// @ts-nocheck

/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Default module
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery,
  useQueryClient,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  MutationFunctionContext,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  AddConnectionToRunningOrderSet200,
  AddFestivalToTalentGrid200,
  AddFestivalToTalentGridBody,
  ApproveBankAccount200,
  AssignArtistToSlot200,
  ClaimTaskResponseType,
  ConfirmPersonJobsRequestType,
  ConfirmPersonJobsResponseType,
  CreateASTFavorite200,
  CreateASTFavoriteRequestType,
  CreateArtist200,
  CreateArtistBankAccount200,
  CreateArtistInTalentGrid200,
  CreateArtistType,
  CreateBankAccountType,
  CreateCompanyBankAccount200,
  CreateCompanyLink200,
  CreateCompanyLinkType,
  CreateCompanyResponseType,
  CreateCompanySiteResponseType,
  CreateCompanySiteType,
  CreateCompanyType,
  CreateFolder200,
  CreateFolderRequestType,
  CreatePersonResponseType,
  CreatePersonType,
  CreateRentalConfigurationType,
  CreateSavedASTRequestType,
  CreateSavedASTResponseType,
  CreateSlot200,
  CreateTalentGrid200,
  CreateTalentGridBody,
  CreateTaskResponseType,
  CreateTaskType,
  CreateVenue200,
  CreateVenueOverviewVersion200,
  CreateVenueOverviewVersionRequestType,
  CreateVenueRentalConfiguration200,
  CreateVenueType,
  DeleteASTFavorite200,
  DeleteArtistInTalentGrid200,
  DeleteBankAccountRequestType,
  DeleteCompanyParams,
  DeleteFestivalFromTalentGrid200,
  DeleteFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId200,
  DeleteResponseType,
  DeleteRunningOrderSet200,
  DeleteSlot200,
  DeleteTalentGrid200,
  FindAllASTEntitiesResponseType,
  FindAllASTEntityValuesResponseType,
  FindAllASTFavoritesParams,
  FindAllASTFavoritesResponseType,
  FindAllArtistsParams,
  FindAllCompaniesParams,
  FindAllDepositsParams,
  FindAllEventsParams,
  FindAllEventsResponseType,
  FindAllPersonsParams,
  FindAllTaskListItemsResponseType,
  FindAllTasksParams,
  FindAllTasksResponseType,
  FindAllTicketSalesASTEntitiesParams,
  FindAllTicketSalesParams,
  FindAllTicketSalesRequestType,
  FindAllTicketSalesResponseType,
  FindAllVenueHoldsParams,
  FindAllVenueOperators200,
  FindAllVenueRentalConfigurationsParams,
  FindAllVenueShowsParams,
  FindAllVenuesParams,
  FindCompanyContactsParams,
  FindCompanyHoldsParams,
  FindCompanyShowsParams,
  FindFinanceProjectList200,
  FindFinanceProjectListParams,
  FindGlobalSearchResultsParams,
  FindPersonJobsListParams,
  FindSavedASTParams,
  FindSavedASTResponseType,
  Get200,
  GetAllTalentGridsResponseType,
  GetArtistGenresResponseType,
  GetArtistListResponseType,
  GetArtistResponseType,
  GetArtistsInTalentGrid200,
  GetCompanyArtistsResponseType,
  GetCompanyContactsResponseType,
  GetCompanyEmailAddressesResponseType,
  GetCompanyEmployeesResponseType,
  GetCompanyHoldsResponseType,
  GetCompanyLinkCategoriesResponseType,
  GetCompanyListResponseType,
  GetCompanyResponseType,
  GetCompanyShowsResponseType,
  GetCompanySitesMinifiedResponseType,
  GetCompanySitesResponseType,
  GetCompanyTagsResponseType,
  GetContractingCompaniesResponseType,
  GetContractingPersonsResponseType,
  GetDepositsResponseType,
  GetFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId200,
  GetFestivalServiceV1TalentGridsGridid200,
  GetGlobalSearchResultsResponseType,
  GetOrganizationUnitsResponseType,
  GetPersonArtistsResponseType,
  GetPersonJobsListResponseType,
  GetPersonResponseType,
  GetPersonSettlementsResponseType,
  GetPersonsListMinifiedResponseType,
  GetPersonsListResponseType,
  GetRunningOrderSets200,
  GetSlots200,
  GetTeamsResponseType,
  GetUsersResponseType,
  GetVenueCategoriesResponseType,
  GetVenueDetailsResponseType,
  GetVenueFBContactsResponseType,
  GetVenueFilesResponseType,
  GetVenueHoldsResponseType,
  GetVenueMerchContactsResponseType,
  GetVenueOverviewVersionResponseType,
  GetVenueOverviewVersionsResponseType,
  GetVenueRentalConfigurationsResponseType,
  GetVenueRentalVersionDatesResponseType,
  GetVenueShowsResponseType,
  GetVenuesListResponseType,
  InitializeUploadRequestType,
  InitializeUploadResponseType,
  MoveFileRequestType,
  PatchFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId200,
  Post200,
  PostFestivalServiceV1TalentGridsGridIdRunningorderSets200,
  PostFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId200,
  RemoveArtistFromSlot200,
  RemoveConnectionFromRunningOrderSet200,
  RenameFileRequestType,
  UpdateArtist200,
  UpdateArtistInTalentGrid200,
  UpdateArtistType,
  UpdateBankAccount200,
  UpdateBankAccountType,
  UpdateCompanyLink200,
  UpdateCompanyLinkType,
  UpdateCompanyResponseType,
  UpdateCompanySiteResponseType,
  UpdateCompanySiteType,
  UpdateCompanyType,
  UpdatePersonResponseType,
  UpdatePersonType,
  UpdateRentalConfigurationType,
  UpdateRentalConfigurationsType,
  UpdateSlot200,
  UpdateTalentGrid200,
  UpdateTalentGridBody,
  UpdateTaskResponseType,
  UpdateTaskType,
  UpdateTicketSales200,
  UpdateTicketSalesParams,
  UpdateTicketSalesRequestType,
  UpdateVenue200,
  UpdateVenueOverviewVersion200,
  UpdateVenueOverviewVersionType,
  UpdateVenueRentalConfiguration200,
  UpdateVenueRentalConfigurations200,
  UpdateVenueType,
  UploadFile200,
  UploadFileRequestType
} from './types';

import { customInstance } from '../../custom-instance';
import type { ErrorType , BodyType } from '../../custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Get Persons List
 */
export const findAllPersons = (
    params?: FindAllPersonsParams,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<GetPersonsListResponseType>(
      {url: `/person-service-v1/persons`, method: 'GET',
        params
    },
      options);
    }




export const getFindAllPersonsQueryKey = (params?: FindAllPersonsParams,) => {
    return [
    'person-service-v1','persons', ...(params ? [params] : [])
    ] as const;
    }


export const getFindAllPersonsQueryOptions = <TData = Awaited<ReturnType<typeof findAllPersons>>, TError = ErrorType<unknown>>(params?: FindAllPersonsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllPersons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllPersonsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllPersons>>> = () => findAllPersons(params, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findAllPersons>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllPersonsQueryResult = NonNullable<Awaited<ReturnType<typeof findAllPersons>>>
export type FindAllPersonsQueryError = ErrorType<unknown>


export function useFindAllPersons<TData = Awaited<ReturnType<typeof findAllPersons>>, TError = ErrorType<unknown>>(
 params: undefined |  FindAllPersonsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllPersons>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllPersons>>,
          TError,
          Awaited<ReturnType<typeof findAllPersons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllPersons<TData = Awaited<ReturnType<typeof findAllPersons>>, TError = ErrorType<unknown>>(
 params?: FindAllPersonsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllPersons>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllPersons>>,
          TError,
          Awaited<ReturnType<typeof findAllPersons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllPersons<TData = Awaited<ReturnType<typeof findAllPersons>>, TError = ErrorType<unknown>>(
 params?: FindAllPersonsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllPersons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Persons List
 */

export function useFindAllPersons<TData = Awaited<ReturnType<typeof findAllPersons>>, TError = ErrorType<unknown>>(
 params?: FindAllPersonsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllPersons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllPersonsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindAllPersonsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findAllPersons>>, TError = ErrorType<unknown>>(params?: FindAllPersonsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllPersons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllPersonsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllPersons>>> = () => findAllPersons(params, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllPersons>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllPersonsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findAllPersons>>>
export type FindAllPersonsSuspenseQueryError = ErrorType<unknown>


export function useFindAllPersonsSuspense<TData = Awaited<ReturnType<typeof findAllPersons>>, TError = ErrorType<unknown>>(
 params: undefined |  FindAllPersonsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllPersons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllPersonsSuspense<TData = Awaited<ReturnType<typeof findAllPersons>>, TError = ErrorType<unknown>>(
 params?: FindAllPersonsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllPersons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllPersonsSuspense<TData = Awaited<ReturnType<typeof findAllPersons>>, TError = ErrorType<unknown>>(
 params?: FindAllPersonsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllPersons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Persons List
 */

export function useFindAllPersonsSuspense<TData = Awaited<ReturnType<typeof findAllPersons>>, TError = ErrorType<unknown>>(
 params?: FindAllPersonsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllPersons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllPersonsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Create Person
 */
export const createPerson = (
    createPersonType?: BodyType<CreatePersonType>,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<CreatePersonResponseType>(
      {url: `/person-service-v1/persons`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPersonType
    },
      options);
    }



export const getCreatePersonMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPerson>>, TError,{data?: BodyType<CreatePersonType>}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createPerson>>, TError,{data?: BodyType<CreatePersonType>}, TContext> => {

const mutationKey = ['createPerson'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPerson>>, {data?: BodyType<CreatePersonType>}> = (props) => {
          const {data} = props ?? {};

          return  createPerson(data,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof createPerson>>, variables: {data?: BodyType<CreatePersonType>}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getFindAllPersonsQueryKey() });
    queryClient.invalidateQueries({ queryKey: getFindPersonsMinifiedQueryKey() });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type CreatePersonMutationResult = NonNullable<Awaited<ReturnType<typeof createPerson>>>
    export type CreatePersonMutationBody = BodyType<CreatePersonType> | undefined
    export type CreatePersonMutationError = ErrorType<unknown>

    /**
 * @summary Create Person
 */
export const useCreatePerson = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPerson>>, TError,{data?: BodyType<CreatePersonType>}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createPerson>>,
        TError,
        {data?: BodyType<CreatePersonType>},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getCreatePersonMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * @summary Get Person Details
 */
export const findPersonDetails = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<GetPersonResponseType>(
      {url: `/person-service-v1/persons/${id}`, method: 'GET'
    },
      options);
    }




export const getFindPersonDetailsQueryKey = (id: string,) => {
    return [
    'person-service-v1','persons',id
    ] as const;
    }


export const getFindPersonDetailsQueryOptions = <TData = Awaited<ReturnType<typeof findPersonDetails>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPersonDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindPersonDetailsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findPersonDetails>>> = () => findPersonDetails(id, requestOptions);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findPersonDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindPersonDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof findPersonDetails>>>
export type FindPersonDetailsQueryError = ErrorType<unknown>


export function useFindPersonDetails<TData = Awaited<ReturnType<typeof findPersonDetails>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPersonDetails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findPersonDetails>>,
          TError,
          Awaited<ReturnType<typeof findPersonDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindPersonDetails<TData = Awaited<ReturnType<typeof findPersonDetails>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPersonDetails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findPersonDetails>>,
          TError,
          Awaited<ReturnType<typeof findPersonDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindPersonDetails<TData = Awaited<ReturnType<typeof findPersonDetails>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPersonDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Person Details
 */

export function useFindPersonDetails<TData = Awaited<ReturnType<typeof findPersonDetails>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPersonDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindPersonDetailsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindPersonDetailsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findPersonDetails>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findPersonDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindPersonDetailsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findPersonDetails>>> = () => findPersonDetails(id, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findPersonDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindPersonDetailsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findPersonDetails>>>
export type FindPersonDetailsSuspenseQueryError = ErrorType<unknown>


export function useFindPersonDetailsSuspense<TData = Awaited<ReturnType<typeof findPersonDetails>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findPersonDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindPersonDetailsSuspense<TData = Awaited<ReturnType<typeof findPersonDetails>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findPersonDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindPersonDetailsSuspense<TData = Awaited<ReturnType<typeof findPersonDetails>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findPersonDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Person Details
 */

export function useFindPersonDetailsSuspense<TData = Awaited<ReturnType<typeof findPersonDetails>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findPersonDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindPersonDetailsSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Delete Person
 */
export const deletePerson = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<DeleteResponseType>(
      {url: `/person-service-v1/persons/${id}`, method: 'DELETE'
    },
      options);
    }



export const getDeletePersonMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePerson>>, TError,{id: string}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePerson>>, TError,{id: string}, TContext> => {

const mutationKey = ['deletePerson'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePerson>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deletePerson(id,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof deletePerson>>, variables: {id: string}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getFindAllPersonsQueryKey() });
    queryClient.invalidateQueries({ queryKey: getFindPersonsMinifiedQueryKey() });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type DeletePersonMutationResult = NonNullable<Awaited<ReturnType<typeof deletePerson>>>

    export type DeletePersonMutationError = ErrorType<unknown>

    /**
 * @summary Delete Person
 */
export const useDeletePerson = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePerson>>, TError,{id: string}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePerson>>,
        TError,
        {id: string},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getDeletePersonMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * @summary Update Person
 */
export const updatePersonPrivateInfo = (
    id: string,
    updatePersonType?: BodyType<UpdatePersonType>,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<UpdatePersonResponseType>(
      {url: `/person-service-v1/persons/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updatePersonType
    },
      options);
    }



export const getUpdatePersonPrivateInfoMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePersonPrivateInfo>>, TError,{id: string;data?: BodyType<UpdatePersonType>}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePersonPrivateInfo>>, TError,{id: string;data?: BodyType<UpdatePersonType>}, TContext> => {

const mutationKey = ['updatePersonPrivateInfo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePersonPrivateInfo>>, {id: string;data?: BodyType<UpdatePersonType>}> = (props) => {
          const {id,data} = props ?? {};

          return  updatePersonPrivateInfo(id,data,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof updatePersonPrivateInfo>>, variables: {id: string;data?: BodyType<UpdatePersonType>}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getFindPersonDetailsQueryKey(variables.id) });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type UpdatePersonPrivateInfoMutationResult = NonNullable<Awaited<ReturnType<typeof updatePersonPrivateInfo>>>
    export type UpdatePersonPrivateInfoMutationBody = BodyType<UpdatePersonType> | undefined
    export type UpdatePersonPrivateInfoMutationError = ErrorType<unknown>

    /**
 * @summary Update Person
 */
export const useUpdatePersonPrivateInfo = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePersonPrivateInfo>>, TError,{id: string;data?: BodyType<UpdatePersonType>}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updatePersonPrivateInfo>>,
        TError,
        {id: string;data?: BodyType<UpdatePersonType>},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getUpdatePersonPrivateInfoMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * @summary Get Persons Minified List
 */
export const findPersonsMinified = (

 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<GetPersonsListMinifiedResponseType>(
      {url: `/person-service-v1/persons-minified`, method: 'GET'
    },
      options);
    }




export const getFindPersonsMinifiedQueryKey = () => {
    return [
    'person-service-v1','persons-minified'
    ] as const;
    }


export const getFindPersonsMinifiedQueryOptions = <TData = Awaited<ReturnType<typeof findPersonsMinified>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPersonsMinified>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindPersonsMinifiedQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findPersonsMinified>>> = () => findPersonsMinified(requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findPersonsMinified>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindPersonsMinifiedQueryResult = NonNullable<Awaited<ReturnType<typeof findPersonsMinified>>>
export type FindPersonsMinifiedQueryError = ErrorType<unknown>


export function useFindPersonsMinified<TData = Awaited<ReturnType<typeof findPersonsMinified>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPersonsMinified>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findPersonsMinified>>,
          TError,
          Awaited<ReturnType<typeof findPersonsMinified>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindPersonsMinified<TData = Awaited<ReturnType<typeof findPersonsMinified>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPersonsMinified>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findPersonsMinified>>,
          TError,
          Awaited<ReturnType<typeof findPersonsMinified>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindPersonsMinified<TData = Awaited<ReturnType<typeof findPersonsMinified>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPersonsMinified>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Persons Minified List
 */

export function useFindPersonsMinified<TData = Awaited<ReturnType<typeof findPersonsMinified>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPersonsMinified>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindPersonsMinifiedQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindPersonsMinifiedSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findPersonsMinified>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findPersonsMinified>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindPersonsMinifiedQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findPersonsMinified>>> = () => findPersonsMinified(requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findPersonsMinified>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindPersonsMinifiedSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findPersonsMinified>>>
export type FindPersonsMinifiedSuspenseQueryError = ErrorType<unknown>


export function useFindPersonsMinifiedSuspense<TData = Awaited<ReturnType<typeof findPersonsMinified>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findPersonsMinified>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindPersonsMinifiedSuspense<TData = Awaited<ReturnType<typeof findPersonsMinified>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findPersonsMinified>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindPersonsMinifiedSuspense<TData = Awaited<ReturnType<typeof findPersonsMinified>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findPersonsMinified>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Persons Minified List
 */

export function useFindPersonsMinifiedSuspense<TData = Awaited<ReturnType<typeof findPersonsMinified>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findPersonsMinified>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindPersonsMinifiedSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Get Person Settlements
 */
export const findPersonSettlements = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<GetPersonSettlementsResponseType>(
      {url: `/person-service-v1/persons/${id}/settlements`, method: 'GET'
    },
      options);
    }




export const getFindPersonSettlementsQueryKey = (id: string,) => {
    return [
    'person-service-v1','persons',id,'settlements'
    ] as const;
    }


export const getFindPersonSettlementsQueryOptions = <TData = Awaited<ReturnType<typeof findPersonSettlements>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPersonSettlements>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindPersonSettlementsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findPersonSettlements>>> = () => findPersonSettlements(id, requestOptions);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findPersonSettlements>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindPersonSettlementsQueryResult = NonNullable<Awaited<ReturnType<typeof findPersonSettlements>>>
export type FindPersonSettlementsQueryError = ErrorType<unknown>


export function useFindPersonSettlements<TData = Awaited<ReturnType<typeof findPersonSettlements>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPersonSettlements>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findPersonSettlements>>,
          TError,
          Awaited<ReturnType<typeof findPersonSettlements>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindPersonSettlements<TData = Awaited<ReturnType<typeof findPersonSettlements>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPersonSettlements>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findPersonSettlements>>,
          TError,
          Awaited<ReturnType<typeof findPersonSettlements>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindPersonSettlements<TData = Awaited<ReturnType<typeof findPersonSettlements>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPersonSettlements>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Person Settlements
 */

export function useFindPersonSettlements<TData = Awaited<ReturnType<typeof findPersonSettlements>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPersonSettlements>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindPersonSettlementsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindPersonSettlementsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findPersonSettlements>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findPersonSettlements>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindPersonSettlementsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findPersonSettlements>>> = () => findPersonSettlements(id, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findPersonSettlements>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindPersonSettlementsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findPersonSettlements>>>
export type FindPersonSettlementsSuspenseQueryError = ErrorType<unknown>


export function useFindPersonSettlementsSuspense<TData = Awaited<ReturnType<typeof findPersonSettlements>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findPersonSettlements>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindPersonSettlementsSuspense<TData = Awaited<ReturnType<typeof findPersonSettlements>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findPersonSettlements>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindPersonSettlementsSuspense<TData = Awaited<ReturnType<typeof findPersonSettlements>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findPersonSettlements>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Person Settlements
 */

export function useFindPersonSettlementsSuspense<TData = Awaited<ReturnType<typeof findPersonSettlements>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findPersonSettlements>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindPersonSettlementsSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Create Company-Link
 */
export const createCompanyLink = (
    createCompanyLinkType?: BodyType<CreateCompanyLinkType>,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<CreateCompanyLink200>(
      {url: `/person-service-v1/company-links`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createCompanyLinkType
    },
      options);
    }



export const getCreateCompanyLinkMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCompanyLink>>, TError,{data?: BodyType<CreateCompanyLinkType>}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createCompanyLink>>, TError,{data?: BodyType<CreateCompanyLinkType>}, TContext> => {

const mutationKey = ['createCompanyLink'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCompanyLink>>, {data?: BodyType<CreateCompanyLinkType>}> = (props) => {
          const {data} = props ?? {};

          return  createCompanyLink(data,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof createCompanyLink>>, variables: {data?: BodyType<CreateCompanyLinkType>}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getFindAllCompaniesQueryKey() });
    queryClient.invalidateQueries({ queryKey: getFindAllPersonsQueryKey() });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type CreateCompanyLinkMutationResult = NonNullable<Awaited<ReturnType<typeof createCompanyLink>>>
    export type CreateCompanyLinkMutationBody = BodyType<CreateCompanyLinkType> | undefined
    export type CreateCompanyLinkMutationError = ErrorType<unknown>

    /**
 * @summary Create Company-Link
 */
export const useCreateCompanyLink = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCompanyLink>>, TError,{data?: BodyType<CreateCompanyLinkType>}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createCompanyLink>>,
        TError,
        {data?: BodyType<CreateCompanyLinkType>},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getCreateCompanyLinkMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * @summary Update Company-Link
 */
export const updateCompanyLink = (
    companyLinkId: string,
    updateCompanyLinkType?: BodyType<UpdateCompanyLinkType>,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<UpdateCompanyLink200>(
      {url: `/person-service-v1/company-links/${companyLinkId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateCompanyLinkType
    },
      options);
    }



export const getUpdateCompanyLinkMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCompanyLink>>, TError,{companyLinkId: string;data?: BodyType<UpdateCompanyLinkType>}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCompanyLink>>, TError,{companyLinkId: string;data?: BodyType<UpdateCompanyLinkType>}, TContext> => {

const mutationKey = ['updateCompanyLink'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCompanyLink>>, {companyLinkId: string;data?: BodyType<UpdateCompanyLinkType>}> = (props) => {
          const {companyLinkId,data} = props ?? {};

          return  updateCompanyLink(companyLinkId,data,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof updateCompanyLink>>, variables: {companyLinkId: string;data?: BodyType<UpdateCompanyLinkType>}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getFindAllCompaniesQueryKey() });
    queryClient.invalidateQueries({ queryKey: getFindAllPersonsQueryKey() });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type UpdateCompanyLinkMutationResult = NonNullable<Awaited<ReturnType<typeof updateCompanyLink>>>
    export type UpdateCompanyLinkMutationBody = BodyType<UpdateCompanyLinkType> | undefined
    export type UpdateCompanyLinkMutationError = ErrorType<unknown>

    /**
 * @summary Update Company-Link
 */
export const useUpdateCompanyLink = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCompanyLink>>, TError,{companyLinkId: string;data?: BodyType<UpdateCompanyLinkType>}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateCompanyLink>>,
        TError,
        {companyLinkId: string;data?: BodyType<UpdateCompanyLinkType>},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getUpdateCompanyLinkMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * @summary Delete Company-Link
 */
export const deleteCompanyLink = (
    companyLinkId: string,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<DeleteResponseType>(
      {url: `/person-service-v1/company-links/${companyLinkId}`, method: 'DELETE'
    },
      options);
    }



export const getDeleteCompanyLinkMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCompanyLink>>, TError,{companyLinkId: string}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCompanyLink>>, TError,{companyLinkId: string}, TContext> => {

const mutationKey = ['deleteCompanyLink'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCompanyLink>>, {companyLinkId: string}> = (props) => {
          const {companyLinkId} = props ?? {};

          return  deleteCompanyLink(companyLinkId,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof deleteCompanyLink>>, variables: {companyLinkId: string}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getFindAllCompaniesQueryKey() });
    queryClient.invalidateQueries({ queryKey: getFindAllPersonsQueryKey() });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type DeleteCompanyLinkMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCompanyLink>>>

    export type DeleteCompanyLinkMutationError = ErrorType<unknown>

    /**
 * @summary Delete Company-Link
 */
export const useDeleteCompanyLink = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCompanyLink>>, TError,{companyLinkId: string}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCompanyLink>>,
        TError,
        {companyLinkId: string},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getDeleteCompanyLinkMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * @summary Get Person Artists
 */
export const findPersonArtists = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<GetPersonArtistsResponseType>(
      {url: `/person-service-v1/persons/${id}/artists`, method: 'GET'
    },
      options);
    }




export const getFindPersonArtistsQueryKey = (id: string,) => {
    return [
    'person-service-v1','persons',id,'artists'
    ] as const;
    }


export const getFindPersonArtistsQueryOptions = <TData = Awaited<ReturnType<typeof findPersonArtists>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPersonArtists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindPersonArtistsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findPersonArtists>>> = () => findPersonArtists(id, requestOptions);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findPersonArtists>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindPersonArtistsQueryResult = NonNullable<Awaited<ReturnType<typeof findPersonArtists>>>
export type FindPersonArtistsQueryError = ErrorType<unknown>


export function useFindPersonArtists<TData = Awaited<ReturnType<typeof findPersonArtists>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPersonArtists>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findPersonArtists>>,
          TError,
          Awaited<ReturnType<typeof findPersonArtists>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindPersonArtists<TData = Awaited<ReturnType<typeof findPersonArtists>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPersonArtists>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findPersonArtists>>,
          TError,
          Awaited<ReturnType<typeof findPersonArtists>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindPersonArtists<TData = Awaited<ReturnType<typeof findPersonArtists>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPersonArtists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Person Artists
 */

export function useFindPersonArtists<TData = Awaited<ReturnType<typeof findPersonArtists>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPersonArtists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindPersonArtistsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindPersonArtistsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findPersonArtists>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findPersonArtists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindPersonArtistsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findPersonArtists>>> = () => findPersonArtists(id, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findPersonArtists>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindPersonArtistsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findPersonArtists>>>
export type FindPersonArtistsSuspenseQueryError = ErrorType<unknown>


export function useFindPersonArtistsSuspense<TData = Awaited<ReturnType<typeof findPersonArtists>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findPersonArtists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindPersonArtistsSuspense<TData = Awaited<ReturnType<typeof findPersonArtists>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findPersonArtists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindPersonArtistsSuspense<TData = Awaited<ReturnType<typeof findPersonArtists>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findPersonArtists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Person Artists
 */

export function useFindPersonArtistsSuspense<TData = Awaited<ReturnType<typeof findPersonArtists>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findPersonArtists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindPersonArtistsSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Get Company Link Categories
 */
export const findCompanyLinkCategories = (

 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<GetCompanyLinkCategoriesResponseType>(
      {url: `/person-service-v1/company-link-categories`, method: 'GET'
    },
      options);
    }




export const getFindCompanyLinkCategoriesQueryKey = () => {
    return [
    'person-service-v1','company-link-categories'
    ] as const;
    }


export const getFindCompanyLinkCategoriesQueryOptions = <TData = Awaited<ReturnType<typeof findCompanyLinkCategories>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanyLinkCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindCompanyLinkCategoriesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findCompanyLinkCategories>>> = () => findCompanyLinkCategories(requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findCompanyLinkCategories>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindCompanyLinkCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof findCompanyLinkCategories>>>
export type FindCompanyLinkCategoriesQueryError = ErrorType<unknown>


export function useFindCompanyLinkCategories<TData = Awaited<ReturnType<typeof findCompanyLinkCategories>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanyLinkCategories>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findCompanyLinkCategories>>,
          TError,
          Awaited<ReturnType<typeof findCompanyLinkCategories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindCompanyLinkCategories<TData = Awaited<ReturnType<typeof findCompanyLinkCategories>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanyLinkCategories>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findCompanyLinkCategories>>,
          TError,
          Awaited<ReturnType<typeof findCompanyLinkCategories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindCompanyLinkCategories<TData = Awaited<ReturnType<typeof findCompanyLinkCategories>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanyLinkCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Company Link Categories
 */

export function useFindCompanyLinkCategories<TData = Awaited<ReturnType<typeof findCompanyLinkCategories>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanyLinkCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindCompanyLinkCategoriesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindCompanyLinkCategoriesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findCompanyLinkCategories>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanyLinkCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindCompanyLinkCategoriesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findCompanyLinkCategories>>> = () => findCompanyLinkCategories(requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanyLinkCategories>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindCompanyLinkCategoriesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findCompanyLinkCategories>>>
export type FindCompanyLinkCategoriesSuspenseQueryError = ErrorType<unknown>


export function useFindCompanyLinkCategoriesSuspense<TData = Awaited<ReturnType<typeof findCompanyLinkCategories>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanyLinkCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindCompanyLinkCategoriesSuspense<TData = Awaited<ReturnType<typeof findCompanyLinkCategories>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanyLinkCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindCompanyLinkCategoriesSuspense<TData = Awaited<ReturnType<typeof findCompanyLinkCategories>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanyLinkCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Company Link Categories
 */

export function useFindCompanyLinkCategoriesSuspense<TData = Awaited<ReturnType<typeof findCompanyLinkCategories>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanyLinkCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindCompanyLinkCategoriesSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Get Person Jobs List
 */
export const findPersonJobsList = (
    id: string,
    params: FindPersonJobsListParams,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<GetPersonJobsListResponseType>(
      {url: `/person-service-v1/persons/${id}/jobs`, method: 'GET',
        params
    },
      options);
    }




export const getFindPersonJobsListQueryKey = (id: string,
    params?: FindPersonJobsListParams,) => {
    return [
    'person-service-v1','persons',id,'jobs', ...(params ? [params] : [])
    ] as const;
    }


export const getFindPersonJobsListQueryOptions = <TData = Awaited<ReturnType<typeof findPersonJobsList>>, TError = ErrorType<unknown>>(id: string,
    params: FindPersonJobsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPersonJobsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindPersonJobsListQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findPersonJobsList>>> = () => findPersonJobsList(id,params, requestOptions);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findPersonJobsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindPersonJobsListQueryResult = NonNullable<Awaited<ReturnType<typeof findPersonJobsList>>>
export type FindPersonJobsListQueryError = ErrorType<unknown>


export function useFindPersonJobsList<TData = Awaited<ReturnType<typeof findPersonJobsList>>, TError = ErrorType<unknown>>(
 id: string,
    params: FindPersonJobsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPersonJobsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findPersonJobsList>>,
          TError,
          Awaited<ReturnType<typeof findPersonJobsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindPersonJobsList<TData = Awaited<ReturnType<typeof findPersonJobsList>>, TError = ErrorType<unknown>>(
 id: string,
    params: FindPersonJobsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPersonJobsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findPersonJobsList>>,
          TError,
          Awaited<ReturnType<typeof findPersonJobsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindPersonJobsList<TData = Awaited<ReturnType<typeof findPersonJobsList>>, TError = ErrorType<unknown>>(
 id: string,
    params: FindPersonJobsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPersonJobsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Person Jobs List
 */

export function useFindPersonJobsList<TData = Awaited<ReturnType<typeof findPersonJobsList>>, TError = ErrorType<unknown>>(
 id: string,
    params: FindPersonJobsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPersonJobsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindPersonJobsListQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindPersonJobsListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findPersonJobsList>>, TError = ErrorType<unknown>>(id: string,
    params: FindPersonJobsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findPersonJobsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindPersonJobsListQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findPersonJobsList>>> = () => findPersonJobsList(id,params, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findPersonJobsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindPersonJobsListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findPersonJobsList>>>
export type FindPersonJobsListSuspenseQueryError = ErrorType<unknown>


export function useFindPersonJobsListSuspense<TData = Awaited<ReturnType<typeof findPersonJobsList>>, TError = ErrorType<unknown>>(
 id: string,
    params: FindPersonJobsListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findPersonJobsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindPersonJobsListSuspense<TData = Awaited<ReturnType<typeof findPersonJobsList>>, TError = ErrorType<unknown>>(
 id: string,
    params: FindPersonJobsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findPersonJobsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindPersonJobsListSuspense<TData = Awaited<ReturnType<typeof findPersonJobsList>>, TError = ErrorType<unknown>>(
 id: string,
    params: FindPersonJobsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findPersonJobsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Person Jobs List
 */

export function useFindPersonJobsListSuspense<TData = Awaited<ReturnType<typeof findPersonJobsList>>, TError = ErrorType<unknown>>(
 id: string,
    params: FindPersonJobsListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findPersonJobsList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindPersonJobsListSuspenseQueryOptions(id,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Confirm Person Jobs
 */
export const confirmPersonJobs = (
    id: string,
    confirmPersonJobsRequestType?: BodyType<ConfirmPersonJobsRequestType>,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<ConfirmPersonJobsResponseType>(
      {url: `/person-service-v1/persons/${id}/jobs`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: confirmPersonJobsRequestType
    },
      options);
    }



export const getConfirmPersonJobsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmPersonJobs>>, TError,{id: string;data?: BodyType<ConfirmPersonJobsRequestType>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof confirmPersonJobs>>, TError,{id: string;data?: BodyType<ConfirmPersonJobsRequestType>}, TContext> => {

const mutationKey = ['confirmPersonJobs'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmPersonJobs>>, {id: string;data?: BodyType<ConfirmPersonJobsRequestType>}> = (props) => {
          const {id,data} = props ?? {};

          return  confirmPersonJobs(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfirmPersonJobsMutationResult = NonNullable<Awaited<ReturnType<typeof confirmPersonJobs>>>
    export type ConfirmPersonJobsMutationBody = BodyType<ConfirmPersonJobsRequestType> | undefined
    export type ConfirmPersonJobsMutationError = ErrorType<unknown>

    /**
 * @summary Confirm Person Jobs
 */
export const useConfirmPersonJobs = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmPersonJobs>>, TError,{id: string;data?: BodyType<ConfirmPersonJobsRequestType>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof confirmPersonJobs>>,
        TError,
        {id: string;data?: BodyType<ConfirmPersonJobsRequestType>},
        TContext
      > => {
      return useMutation(getConfirmPersonJobsMutationOptions(options), queryClient);
    }

/**
 * @summary Get Person Assignable Users
 */
export const findPersonAssignableUsers = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<GetUsersResponseType>(
      {url: `/person-service-v1/persons/${id}/assignable-users`, method: 'GET'
    },
      options);
    }




export const getFindPersonAssignableUsersQueryKey = (id: string,) => {
    return [
    'person-service-v1','persons',id,'assignable-users'
    ] as const;
    }


export const getFindPersonAssignableUsersQueryOptions = <TData = Awaited<ReturnType<typeof findPersonAssignableUsers>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPersonAssignableUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindPersonAssignableUsersQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findPersonAssignableUsers>>> = () => findPersonAssignableUsers(id, requestOptions);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findPersonAssignableUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindPersonAssignableUsersQueryResult = NonNullable<Awaited<ReturnType<typeof findPersonAssignableUsers>>>
export type FindPersonAssignableUsersQueryError = ErrorType<unknown>


export function useFindPersonAssignableUsers<TData = Awaited<ReturnType<typeof findPersonAssignableUsers>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPersonAssignableUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findPersonAssignableUsers>>,
          TError,
          Awaited<ReturnType<typeof findPersonAssignableUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindPersonAssignableUsers<TData = Awaited<ReturnType<typeof findPersonAssignableUsers>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPersonAssignableUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findPersonAssignableUsers>>,
          TError,
          Awaited<ReturnType<typeof findPersonAssignableUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindPersonAssignableUsers<TData = Awaited<ReturnType<typeof findPersonAssignableUsers>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPersonAssignableUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Person Assignable Users
 */

export function useFindPersonAssignableUsers<TData = Awaited<ReturnType<typeof findPersonAssignableUsers>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findPersonAssignableUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindPersonAssignableUsersQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindPersonAssignableUsersSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findPersonAssignableUsers>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findPersonAssignableUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindPersonAssignableUsersQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findPersonAssignableUsers>>> = () => findPersonAssignableUsers(id, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findPersonAssignableUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindPersonAssignableUsersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findPersonAssignableUsers>>>
export type FindPersonAssignableUsersSuspenseQueryError = ErrorType<unknown>


export function useFindPersonAssignableUsersSuspense<TData = Awaited<ReturnType<typeof findPersonAssignableUsers>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findPersonAssignableUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindPersonAssignableUsersSuspense<TData = Awaited<ReturnType<typeof findPersonAssignableUsers>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findPersonAssignableUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindPersonAssignableUsersSuspense<TData = Awaited<ReturnType<typeof findPersonAssignableUsers>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findPersonAssignableUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Person Assignable Users
 */

export function useFindPersonAssignableUsersSuspense<TData = Awaited<ReturnType<typeof findPersonAssignableUsers>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findPersonAssignableUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindPersonAssignableUsersSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Get Company Contacts
 */
export const findCompanyContacts = (
    params: FindCompanyContactsParams,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<GetCompanyContactsResponseType>(
      {url: `/person-service-v1/company-contacts`, method: 'GET',
        params
    },
      options);
    }




export const getFindCompanyContactsQueryKey = (params?: FindCompanyContactsParams,) => {
    return [
    'person-service-v1','company-contacts', ...(params ? [params] : [])
    ] as const;
    }


export const getFindCompanyContactsQueryOptions = <TData = Awaited<ReturnType<typeof findCompanyContacts>>, TError = ErrorType<unknown>>(params: FindCompanyContactsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanyContacts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindCompanyContactsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findCompanyContacts>>> = () => findCompanyContacts(params, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findCompanyContacts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindCompanyContactsQueryResult = NonNullable<Awaited<ReturnType<typeof findCompanyContacts>>>
export type FindCompanyContactsQueryError = ErrorType<unknown>


export function useFindCompanyContacts<TData = Awaited<ReturnType<typeof findCompanyContacts>>, TError = ErrorType<unknown>>(
 params: FindCompanyContactsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanyContacts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findCompanyContacts>>,
          TError,
          Awaited<ReturnType<typeof findCompanyContacts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindCompanyContacts<TData = Awaited<ReturnType<typeof findCompanyContacts>>, TError = ErrorType<unknown>>(
 params: FindCompanyContactsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanyContacts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findCompanyContacts>>,
          TError,
          Awaited<ReturnType<typeof findCompanyContacts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindCompanyContacts<TData = Awaited<ReturnType<typeof findCompanyContacts>>, TError = ErrorType<unknown>>(
 params: FindCompanyContactsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanyContacts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Company Contacts
 */

export function useFindCompanyContacts<TData = Awaited<ReturnType<typeof findCompanyContacts>>, TError = ErrorType<unknown>>(
 params: FindCompanyContactsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanyContacts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindCompanyContactsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindCompanyContactsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findCompanyContacts>>, TError = ErrorType<unknown>>(params: FindCompanyContactsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanyContacts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindCompanyContactsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findCompanyContacts>>> = () => findCompanyContacts(params, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanyContacts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindCompanyContactsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findCompanyContacts>>>
export type FindCompanyContactsSuspenseQueryError = ErrorType<unknown>


export function useFindCompanyContactsSuspense<TData = Awaited<ReturnType<typeof findCompanyContacts>>, TError = ErrorType<unknown>>(
 params: FindCompanyContactsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanyContacts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindCompanyContactsSuspense<TData = Awaited<ReturnType<typeof findCompanyContacts>>, TError = ErrorType<unknown>>(
 params: FindCompanyContactsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanyContacts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindCompanyContactsSuspense<TData = Awaited<ReturnType<typeof findCompanyContacts>>, TError = ErrorType<unknown>>(
 params: FindCompanyContactsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanyContacts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Company Contacts
 */

export function useFindCompanyContactsSuspense<TData = Awaited<ReturnType<typeof findCompanyContacts>>, TError = ErrorType<unknown>>(
 params: FindCompanyContactsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanyContacts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindCompanyContactsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Get Global-Search Results
 */
export const findGlobalSearchResults = (
    params: FindGlobalSearchResultsParams,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<GetGlobalSearchResultsResponseType>(
      {url: `/globalsearch-service-v1/search`, method: 'GET',
        params
    },
      options);
    }




export const getFindGlobalSearchResultsQueryKey = (params?: FindGlobalSearchResultsParams,) => {
    return [
    'globalsearch-service-v1','search', ...(params ? [params] : [])
    ] as const;
    }


export const getFindGlobalSearchResultsQueryOptions = <TData = Awaited<ReturnType<typeof findGlobalSearchResults>>, TError = ErrorType<unknown>>(params: FindGlobalSearchResultsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findGlobalSearchResults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindGlobalSearchResultsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findGlobalSearchResults>>> = () => findGlobalSearchResults(params, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findGlobalSearchResults>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindGlobalSearchResultsQueryResult = NonNullable<Awaited<ReturnType<typeof findGlobalSearchResults>>>
export type FindGlobalSearchResultsQueryError = ErrorType<unknown>


export function useFindGlobalSearchResults<TData = Awaited<ReturnType<typeof findGlobalSearchResults>>, TError = ErrorType<unknown>>(
 params: FindGlobalSearchResultsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findGlobalSearchResults>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findGlobalSearchResults>>,
          TError,
          Awaited<ReturnType<typeof findGlobalSearchResults>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindGlobalSearchResults<TData = Awaited<ReturnType<typeof findGlobalSearchResults>>, TError = ErrorType<unknown>>(
 params: FindGlobalSearchResultsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findGlobalSearchResults>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findGlobalSearchResults>>,
          TError,
          Awaited<ReturnType<typeof findGlobalSearchResults>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindGlobalSearchResults<TData = Awaited<ReturnType<typeof findGlobalSearchResults>>, TError = ErrorType<unknown>>(
 params: FindGlobalSearchResultsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findGlobalSearchResults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Global-Search Results
 */

export function useFindGlobalSearchResults<TData = Awaited<ReturnType<typeof findGlobalSearchResults>>, TError = ErrorType<unknown>>(
 params: FindGlobalSearchResultsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findGlobalSearchResults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindGlobalSearchResultsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindGlobalSearchResultsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findGlobalSearchResults>>, TError = ErrorType<unknown>>(params: FindGlobalSearchResultsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findGlobalSearchResults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindGlobalSearchResultsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findGlobalSearchResults>>> = () => findGlobalSearchResults(params, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findGlobalSearchResults>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindGlobalSearchResultsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findGlobalSearchResults>>>
export type FindGlobalSearchResultsSuspenseQueryError = ErrorType<unknown>


export function useFindGlobalSearchResultsSuspense<TData = Awaited<ReturnType<typeof findGlobalSearchResults>>, TError = ErrorType<unknown>>(
 params: FindGlobalSearchResultsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findGlobalSearchResults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindGlobalSearchResultsSuspense<TData = Awaited<ReturnType<typeof findGlobalSearchResults>>, TError = ErrorType<unknown>>(
 params: FindGlobalSearchResultsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findGlobalSearchResults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindGlobalSearchResultsSuspense<TData = Awaited<ReturnType<typeof findGlobalSearchResults>>, TError = ErrorType<unknown>>(
 params: FindGlobalSearchResultsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findGlobalSearchResults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Global-Search Results
 */

export function useFindGlobalSearchResultsSuspense<TData = Awaited<ReturnType<typeof findGlobalSearchResults>>, TError = ErrorType<unknown>>(
 params: FindGlobalSearchResultsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findGlobalSearchResults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindGlobalSearchResultsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Get Finance Project List
 */
export const findFinanceProjectList = (
    params?: FindFinanceProjectListParams,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<FindFinanceProjectList200>(
      {url: `/finance-service-v1/projectlist`, method: 'GET',
        params
    },
      options);
    }




export const getFindFinanceProjectListQueryKey = (params?: FindFinanceProjectListParams,) => {
    return [
    'finance-service-v1','projectlist', ...(params ? [params] : [])
    ] as const;
    }


export const getFindFinanceProjectListQueryOptions = <TData = Awaited<ReturnType<typeof findFinanceProjectList>>, TError = ErrorType<unknown>>(params?: FindFinanceProjectListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findFinanceProjectList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindFinanceProjectListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findFinanceProjectList>>> = () => findFinanceProjectList(params, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findFinanceProjectList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindFinanceProjectListQueryResult = NonNullable<Awaited<ReturnType<typeof findFinanceProjectList>>>
export type FindFinanceProjectListQueryError = ErrorType<unknown>


export function useFindFinanceProjectList<TData = Awaited<ReturnType<typeof findFinanceProjectList>>, TError = ErrorType<unknown>>(
 params: undefined |  FindFinanceProjectListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findFinanceProjectList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findFinanceProjectList>>,
          TError,
          Awaited<ReturnType<typeof findFinanceProjectList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindFinanceProjectList<TData = Awaited<ReturnType<typeof findFinanceProjectList>>, TError = ErrorType<unknown>>(
 params?: FindFinanceProjectListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findFinanceProjectList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findFinanceProjectList>>,
          TError,
          Awaited<ReturnType<typeof findFinanceProjectList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindFinanceProjectList<TData = Awaited<ReturnType<typeof findFinanceProjectList>>, TError = ErrorType<unknown>>(
 params?: FindFinanceProjectListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findFinanceProjectList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Finance Project List
 */

export function useFindFinanceProjectList<TData = Awaited<ReturnType<typeof findFinanceProjectList>>, TError = ErrorType<unknown>>(
 params?: FindFinanceProjectListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findFinanceProjectList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindFinanceProjectListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindFinanceProjectListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findFinanceProjectList>>, TError = ErrorType<unknown>>(params?: FindFinanceProjectListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findFinanceProjectList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindFinanceProjectListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findFinanceProjectList>>> = () => findFinanceProjectList(params, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findFinanceProjectList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindFinanceProjectListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findFinanceProjectList>>>
export type FindFinanceProjectListSuspenseQueryError = ErrorType<unknown>


export function useFindFinanceProjectListSuspense<TData = Awaited<ReturnType<typeof findFinanceProjectList>>, TError = ErrorType<unknown>>(
 params: undefined |  FindFinanceProjectListParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findFinanceProjectList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindFinanceProjectListSuspense<TData = Awaited<ReturnType<typeof findFinanceProjectList>>, TError = ErrorType<unknown>>(
 params?: FindFinanceProjectListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findFinanceProjectList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindFinanceProjectListSuspense<TData = Awaited<ReturnType<typeof findFinanceProjectList>>, TError = ErrorType<unknown>>(
 params?: FindFinanceProjectListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findFinanceProjectList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Finance Project List
 */

export function useFindFinanceProjectListSuspense<TData = Awaited<ReturnType<typeof findFinanceProjectList>>, TError = ErrorType<unknown>>(
 params?: FindFinanceProjectListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findFinanceProjectList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindFinanceProjectListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Get Deposits
 */
export const findAllDeposits = (
    params?: FindAllDepositsParams,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<GetDepositsResponseType>(
      {url: `/finance-service-v1/deposits`, method: 'GET',
        params
    },
      options);
    }




export const getFindAllDepositsQueryKey = (params?: FindAllDepositsParams,) => {
    return [
    'finance-service-v1','deposits', ...(params ? [params] : [])
    ] as const;
    }


export const getFindAllDepositsQueryOptions = <TData = Awaited<ReturnType<typeof findAllDeposits>>, TError = ErrorType<unknown>>(params?: FindAllDepositsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllDeposits>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllDepositsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllDeposits>>> = () => findAllDeposits(params, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findAllDeposits>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllDepositsQueryResult = NonNullable<Awaited<ReturnType<typeof findAllDeposits>>>
export type FindAllDepositsQueryError = ErrorType<unknown>


export function useFindAllDeposits<TData = Awaited<ReturnType<typeof findAllDeposits>>, TError = ErrorType<unknown>>(
 params: undefined |  FindAllDepositsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllDeposits>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllDeposits>>,
          TError,
          Awaited<ReturnType<typeof findAllDeposits>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllDeposits<TData = Awaited<ReturnType<typeof findAllDeposits>>, TError = ErrorType<unknown>>(
 params?: FindAllDepositsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllDeposits>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllDeposits>>,
          TError,
          Awaited<ReturnType<typeof findAllDeposits>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllDeposits<TData = Awaited<ReturnType<typeof findAllDeposits>>, TError = ErrorType<unknown>>(
 params?: FindAllDepositsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllDeposits>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Deposits
 */

export function useFindAllDeposits<TData = Awaited<ReturnType<typeof findAllDeposits>>, TError = ErrorType<unknown>>(
 params?: FindAllDepositsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllDeposits>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllDepositsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindAllDepositsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findAllDeposits>>, TError = ErrorType<unknown>>(params?: FindAllDepositsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllDeposits>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllDepositsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllDeposits>>> = () => findAllDeposits(params, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllDeposits>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllDepositsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findAllDeposits>>>
export type FindAllDepositsSuspenseQueryError = ErrorType<unknown>


export function useFindAllDepositsSuspense<TData = Awaited<ReturnType<typeof findAllDeposits>>, TError = ErrorType<unknown>>(
 params: undefined |  FindAllDepositsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllDeposits>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllDepositsSuspense<TData = Awaited<ReturnType<typeof findAllDeposits>>, TError = ErrorType<unknown>>(
 params?: FindAllDepositsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllDeposits>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllDepositsSuspense<TData = Awaited<ReturnType<typeof findAllDeposits>>, TError = ErrorType<unknown>>(
 params?: FindAllDepositsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllDeposits>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Deposits
 */

export function useFindAllDepositsSuspense<TData = Awaited<ReturnType<typeof findAllDeposits>>, TError = ErrorType<unknown>>(
 params?: FindAllDepositsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllDeposits>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllDepositsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Get All Talent Grids
 */
export const getTalentGrids = (

 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<GetAllTalentGridsResponseType>(
      {url: `/festival-service-v1/talent-grids`, method: 'GET'
    },
      options);
    }




export const getGetTalentGridsQueryKey = () => {
    return [
    'festival-service-v1','talent-grids'
    ] as const;
    }


export const getGetTalentGridsQueryOptions = <TData = Awaited<ReturnType<typeof getTalentGrids>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTalentGrids>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTalentGridsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTalentGrids>>> = () => getTalentGrids(requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTalentGrids>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTalentGridsQueryResult = NonNullable<Awaited<ReturnType<typeof getTalentGrids>>>
export type GetTalentGridsQueryError = ErrorType<unknown>


export function useGetTalentGrids<TData = Awaited<ReturnType<typeof getTalentGrids>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTalentGrids>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTalentGrids>>,
          TError,
          Awaited<ReturnType<typeof getTalentGrids>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTalentGrids<TData = Awaited<ReturnType<typeof getTalentGrids>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTalentGrids>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTalentGrids>>,
          TError,
          Awaited<ReturnType<typeof getTalentGrids>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTalentGrids<TData = Awaited<ReturnType<typeof getTalentGrids>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTalentGrids>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get All Talent Grids
 */

export function useGetTalentGrids<TData = Awaited<ReturnType<typeof getTalentGrids>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTalentGrids>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTalentGridsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetTalentGridsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getTalentGrids>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTalentGrids>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTalentGridsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTalentGrids>>> = () => getTalentGrids(requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTalentGrids>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTalentGridsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getTalentGrids>>>
export type GetTalentGridsSuspenseQueryError = ErrorType<unknown>


export function useGetTalentGridsSuspense<TData = Awaited<ReturnType<typeof getTalentGrids>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTalentGrids>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTalentGridsSuspense<TData = Awaited<ReturnType<typeof getTalentGrids>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTalentGrids>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTalentGridsSuspense<TData = Awaited<ReturnType<typeof getTalentGrids>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTalentGrids>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get All Talent Grids
 */

export function useGetTalentGridsSuspense<TData = Awaited<ReturnType<typeof getTalentGrids>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTalentGrids>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTalentGridsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Create Talent Grid
 */
export const createTalentGrid = (
    createTalentGridBody?: BodyType<CreateTalentGridBody>,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<CreateTalentGrid200>(
      {url: `/festival-service-v1/talent-grids`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createTalentGridBody
    },
      options);
    }



export const getCreateTalentGridMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTalentGrid>>, TError,{data?: BodyType<CreateTalentGridBody>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createTalentGrid>>, TError,{data?: BodyType<CreateTalentGridBody>}, TContext> => {

const mutationKey = ['createTalentGrid'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTalentGrid>>, {data?: BodyType<CreateTalentGridBody>}> = (props) => {
          const {data} = props ?? {};

          return  createTalentGrid(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTalentGridMutationResult = NonNullable<Awaited<ReturnType<typeof createTalentGrid>>>
    export type CreateTalentGridMutationBody = BodyType<CreateTalentGridBody> | undefined
    export type CreateTalentGridMutationError = ErrorType<unknown>

    /**
 * @summary Create Talent Grid
 */
export const useCreateTalentGrid = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTalentGrid>>, TError,{data?: BodyType<CreateTalentGridBody>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createTalentGrid>>,
        TError,
        {data?: BodyType<CreateTalentGridBody>},
        TContext
      > => {
      return useMutation(getCreateTalentGridMutationOptions(options), queryClient);
    }

/**
 * @summary Get Talent Grid
 */
export const getFestivalServiceV1TalentGridsGridid = (
    gridid: string,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<GetFestivalServiceV1TalentGridsGridid200>(
      {url: `/festival-service-v1/talent-grids/${gridid}`, method: 'GET'
    },
      options);
    }




export const getGetFestivalServiceV1TalentGridsGrididQueryKey = (gridid: string,) => {
    return [
    'festival-service-v1','talent-grids',gridid
    ] as const;
    }


export const getGetFestivalServiceV1TalentGridsGrididQueryOptions = <TData = Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridid>>, TError = ErrorType<unknown>>(gridid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridid>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFestivalServiceV1TalentGridsGrididQueryKey(gridid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridid>>> = () => getFestivalServiceV1TalentGridsGridid(gridid, requestOptions);





   return  { queryKey, queryFn, enabled: gridid !== null && gridid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridid>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFestivalServiceV1TalentGridsGrididQueryResult = NonNullable<Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridid>>>
export type GetFestivalServiceV1TalentGridsGrididQueryError = ErrorType<unknown>


export function useGetFestivalServiceV1TalentGridsGridid<TData = Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridid>>, TError = ErrorType<unknown>>(
 gridid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridid>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridid>>,
          TError,
          Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridid>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFestivalServiceV1TalentGridsGridid<TData = Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridid>>, TError = ErrorType<unknown>>(
 gridid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridid>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridid>>,
          TError,
          Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridid>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFestivalServiceV1TalentGridsGridid<TData = Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridid>>, TError = ErrorType<unknown>>(
 gridid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridid>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Talent Grid
 */

export function useGetFestivalServiceV1TalentGridsGridid<TData = Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridid>>, TError = ErrorType<unknown>>(
 gridid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridid>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFestivalServiceV1TalentGridsGrididQueryOptions(gridid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetFestivalServiceV1TalentGridsGrididSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridid>>, TError = ErrorType<unknown>>(gridid: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridid>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFestivalServiceV1TalentGridsGrididQueryKey(gridid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridid>>> = () => getFestivalServiceV1TalentGridsGridid(gridid, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridid>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFestivalServiceV1TalentGridsGrididSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridid>>>
export type GetFestivalServiceV1TalentGridsGrididSuspenseQueryError = ErrorType<unknown>


export function useGetFestivalServiceV1TalentGridsGrididSuspense<TData = Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridid>>, TError = ErrorType<unknown>>(
 gridid: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridid>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFestivalServiceV1TalentGridsGrididSuspense<TData = Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridid>>, TError = ErrorType<unknown>>(
 gridid: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridid>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFestivalServiceV1TalentGridsGrididSuspense<TData = Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridid>>, TError = ErrorType<unknown>>(
 gridid: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridid>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Talent Grid
 */

export function useGetFestivalServiceV1TalentGridsGrididSuspense<TData = Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridid>>, TError = ErrorType<unknown>>(
 gridid: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridid>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFestivalServiceV1TalentGridsGrididSuspenseQueryOptions(gridid,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Delete Talent Grid
 */
export const deleteTalentGrid = (
    gridid: string,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<DeleteTalentGrid200>(
      {url: `/festival-service-v1/talent-grids/${gridid}`, method: 'DELETE'
    },
      options);
    }



export const getDeleteTalentGridMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTalentGrid>>, TError,{gridid: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTalentGrid>>, TError,{gridid: string}, TContext> => {

const mutationKey = ['deleteTalentGrid'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTalentGrid>>, {gridid: string}> = (props) => {
          const {gridid} = props ?? {};

          return  deleteTalentGrid(gridid,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTalentGridMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTalentGrid>>>

    export type DeleteTalentGridMutationError = ErrorType<unknown>

    /**
 * @summary Delete Talent Grid
 */
export const useDeleteTalentGrid = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTalentGrid>>, TError,{gridid: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteTalentGrid>>,
        TError,
        {gridid: string},
        TContext
      > => {
      return useMutation(getDeleteTalentGridMutationOptions(options), queryClient);
    }

/**
 * @summary Update Talent Grid
 */
export const updateTalentGrid = (
    gridid: string,
    updateTalentGridBody?: BodyType<UpdateTalentGridBody>,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<UpdateTalentGrid200>(
      {url: `/festival-service-v1/talent-grids/${gridid}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateTalentGridBody
    },
      options);
    }



export const getUpdateTalentGridMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTalentGrid>>, TError,{gridid: string;data?: BodyType<UpdateTalentGridBody>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTalentGrid>>, TError,{gridid: string;data?: BodyType<UpdateTalentGridBody>}, TContext> => {

const mutationKey = ['updateTalentGrid'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTalentGrid>>, {gridid: string;data?: BodyType<UpdateTalentGridBody>}> = (props) => {
          const {gridid,data} = props ?? {};

          return  updateTalentGrid(gridid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTalentGridMutationResult = NonNullable<Awaited<ReturnType<typeof updateTalentGrid>>>
    export type UpdateTalentGridMutationBody = BodyType<UpdateTalentGridBody> | undefined
    export type UpdateTalentGridMutationError = ErrorType<unknown>

    /**
 * @summary Update Talent Grid
 */
export const useUpdateTalentGrid = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTalentGrid>>, TError,{gridid: string;data?: BodyType<UpdateTalentGridBody>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateTalentGrid>>,
        TError,
        {gridid: string;data?: BodyType<UpdateTalentGridBody>},
        TContext
      > => {
      return useMutation(getUpdateTalentGridMutationOptions(options), queryClient);
    }

/**
 * @summary Add Festival to Talent Grid
 */
export const addFestivalToTalentGrid = (
    gridId: string,
    addFestivalToTalentGridBody?: BodyType<AddFestivalToTalentGridBody>,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<AddFestivalToTalentGrid200>(
      {url: `/festival-service-v1/talent-grids/${gridId}/festivals`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addFestivalToTalentGridBody
    },
      options);
    }



export const getAddFestivalToTalentGridMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addFestivalToTalentGrid>>, TError,{gridId: string;data?: BodyType<AddFestivalToTalentGridBody>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof addFestivalToTalentGrid>>, TError,{gridId: string;data?: BodyType<AddFestivalToTalentGridBody>}, TContext> => {

const mutationKey = ['addFestivalToTalentGrid'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addFestivalToTalentGrid>>, {gridId: string;data?: BodyType<AddFestivalToTalentGridBody>}> = (props) => {
          const {gridId,data} = props ?? {};

          return  addFestivalToTalentGrid(gridId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddFestivalToTalentGridMutationResult = NonNullable<Awaited<ReturnType<typeof addFestivalToTalentGrid>>>
    export type AddFestivalToTalentGridMutationBody = BodyType<AddFestivalToTalentGridBody> | undefined
    export type AddFestivalToTalentGridMutationError = ErrorType<unknown>

    /**
 * @summary Add Festival to Talent Grid
 */
export const useAddFestivalToTalentGrid = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addFestivalToTalentGrid>>, TError,{gridId: string;data?: BodyType<AddFestivalToTalentGridBody>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addFestivalToTalentGrid>>,
        TError,
        {gridId: string;data?: BodyType<AddFestivalToTalentGridBody>},
        TContext
      > => {
      return useMutation(getAddFestivalToTalentGridMutationOptions(options), queryClient);
    }

/**
 * @summary Delete Festival from Talent Grid
 */
export const deleteFestivalFromTalentGrid = (
    gridId: string,
    festivalId: string,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<DeleteFestivalFromTalentGrid200>(
      {url: `/festival-service-v1/talent-grids/${gridId}/festivals/${festivalId}`, method: 'DELETE'
    },
      options);
    }



export const getDeleteFestivalFromTalentGridMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFestivalFromTalentGrid>>, TError,{gridId: string;festivalId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteFestivalFromTalentGrid>>, TError,{gridId: string;festivalId: string}, TContext> => {

const mutationKey = ['deleteFestivalFromTalentGrid'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteFestivalFromTalentGrid>>, {gridId: string;festivalId: string}> = (props) => {
          const {gridId,festivalId} = props ?? {};

          return  deleteFestivalFromTalentGrid(gridId,festivalId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteFestivalFromTalentGridMutationResult = NonNullable<Awaited<ReturnType<typeof deleteFestivalFromTalentGrid>>>

    export type DeleteFestivalFromTalentGridMutationError = ErrorType<unknown>

    /**
 * @summary Delete Festival from Talent Grid
 */
export const useDeleteFestivalFromTalentGrid = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFestivalFromTalentGrid>>, TError,{gridId: string;festivalId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteFestivalFromTalentGrid>>,
        TError,
        {gridId: string;festivalId: string},
        TContext
      > => {
      return useMutation(getDeleteFestivalFromTalentGridMutationOptions(options), queryClient);
    }

/**
 * @summary Get Running Order Sets
 */
export const getRunningOrderSets = (
    gridId: string,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<GetRunningOrderSets200>(
      {url: `/festival-service-v1/talent-grids/${gridId}/runningorder-sets`, method: 'GET'
    },
      options);
    }




export const getGetRunningOrderSetsQueryKey = (gridId: string,) => {
    return [
    'festival-service-v1','talent-grids',gridId,'runningorder-sets'
    ] as const;
    }


export const getGetRunningOrderSetsQueryOptions = <TData = Awaited<ReturnType<typeof getRunningOrderSets>>, TError = ErrorType<unknown>>(gridId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRunningOrderSets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRunningOrderSetsQueryKey(gridId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRunningOrderSets>>> = () => getRunningOrderSets(gridId, requestOptions);





   return  { queryKey, queryFn, enabled: gridId !== null && gridId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRunningOrderSets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRunningOrderSetsQueryResult = NonNullable<Awaited<ReturnType<typeof getRunningOrderSets>>>
export type GetRunningOrderSetsQueryError = ErrorType<unknown>


export function useGetRunningOrderSets<TData = Awaited<ReturnType<typeof getRunningOrderSets>>, TError = ErrorType<unknown>>(
 gridId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRunningOrderSets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRunningOrderSets>>,
          TError,
          Awaited<ReturnType<typeof getRunningOrderSets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRunningOrderSets<TData = Awaited<ReturnType<typeof getRunningOrderSets>>, TError = ErrorType<unknown>>(
 gridId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRunningOrderSets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRunningOrderSets>>,
          TError,
          Awaited<ReturnType<typeof getRunningOrderSets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRunningOrderSets<TData = Awaited<ReturnType<typeof getRunningOrderSets>>, TError = ErrorType<unknown>>(
 gridId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRunningOrderSets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Running Order Sets
 */

export function useGetRunningOrderSets<TData = Awaited<ReturnType<typeof getRunningOrderSets>>, TError = ErrorType<unknown>>(
 gridId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRunningOrderSets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRunningOrderSetsQueryOptions(gridId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetRunningOrderSetsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getRunningOrderSets>>, TError = ErrorType<unknown>>(gridId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRunningOrderSets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRunningOrderSetsQueryKey(gridId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRunningOrderSets>>> = () => getRunningOrderSets(gridId, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRunningOrderSets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRunningOrderSetsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getRunningOrderSets>>>
export type GetRunningOrderSetsSuspenseQueryError = ErrorType<unknown>


export function useGetRunningOrderSetsSuspense<TData = Awaited<ReturnType<typeof getRunningOrderSets>>, TError = ErrorType<unknown>>(
 gridId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRunningOrderSets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRunningOrderSetsSuspense<TData = Awaited<ReturnType<typeof getRunningOrderSets>>, TError = ErrorType<unknown>>(
 gridId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRunningOrderSets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRunningOrderSetsSuspense<TData = Awaited<ReturnType<typeof getRunningOrderSets>>, TError = ErrorType<unknown>>(
 gridId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRunningOrderSets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Running Order Sets
 */

export function useGetRunningOrderSetsSuspense<TData = Awaited<ReturnType<typeof getRunningOrderSets>>, TError = ErrorType<unknown>>(
 gridId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getRunningOrderSets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRunningOrderSetsSuspenseQueryOptions(gridId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Create Running Order Set
 */
export const postFestivalServiceV1TalentGridsGridIdRunningorderSets = (
    gridId: string,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<PostFestivalServiceV1TalentGridsGridIdRunningorderSets200>(
      {url: `/festival-service-v1/talent-grids/${gridId}/runningorder-sets`, method: 'POST'
    },
      options);
    }



export const getPostFestivalServiceV1TalentGridsGridIdRunningorderSetsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFestivalServiceV1TalentGridsGridIdRunningorderSets>>, TError,{gridId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postFestivalServiceV1TalentGridsGridIdRunningorderSets>>, TError,{gridId: string}, TContext> => {

const mutationKey = ['postFestivalServiceV1TalentGridsGridIdRunningorderSets'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFestivalServiceV1TalentGridsGridIdRunningorderSets>>, {gridId: string}> = (props) => {
          const {gridId} = props ?? {};

          return  postFestivalServiceV1TalentGridsGridIdRunningorderSets(gridId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostFestivalServiceV1TalentGridsGridIdRunningorderSetsMutationResult = NonNullable<Awaited<ReturnType<typeof postFestivalServiceV1TalentGridsGridIdRunningorderSets>>>

    export type PostFestivalServiceV1TalentGridsGridIdRunningorderSetsMutationError = ErrorType<unknown>

    /**
 * @summary Create Running Order Set
 */
export const usePostFestivalServiceV1TalentGridsGridIdRunningorderSets = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFestivalServiceV1TalentGridsGridIdRunningorderSets>>, TError,{gridId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postFestivalServiceV1TalentGridsGridIdRunningorderSets>>,
        TError,
        {gridId: string},
        TContext
      > => {
      return useMutation(getPostFestivalServiceV1TalentGridsGridIdRunningorderSetsMutationOptions(options), queryClient);
    }

/**
 * @summary Delete Running Order Set
 */
export const deleteRunningOrderSet = (
    gridId: string,
    setId: string,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<DeleteRunningOrderSet200>(
      {url: `/festival-service-v1/talent-grids/${gridId}/runningorder-sets/${setId}`, method: 'DELETE'
    },
      options);
    }



export const getDeleteRunningOrderSetMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRunningOrderSet>>, TError,{gridId: string;setId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteRunningOrderSet>>, TError,{gridId: string;setId: string}, TContext> => {

const mutationKey = ['deleteRunningOrderSet'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteRunningOrderSet>>, {gridId: string;setId: string}> = (props) => {
          const {gridId,setId} = props ?? {};

          return  deleteRunningOrderSet(gridId,setId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteRunningOrderSetMutationResult = NonNullable<Awaited<ReturnType<typeof deleteRunningOrderSet>>>

    export type DeleteRunningOrderSetMutationError = ErrorType<unknown>

    /**
 * @summary Delete Running Order Set
 */
export const useDeleteRunningOrderSet = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRunningOrderSet>>, TError,{gridId: string;setId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteRunningOrderSet>>,
        TError,
        {gridId: string;setId: string},
        TContext
      > => {
      return useMutation(getDeleteRunningOrderSetMutationOptions(options), queryClient);
    }

/**
 * @summary Add Connection to Running Order Set
 */
export const addConnectionToRunningOrderSet = (
    gridId: string,
    setId: string,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<AddConnectionToRunningOrderSet200>(
      {url: `/festival-service-v1/talent-grids/${gridId}/runningorder-sets/${setId}/connections`, method: 'POST'
    },
      options);
    }



export const getAddConnectionToRunningOrderSetMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addConnectionToRunningOrderSet>>, TError,{gridId: string;setId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof addConnectionToRunningOrderSet>>, TError,{gridId: string;setId: string}, TContext> => {

const mutationKey = ['addConnectionToRunningOrderSet'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addConnectionToRunningOrderSet>>, {gridId: string;setId: string}> = (props) => {
          const {gridId,setId} = props ?? {};

          return  addConnectionToRunningOrderSet(gridId,setId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddConnectionToRunningOrderSetMutationResult = NonNullable<Awaited<ReturnType<typeof addConnectionToRunningOrderSet>>>

    export type AddConnectionToRunningOrderSetMutationError = ErrorType<unknown>

    /**
 * @summary Add Connection to Running Order Set
 */
export const useAddConnectionToRunningOrderSet = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addConnectionToRunningOrderSet>>, TError,{gridId: string;setId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addConnectionToRunningOrderSet>>,
        TError,
        {gridId: string;setId: string},
        TContext
      > => {
      return useMutation(getAddConnectionToRunningOrderSetMutationOptions(options), queryClient);
    }

/**
 * @summary Remove Connection from Running Order Set
 */
export const removeConnectionFromRunningOrderSet = (
    gridId: string,
    setId: string,
    connectionId: string,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<RemoveConnectionFromRunningOrderSet200>(
      {url: `/festival-service-v1/talent-grids/${gridId}/runningorder-sets/${setId}/connections/${connectionId}`, method: 'DELETE'
    },
      options);
    }



export const getRemoveConnectionFromRunningOrderSetMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeConnectionFromRunningOrderSet>>, TError,{gridId: string;setId: string;connectionId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof removeConnectionFromRunningOrderSet>>, TError,{gridId: string;setId: string;connectionId: string}, TContext> => {

const mutationKey = ['removeConnectionFromRunningOrderSet'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeConnectionFromRunningOrderSet>>, {gridId: string;setId: string;connectionId: string}> = (props) => {
          const {gridId,setId,connectionId} = props ?? {};

          return  removeConnectionFromRunningOrderSet(gridId,setId,connectionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveConnectionFromRunningOrderSetMutationResult = NonNullable<Awaited<ReturnType<typeof removeConnectionFromRunningOrderSet>>>

    export type RemoveConnectionFromRunningOrderSetMutationError = ErrorType<unknown>

    /**
 * @summary Remove Connection from Running Order Set
 */
export const useRemoveConnectionFromRunningOrderSet = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeConnectionFromRunningOrderSet>>, TError,{gridId: string;setId: string;connectionId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeConnectionFromRunningOrderSet>>,
        TError,
        {gridId: string;setId: string;connectionId: string},
        TContext
      > => {
      return useMutation(getRemoveConnectionFromRunningOrderSetMutationOptions(options), queryClient);
    }

/**
 * @summary Get Running Order
 */
export const getFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId = (
    gridId: string,
    setId: string,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<GetFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId200>(
      {url: `/festival-service-v1/talent-grids/${gridId}/runningorder-sets/${setId}/`, method: 'GET'
    },
      options);
    }




export const getGetFestivalServiceV1TalentGridsGridIdRunningorderSetsSetIdQueryKey = (gridId: string,
    setId: string,) => {
    return [
    'festival-service-v1','talent-grids',gridId,'runningorder-sets',setId
    ] as const;
    }


export const getGetFestivalServiceV1TalentGridsGridIdRunningorderSetsSetIdQueryOptions = <TData = Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId>>, TError = ErrorType<unknown>>(gridId: string,
    setId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFestivalServiceV1TalentGridsGridIdRunningorderSetsSetIdQueryKey(gridId,setId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId>>> = () => getFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId(gridId,setId, requestOptions);





   return  { queryKey, queryFn, enabled: gridId !== null && gridId !== undefined && setId !== null && setId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFestivalServiceV1TalentGridsGridIdRunningorderSetsSetIdQueryResult = NonNullable<Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId>>>
export type GetFestivalServiceV1TalentGridsGridIdRunningorderSetsSetIdQueryError = ErrorType<unknown>


export function useGetFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId<TData = Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId>>, TError = ErrorType<unknown>>(
 gridId: string,
    setId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId>>,
          TError,
          Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId<TData = Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId>>, TError = ErrorType<unknown>>(
 gridId: string,
    setId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId>>,
          TError,
          Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId<TData = Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId>>, TError = ErrorType<unknown>>(
 gridId: string,
    setId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Running Order
 */

export function useGetFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId<TData = Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId>>, TError = ErrorType<unknown>>(
 gridId: string,
    setId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFestivalServiceV1TalentGridsGridIdRunningorderSetsSetIdQueryOptions(gridId,setId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetFestivalServiceV1TalentGridsGridIdRunningorderSetsSetIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId>>, TError = ErrorType<unknown>>(gridId: string,
    setId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFestivalServiceV1TalentGridsGridIdRunningorderSetsSetIdQueryKey(gridId,setId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId>>> = () => getFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId(gridId,setId, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFestivalServiceV1TalentGridsGridIdRunningorderSetsSetIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId>>>
export type GetFestivalServiceV1TalentGridsGridIdRunningorderSetsSetIdSuspenseQueryError = ErrorType<unknown>


export function useGetFestivalServiceV1TalentGridsGridIdRunningorderSetsSetIdSuspense<TData = Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId>>, TError = ErrorType<unknown>>(
 gridId: string,
    setId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFestivalServiceV1TalentGridsGridIdRunningorderSetsSetIdSuspense<TData = Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId>>, TError = ErrorType<unknown>>(
 gridId: string,
    setId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFestivalServiceV1TalentGridsGridIdRunningorderSetsSetIdSuspense<TData = Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId>>, TError = ErrorType<unknown>>(
 gridId: string,
    setId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Running Order
 */

export function useGetFestivalServiceV1TalentGridsGridIdRunningorderSetsSetIdSuspense<TData = Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId>>, TError = ErrorType<unknown>>(
 gridId: string,
    setId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFestivalServiceV1TalentGridsGridIdRunningorderSetsSetIdSuspenseQueryOptions(gridId,setId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Create Running Order
 */
export const postFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId = (
    gridId: string,
    setId: string,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<PostFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId200>(
      {url: `/festival-service-v1/talent-grids/${gridId}/runningorder-sets/${setId}/`, method: 'POST'
    },
      options);
    }



export const getPostFestivalServiceV1TalentGridsGridIdRunningorderSetsSetIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId>>, TError,{gridId: string;setId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId>>, TError,{gridId: string;setId: string}, TContext> => {

const mutationKey = ['postFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId>>, {gridId: string;setId: string}> = (props) => {
          const {gridId,setId} = props ?? {};

          return  postFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId(gridId,setId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostFestivalServiceV1TalentGridsGridIdRunningorderSetsSetIdMutationResult = NonNullable<Awaited<ReturnType<typeof postFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId>>>

    export type PostFestivalServiceV1TalentGridsGridIdRunningorderSetsSetIdMutationError = ErrorType<unknown>

    /**
 * @summary Create Running Order
 */
export const usePostFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId>>, TError,{gridId: string;setId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId>>,
        TError,
        {gridId: string;setId: string},
        TContext
      > => {
      return useMutation(getPostFestivalServiceV1TalentGridsGridIdRunningorderSetsSetIdMutationOptions(options), queryClient);
    }

/**
 * @summary Update Running Order
 */
export const patchFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId = (
    gridId: string,
    setId: string,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<PatchFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId200>(
      {url: `/festival-service-v1/talent-grids/${gridId}/runningorder-sets/${setId}/`, method: 'PATCH'
    },
      options);
    }



export const getPatchFestivalServiceV1TalentGridsGridIdRunningorderSetsSetIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId>>, TError,{gridId: string;setId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId>>, TError,{gridId: string;setId: string}, TContext> => {

const mutationKey = ['patchFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId>>, {gridId: string;setId: string}> = (props) => {
          const {gridId,setId} = props ?? {};

          return  patchFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId(gridId,setId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchFestivalServiceV1TalentGridsGridIdRunningorderSetsSetIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId>>>

    export type PatchFestivalServiceV1TalentGridsGridIdRunningorderSetsSetIdMutationError = ErrorType<unknown>

    /**
 * @summary Update Running Order
 */
export const usePatchFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId>>, TError,{gridId: string;setId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId>>,
        TError,
        {gridId: string;setId: string},
        TContext
      > => {
      return useMutation(getPatchFestivalServiceV1TalentGridsGridIdRunningorderSetsSetIdMutationOptions(options), queryClient);
    }

/**
 * @summary Delete Running Order
 */
export const deleteFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId = (
    gridId: string,
    setId: string,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<DeleteFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId200>(
      {url: `/festival-service-v1/talent-grids/${gridId}/runningorder-sets/${setId}/`, method: 'DELETE'
    },
      options);
    }



export const getDeleteFestivalServiceV1TalentGridsGridIdRunningorderSetsSetIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId>>, TError,{gridId: string;setId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId>>, TError,{gridId: string;setId: string}, TContext> => {

const mutationKey = ['deleteFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId>>, {gridId: string;setId: string}> = (props) => {
          const {gridId,setId} = props ?? {};

          return  deleteFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId(gridId,setId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteFestivalServiceV1TalentGridsGridIdRunningorderSetsSetIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId>>>

    export type DeleteFestivalServiceV1TalentGridsGridIdRunningorderSetsSetIdMutationError = ErrorType<unknown>

    /**
 * @summary Delete Running Order
 */
export const useDeleteFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId>>, TError,{gridId: string;setId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteFestivalServiceV1TalentGridsGridIdRunningorderSetsSetId>>,
        TError,
        {gridId: string;setId: string},
        TContext
      > => {
      return useMutation(getDeleteFestivalServiceV1TalentGridsGridIdRunningorderSetsSetIdMutationOptions(options), queryClient);
    }

/**
 * @summary Get Slots
 */
export const getSlots = (
    gridId: string,
    setId: string,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<GetSlots200>(
      {url: `/festival-service-v1/talent-grids/${gridId}/runningorder-sets/${setId}/slots`, method: 'GET'
    },
      options);
    }




export const getGetSlotsQueryKey = (gridId: string,
    setId: string,) => {
    return [
    'festival-service-v1','talent-grids',gridId,'runningorder-sets',setId,'slots'
    ] as const;
    }


export const getGetSlotsQueryOptions = <TData = Awaited<ReturnType<typeof getSlots>>, TError = ErrorType<unknown>>(gridId: string,
    setId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSlots>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSlotsQueryKey(gridId,setId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSlots>>> = () => getSlots(gridId,setId, requestOptions);





   return  { queryKey, queryFn, enabled: gridId !== null && gridId !== undefined && setId !== null && setId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSlots>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSlotsQueryResult = NonNullable<Awaited<ReturnType<typeof getSlots>>>
export type GetSlotsQueryError = ErrorType<unknown>


export function useGetSlots<TData = Awaited<ReturnType<typeof getSlots>>, TError = ErrorType<unknown>>(
 gridId: string,
    setId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSlots>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSlots>>,
          TError,
          Awaited<ReturnType<typeof getSlots>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSlots<TData = Awaited<ReturnType<typeof getSlots>>, TError = ErrorType<unknown>>(
 gridId: string,
    setId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSlots>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSlots>>,
          TError,
          Awaited<ReturnType<typeof getSlots>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSlots<TData = Awaited<ReturnType<typeof getSlots>>, TError = ErrorType<unknown>>(
 gridId: string,
    setId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSlots>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Slots
 */

export function useGetSlots<TData = Awaited<ReturnType<typeof getSlots>>, TError = ErrorType<unknown>>(
 gridId: string,
    setId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSlots>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSlotsQueryOptions(gridId,setId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetSlotsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSlots>>, TError = ErrorType<unknown>>(gridId: string,
    setId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSlots>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSlotsQueryKey(gridId,setId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSlots>>> = () => getSlots(gridId,setId, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSlots>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSlotsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSlots>>>
export type GetSlotsSuspenseQueryError = ErrorType<unknown>


export function useGetSlotsSuspense<TData = Awaited<ReturnType<typeof getSlots>>, TError = ErrorType<unknown>>(
 gridId: string,
    setId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSlots>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSlotsSuspense<TData = Awaited<ReturnType<typeof getSlots>>, TError = ErrorType<unknown>>(
 gridId: string,
    setId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSlots>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSlotsSuspense<TData = Awaited<ReturnType<typeof getSlots>>, TError = ErrorType<unknown>>(
 gridId: string,
    setId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSlots>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Slots
 */

export function useGetSlotsSuspense<TData = Awaited<ReturnType<typeof getSlots>>, TError = ErrorType<unknown>>(
 gridId: string,
    setId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSlots>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSlotsSuspenseQueryOptions(gridId,setId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Create Slot
 */
export const createSlot = (
    gridId: string,
    setId: string,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<CreateSlot200>(
      {url: `/festival-service-v1/talent-grids/${gridId}/runningorder-sets/${setId}/slots`, method: 'POST'
    },
      options);
    }



export const getCreateSlotMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSlot>>, TError,{gridId: string;setId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createSlot>>, TError,{gridId: string;setId: string}, TContext> => {

const mutationKey = ['createSlot'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSlot>>, {gridId: string;setId: string}> = (props) => {
          const {gridId,setId} = props ?? {};

          return  createSlot(gridId,setId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSlotMutationResult = NonNullable<Awaited<ReturnType<typeof createSlot>>>

    export type CreateSlotMutationError = ErrorType<unknown>

    /**
 * @summary Create Slot
 */
export const useCreateSlot = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSlot>>, TError,{gridId: string;setId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createSlot>>,
        TError,
        {gridId: string;setId: string},
        TContext
      > => {
      return useMutation(getCreateSlotMutationOptions(options), queryClient);
    }

/**
 * @summary Update Slot
 */
export const updateSlot = (
    gridId: string,
    setId: string,
    slotId: string,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<UpdateSlot200>(
      {url: `/festival-service-v1/talent-grids/${gridId}/runningorder-sets/${setId}/slots/${slotId}`, method: 'PATCH'
    },
      options);
    }



export const getUpdateSlotMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSlot>>, TError,{gridId: string;setId: string;slotId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSlot>>, TError,{gridId: string;setId: string;slotId: string}, TContext> => {

const mutationKey = ['updateSlot'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSlot>>, {gridId: string;setId: string;slotId: string}> = (props) => {
          const {gridId,setId,slotId} = props ?? {};

          return  updateSlot(gridId,setId,slotId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSlotMutationResult = NonNullable<Awaited<ReturnType<typeof updateSlot>>>

    export type UpdateSlotMutationError = ErrorType<unknown>

    /**
 * @summary Update Slot
 */
export const useUpdateSlot = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSlot>>, TError,{gridId: string;setId: string;slotId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateSlot>>,
        TError,
        {gridId: string;setId: string;slotId: string},
        TContext
      > => {
      return useMutation(getUpdateSlotMutationOptions(options), queryClient);
    }

/**
 * @summary Delete Slot
 */
export const deleteSlot = (
    gridId: string,
    setId: string,
    slotId: string,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<DeleteSlot200>(
      {url: `/festival-service-v1/talent-grids/${gridId}/runningorder-sets/${setId}/slots/${slotId}`, method: 'DELETE'
    },
      options);
    }



export const getDeleteSlotMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSlot>>, TError,{gridId: string;setId: string;slotId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSlot>>, TError,{gridId: string;setId: string;slotId: string}, TContext> => {

const mutationKey = ['deleteSlot'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSlot>>, {gridId: string;setId: string;slotId: string}> = (props) => {
          const {gridId,setId,slotId} = props ?? {};

          return  deleteSlot(gridId,setId,slotId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteSlotMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSlot>>>

    export type DeleteSlotMutationError = ErrorType<unknown>

    /**
 * @summary Delete Slot
 */
export const useDeleteSlot = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSlot>>, TError,{gridId: string;setId: string;slotId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteSlot>>,
        TError,
        {gridId: string;setId: string;slotId: string},
        TContext
      > => {
      return useMutation(getDeleteSlotMutationOptions(options), queryClient);
    }

/**
 * @summary Assign Artist to Slot
 */
export const assignArtistToSlot = (
    gridId: string,
    setId: string,
    slotId: string,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<AssignArtistToSlot200>(
      {url: `/festival-service-v1/talent-grids/${gridId}/runningorder-sets/${setId}/slots/${slotId}/artists`, method: 'POST'
    },
      options);
    }



export const getAssignArtistToSlotMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignArtistToSlot>>, TError,{gridId: string;setId: string;slotId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof assignArtistToSlot>>, TError,{gridId: string;setId: string;slotId: string}, TContext> => {

const mutationKey = ['assignArtistToSlot'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assignArtistToSlot>>, {gridId: string;setId: string;slotId: string}> = (props) => {
          const {gridId,setId,slotId} = props ?? {};

          return  assignArtistToSlot(gridId,setId,slotId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AssignArtistToSlotMutationResult = NonNullable<Awaited<ReturnType<typeof assignArtistToSlot>>>

    export type AssignArtistToSlotMutationError = ErrorType<unknown>

    /**
 * @summary Assign Artist to Slot
 */
export const useAssignArtistToSlot = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignArtistToSlot>>, TError,{gridId: string;setId: string;slotId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof assignArtistToSlot>>,
        TError,
        {gridId: string;setId: string;slotId: string},
        TContext
      > => {
      return useMutation(getAssignArtistToSlotMutationOptions(options), queryClient);
    }

/**
 * @summary Remove Artist from Slot
 */
export const removeArtistFromSlot = (
    gridId: string,
    setId: string,
    slotId: string,
    artistId: string,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<RemoveArtistFromSlot200>(
      {url: `/festival-service-v1/talent-grids/${gridId}/runningorder-sets/${setId}/slots/${slotId}/artists/${artistId}`, method: 'DELETE'
    },
      options);
    }



export const getRemoveArtistFromSlotMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeArtistFromSlot>>, TError,{gridId: string;setId: string;slotId: string;artistId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof removeArtistFromSlot>>, TError,{gridId: string;setId: string;slotId: string;artistId: string}, TContext> => {

const mutationKey = ['removeArtistFromSlot'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeArtistFromSlot>>, {gridId: string;setId: string;slotId: string;artistId: string}> = (props) => {
          const {gridId,setId,slotId,artistId} = props ?? {};

          return  removeArtistFromSlot(gridId,setId,slotId,artistId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveArtistFromSlotMutationResult = NonNullable<Awaited<ReturnType<typeof removeArtistFromSlot>>>

    export type RemoveArtistFromSlotMutationError = ErrorType<unknown>

    /**
 * @summary Remove Artist from Slot
 */
export const useRemoveArtistFromSlot = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeArtistFromSlot>>, TError,{gridId: string;setId: string;slotId: string;artistId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeArtistFromSlot>>,
        TError,
        {gridId: string;setId: string;slotId: string;artistId: string},
        TContext
      > => {
      return useMutation(getRemoveArtistFromSlotMutationOptions(options), queryClient);
    }

/**
 * @summary Get Artists in Talent Grid
 */
export const getArtistsInTalentGrid = (
    gridId: string,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<GetArtistsInTalentGrid200>(
      {url: `/festival-service-v1/talent-grids/${gridId}/artists`, method: 'GET'
    },
      options);
    }




export const getGetArtistsInTalentGridQueryKey = (gridId: string,) => {
    return [
    'festival-service-v1','talent-grids',gridId,'artists'
    ] as const;
    }


export const getGetArtistsInTalentGridQueryOptions = <TData = Awaited<ReturnType<typeof getArtistsInTalentGrid>>, TError = ErrorType<unknown>>(gridId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArtistsInTalentGrid>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetArtistsInTalentGridQueryKey(gridId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getArtistsInTalentGrid>>> = () => getArtistsInTalentGrid(gridId, requestOptions);





   return  { queryKey, queryFn, enabled: gridId !== null && gridId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getArtistsInTalentGrid>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetArtistsInTalentGridQueryResult = NonNullable<Awaited<ReturnType<typeof getArtistsInTalentGrid>>>
export type GetArtistsInTalentGridQueryError = ErrorType<unknown>


export function useGetArtistsInTalentGrid<TData = Awaited<ReturnType<typeof getArtistsInTalentGrid>>, TError = ErrorType<unknown>>(
 gridId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArtistsInTalentGrid>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getArtistsInTalentGrid>>,
          TError,
          Awaited<ReturnType<typeof getArtistsInTalentGrid>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetArtistsInTalentGrid<TData = Awaited<ReturnType<typeof getArtistsInTalentGrid>>, TError = ErrorType<unknown>>(
 gridId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArtistsInTalentGrid>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getArtistsInTalentGrid>>,
          TError,
          Awaited<ReturnType<typeof getArtistsInTalentGrid>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetArtistsInTalentGrid<TData = Awaited<ReturnType<typeof getArtistsInTalentGrid>>, TError = ErrorType<unknown>>(
 gridId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArtistsInTalentGrid>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Artists in Talent Grid
 */

export function useGetArtistsInTalentGrid<TData = Awaited<ReturnType<typeof getArtistsInTalentGrid>>, TError = ErrorType<unknown>>(
 gridId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArtistsInTalentGrid>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetArtistsInTalentGridQueryOptions(gridId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetArtistsInTalentGridSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getArtistsInTalentGrid>>, TError = ErrorType<unknown>>(gridId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getArtistsInTalentGrid>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetArtistsInTalentGridQueryKey(gridId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getArtistsInTalentGrid>>> = () => getArtistsInTalentGrid(gridId, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getArtistsInTalentGrid>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetArtistsInTalentGridSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getArtistsInTalentGrid>>>
export type GetArtistsInTalentGridSuspenseQueryError = ErrorType<unknown>


export function useGetArtistsInTalentGridSuspense<TData = Awaited<ReturnType<typeof getArtistsInTalentGrid>>, TError = ErrorType<unknown>>(
 gridId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getArtistsInTalentGrid>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetArtistsInTalentGridSuspense<TData = Awaited<ReturnType<typeof getArtistsInTalentGrid>>, TError = ErrorType<unknown>>(
 gridId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getArtistsInTalentGrid>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetArtistsInTalentGridSuspense<TData = Awaited<ReturnType<typeof getArtistsInTalentGrid>>, TError = ErrorType<unknown>>(
 gridId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getArtistsInTalentGrid>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Artists in Talent Grid
 */

export function useGetArtistsInTalentGridSuspense<TData = Awaited<ReturnType<typeof getArtistsInTalentGrid>>, TError = ErrorType<unknown>>(
 gridId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getArtistsInTalentGrid>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetArtistsInTalentGridSuspenseQueryOptions(gridId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Create Artist in Talent Grid
 */
export const createArtistInTalentGrid = (
    gridId: string,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<CreateArtistInTalentGrid200>(
      {url: `/festival-service-v1/talent-grids/${gridId}/artists`, method: 'POST'
    },
      options);
    }



export const getCreateArtistInTalentGridMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createArtistInTalentGrid>>, TError,{gridId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createArtistInTalentGrid>>, TError,{gridId: string}, TContext> => {

const mutationKey = ['createArtistInTalentGrid'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createArtistInTalentGrid>>, {gridId: string}> = (props) => {
          const {gridId} = props ?? {};

          return  createArtistInTalentGrid(gridId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateArtistInTalentGridMutationResult = NonNullable<Awaited<ReturnType<typeof createArtistInTalentGrid>>>

    export type CreateArtistInTalentGridMutationError = ErrorType<unknown>

    /**
 * @summary Create Artist in Talent Grid
 */
export const useCreateArtistInTalentGrid = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createArtistInTalentGrid>>, TError,{gridId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createArtistInTalentGrid>>,
        TError,
        {gridId: string},
        TContext
      > => {
      return useMutation(getCreateArtistInTalentGridMutationOptions(options), queryClient);
    }

/**
 * @summary Get Artist in Talent Grid
 */
export const get = (

 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<Get200>(
      {url: `/`, method: 'GET'
    },
      options);
    }




export const getGetQueryKey = () => {
    return [

    ] as const;
    }


export const getGetQueryOptions = <TData = Awaited<ReturnType<typeof get>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof get>>> = () => get(requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof get>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetQueryResult = NonNullable<Awaited<ReturnType<typeof get>>>
export type GetQueryError = ErrorType<unknown>


export function useGet<TData = Awaited<ReturnType<typeof get>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof get>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof get>>,
          TError,
          Awaited<ReturnType<typeof get>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGet<TData = Awaited<ReturnType<typeof get>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof get>>,
          TError,
          Awaited<ReturnType<typeof get>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGet<TData = Awaited<ReturnType<typeof get>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Artist in Talent Grid
 */

export function useGet<TData = Awaited<ReturnType<typeof get>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof get>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof get>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof get>>> = () => get(requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof get>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof get>>>
export type GetSuspenseQueryError = ErrorType<unknown>


export function useGetSuspense<TData = Awaited<ReturnType<typeof get>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof get>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuspense<TData = Awaited<ReturnType<typeof get>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof get>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSuspense<TData = Awaited<ReturnType<typeof get>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof get>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Artist in Talent Grid
 */

export function useGetSuspense<TData = Awaited<ReturnType<typeof get>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof get>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Create Artist Offer
 */
export const post = (

 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<Post200>(
      {url: `/`, method: 'POST'
    },
      options);
    }



export const getPostMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof post>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof post>>, TError,void, TContext> => {

const mutationKey = ['post'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof post>>, void> = () => {


          return  post(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostMutationResult = NonNullable<Awaited<ReturnType<typeof post>>>

    export type PostMutationError = ErrorType<unknown>

    /**
 * @summary Create Artist Offer
 */
export const usePost = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof post>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof post>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getPostMutationOptions(options), queryClient);
    }

/**
 * @summary Update Artist in Talent Grid
 */
export const updateArtistInTalentGrid = (
    gridId: string,
    artistId: string,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<UpdateArtistInTalentGrid200>(
      {url: `/festival-service-v1/talent-grids/${gridId}/artists/${artistId}`, method: 'PATCH'
    },
      options);
    }



export const getUpdateArtistInTalentGridMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateArtistInTalentGrid>>, TError,{gridId: string;artistId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateArtistInTalentGrid>>, TError,{gridId: string;artistId: string}, TContext> => {

const mutationKey = ['updateArtistInTalentGrid'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateArtistInTalentGrid>>, {gridId: string;artistId: string}> = (props) => {
          const {gridId,artistId} = props ?? {};

          return  updateArtistInTalentGrid(gridId,artistId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateArtistInTalentGridMutationResult = NonNullable<Awaited<ReturnType<typeof updateArtistInTalentGrid>>>

    export type UpdateArtistInTalentGridMutationError = ErrorType<unknown>

    /**
 * @summary Update Artist in Talent Grid
 */
export const useUpdateArtistInTalentGrid = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateArtistInTalentGrid>>, TError,{gridId: string;artistId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateArtistInTalentGrid>>,
        TError,
        {gridId: string;artistId: string},
        TContext
      > => {
      return useMutation(getUpdateArtistInTalentGridMutationOptions(options), queryClient);
    }

/**
 * @summary Delete Artist in Talent Grid
 */
export const deleteArtistInTalentGrid = (
    gridId: string,
    artistId: string,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<DeleteArtistInTalentGrid200>(
      {url: `/festival-service-v1/talent-grids/${gridId}/artists/${artistId}`, method: 'DELETE'
    },
      options);
    }



export const getDeleteArtistInTalentGridMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteArtistInTalentGrid>>, TError,{gridId: string;artistId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteArtistInTalentGrid>>, TError,{gridId: string;artistId: string}, TContext> => {

const mutationKey = ['deleteArtistInTalentGrid'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteArtistInTalentGrid>>, {gridId: string;artistId: string}> = (props) => {
          const {gridId,artistId} = props ?? {};

          return  deleteArtistInTalentGrid(gridId,artistId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteArtistInTalentGridMutationResult = NonNullable<Awaited<ReturnType<typeof deleteArtistInTalentGrid>>>

    export type DeleteArtistInTalentGridMutationError = ErrorType<unknown>

    /**
 * @summary Delete Artist in Talent Grid
 */
export const useDeleteArtistInTalentGrid = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteArtistInTalentGrid>>, TError,{gridId: string;artistId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteArtistInTalentGrid>>,
        TError,
        {gridId: string;artistId: string},
        TContext
      > => {
      return useMutation(getDeleteArtistInTalentGridMutationOptions(options), queryClient);
    }

/**
 * @summary Get Venue Operators
 */
export const findAllVenueOperators = (

 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<FindAllVenueOperators200>(
      {url: `/venues-service-v1/venue-operators`, method: 'GET'
    },
      options);
    }




export const getFindAllVenueOperatorsQueryKey = () => {
    return [
    'venues-service-v1','venue-operators'
    ] as const;
    }


export const getFindAllVenueOperatorsQueryOptions = <TData = Awaited<ReturnType<typeof findAllVenueOperators>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllVenueOperators>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllVenueOperatorsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllVenueOperators>>> = () => findAllVenueOperators(requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findAllVenueOperators>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllVenueOperatorsQueryResult = NonNullable<Awaited<ReturnType<typeof findAllVenueOperators>>>
export type FindAllVenueOperatorsQueryError = ErrorType<unknown>


export function useFindAllVenueOperators<TData = Awaited<ReturnType<typeof findAllVenueOperators>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllVenueOperators>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllVenueOperators>>,
          TError,
          Awaited<ReturnType<typeof findAllVenueOperators>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllVenueOperators<TData = Awaited<ReturnType<typeof findAllVenueOperators>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllVenueOperators>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllVenueOperators>>,
          TError,
          Awaited<ReturnType<typeof findAllVenueOperators>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllVenueOperators<TData = Awaited<ReturnType<typeof findAllVenueOperators>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllVenueOperators>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Venue Operators
 */

export function useFindAllVenueOperators<TData = Awaited<ReturnType<typeof findAllVenueOperators>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllVenueOperators>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllVenueOperatorsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindAllVenueOperatorsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findAllVenueOperators>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueOperators>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllVenueOperatorsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllVenueOperators>>> = () => findAllVenueOperators(requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueOperators>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllVenueOperatorsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findAllVenueOperators>>>
export type FindAllVenueOperatorsSuspenseQueryError = ErrorType<unknown>


export function useFindAllVenueOperatorsSuspense<TData = Awaited<ReturnType<typeof findAllVenueOperators>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueOperators>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllVenueOperatorsSuspense<TData = Awaited<ReturnType<typeof findAllVenueOperators>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueOperators>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllVenueOperatorsSuspense<TData = Awaited<ReturnType<typeof findAllVenueOperators>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueOperators>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Venue Operators
 */

export function useFindAllVenueOperatorsSuspense<TData = Awaited<ReturnType<typeof findAllVenueOperators>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueOperators>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllVenueOperatorsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Get Venue Details
 */
export const findVenue = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<GetVenueDetailsResponseType>(
      {url: `/venues-service-v1/venues/${id}`, method: 'GET'
    },
      options);
    }




export const getFindVenueQueryKey = (id: string,) => {
    return [
    'venues-service-v1','venues',id
    ] as const;
    }


export const getFindVenueQueryOptions = <TData = Awaited<ReturnType<typeof findVenue>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findVenue>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindVenueQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findVenue>>> = () => findVenue(id, requestOptions);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findVenue>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindVenueQueryResult = NonNullable<Awaited<ReturnType<typeof findVenue>>>
export type FindVenueQueryError = ErrorType<unknown>


export function useFindVenue<TData = Awaited<ReturnType<typeof findVenue>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findVenue>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findVenue>>,
          TError,
          Awaited<ReturnType<typeof findVenue>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindVenue<TData = Awaited<ReturnType<typeof findVenue>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findVenue>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findVenue>>,
          TError,
          Awaited<ReturnType<typeof findVenue>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindVenue<TData = Awaited<ReturnType<typeof findVenue>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findVenue>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Venue Details
 */

export function useFindVenue<TData = Awaited<ReturnType<typeof findVenue>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findVenue>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindVenueQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindVenueSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findVenue>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findVenue>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindVenueQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findVenue>>> = () => findVenue(id, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findVenue>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindVenueSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findVenue>>>
export type FindVenueSuspenseQueryError = ErrorType<unknown>


export function useFindVenueSuspense<TData = Awaited<ReturnType<typeof findVenue>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findVenue>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindVenueSuspense<TData = Awaited<ReturnType<typeof findVenue>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findVenue>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindVenueSuspense<TData = Awaited<ReturnType<typeof findVenue>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findVenue>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Venue Details
 */

export function useFindVenueSuspense<TData = Awaited<ReturnType<typeof findVenue>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findVenue>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindVenueSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Update Venue
 */
export const updateVenue = (
    id: string,
    updateVenueType?: BodyType<UpdateVenueType>,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<UpdateVenue200>(
      {url: `/venues-service-v1/venues/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateVenueType
    },
      options);
    }



export const getUpdateVenueMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVenue>>, TError,{id: string;data?: BodyType<UpdateVenueType>}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateVenue>>, TError,{id: string;data?: BodyType<UpdateVenueType>}, TContext> => {

const mutationKey = ['updateVenue'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateVenue>>, {id: string;data?: BodyType<UpdateVenueType>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateVenue(id,data,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof updateVenue>>, variables: {id: string;data?: BodyType<UpdateVenueType>}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getFindAllVenuesQueryKey() });
    queryClient.invalidateQueries({ queryKey: getFindVenueQueryKey(variables.id) });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type UpdateVenueMutationResult = NonNullable<Awaited<ReturnType<typeof updateVenue>>>
    export type UpdateVenueMutationBody = BodyType<UpdateVenueType> | undefined
    export type UpdateVenueMutationError = ErrorType<unknown>

    /**
 * @summary Update Venue
 */
export const useUpdateVenue = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVenue>>, TError,{id: string;data?: BodyType<UpdateVenueType>}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateVenue>>,
        TError,
        {id: string;data?: BodyType<UpdateVenueType>},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getUpdateVenueMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * @summary Delete Venue
 */
export const deleteVenue = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<DeleteResponseType>(
      {url: `/venues-service-v1/venues/${id}`, method: 'DELETE'
    },
      options);
    }



export const getDeleteVenueMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVenue>>, TError,{id: string}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteVenue>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteVenue'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteVenue>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteVenue(id,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof deleteVenue>>, variables: {id: string}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getFindAllVenuesQueryKey() });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type DeleteVenueMutationResult = NonNullable<Awaited<ReturnType<typeof deleteVenue>>>

    export type DeleteVenueMutationError = ErrorType<unknown>

    /**
 * @summary Delete Venue
 */
export const useDeleteVenue = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVenue>>, TError,{id: string}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteVenue>>,
        TError,
        {id: string},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getDeleteVenueMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * @summary Get Rental Configurations
 */
export const findAllVenueRentalConfigurations = (
    venueId: string,
    version: string,
    params?: FindAllVenueRentalConfigurationsParams,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<GetVenueRentalConfigurationsResponseType>(
      {url: `/venues-service-v1/venues/${venueId}/rental-configurations/${version}`, method: 'GET',
        params
    },
      options);
    }




export const getFindAllVenueRentalConfigurationsQueryKey = (venueId: string,
    version: string,
    params?: FindAllVenueRentalConfigurationsParams,) => {
    return [
    'venues-service-v1','venues',venueId,'rental-configurations',version, ...(params ? [params] : [])
    ] as const;
    }


export const getFindAllVenueRentalConfigurationsQueryOptions = <TData = Awaited<ReturnType<typeof findAllVenueRentalConfigurations>>, TError = ErrorType<unknown>>(venueId: string,
    version: string,
    params?: FindAllVenueRentalConfigurationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllVenueRentalConfigurations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllVenueRentalConfigurationsQueryKey(venueId,version,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllVenueRentalConfigurations>>> = () => findAllVenueRentalConfigurations(venueId,version,params, requestOptions);





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined && version !== null && version !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findAllVenueRentalConfigurations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllVenueRentalConfigurationsQueryResult = NonNullable<Awaited<ReturnType<typeof findAllVenueRentalConfigurations>>>
export type FindAllVenueRentalConfigurationsQueryError = ErrorType<unknown>


export function useFindAllVenueRentalConfigurations<TData = Awaited<ReturnType<typeof findAllVenueRentalConfigurations>>, TError = ErrorType<unknown>>(
 venueId: string,
    version: string,
    params: undefined |  FindAllVenueRentalConfigurationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllVenueRentalConfigurations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllVenueRentalConfigurations>>,
          TError,
          Awaited<ReturnType<typeof findAllVenueRentalConfigurations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllVenueRentalConfigurations<TData = Awaited<ReturnType<typeof findAllVenueRentalConfigurations>>, TError = ErrorType<unknown>>(
 venueId: string,
    version: string,
    params?: FindAllVenueRentalConfigurationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllVenueRentalConfigurations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllVenueRentalConfigurations>>,
          TError,
          Awaited<ReturnType<typeof findAllVenueRentalConfigurations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllVenueRentalConfigurations<TData = Awaited<ReturnType<typeof findAllVenueRentalConfigurations>>, TError = ErrorType<unknown>>(
 venueId: string,
    version: string,
    params?: FindAllVenueRentalConfigurationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllVenueRentalConfigurations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Rental Configurations
 */

export function useFindAllVenueRentalConfigurations<TData = Awaited<ReturnType<typeof findAllVenueRentalConfigurations>>, TError = ErrorType<unknown>>(
 venueId: string,
    version: string,
    params?: FindAllVenueRentalConfigurationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllVenueRentalConfigurations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllVenueRentalConfigurationsQueryOptions(venueId,version,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindAllVenueRentalConfigurationsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findAllVenueRentalConfigurations>>, TError = ErrorType<unknown>>(venueId: string,
    version: string,
    params?: FindAllVenueRentalConfigurationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueRentalConfigurations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllVenueRentalConfigurationsQueryKey(venueId,version,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllVenueRentalConfigurations>>> = () => findAllVenueRentalConfigurations(venueId,version,params, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueRentalConfigurations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllVenueRentalConfigurationsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findAllVenueRentalConfigurations>>>
export type FindAllVenueRentalConfigurationsSuspenseQueryError = ErrorType<unknown>


export function useFindAllVenueRentalConfigurationsSuspense<TData = Awaited<ReturnType<typeof findAllVenueRentalConfigurations>>, TError = ErrorType<unknown>>(
 venueId: string,
    version: string,
    params: undefined |  FindAllVenueRentalConfigurationsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueRentalConfigurations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllVenueRentalConfigurationsSuspense<TData = Awaited<ReturnType<typeof findAllVenueRentalConfigurations>>, TError = ErrorType<unknown>>(
 venueId: string,
    version: string,
    params?: FindAllVenueRentalConfigurationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueRentalConfigurations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllVenueRentalConfigurationsSuspense<TData = Awaited<ReturnType<typeof findAllVenueRentalConfigurations>>, TError = ErrorType<unknown>>(
 venueId: string,
    version: string,
    params?: FindAllVenueRentalConfigurationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueRentalConfigurations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Rental Configurations
 */

export function useFindAllVenueRentalConfigurationsSuspense<TData = Awaited<ReturnType<typeof findAllVenueRentalConfigurations>>, TError = ErrorType<unknown>>(
 venueId: string,
    version: string,
    params?: FindAllVenueRentalConfigurationsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueRentalConfigurations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllVenueRentalConfigurationsSuspenseQueryOptions(venueId,version,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Delete Rental Configuration
 */
export const deleteVenueRentalConfiguration = (
    venueId: string,
    configurationId: string,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<DeleteResponseType>(
      {url: `/venues-service-v1/venues/${venueId}/rental-configurations/${configurationId}`, method: 'DELETE'
    },
      options);
    }



export const getDeleteVenueRentalConfigurationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVenueRentalConfiguration>>, TError,{venueId: string;configurationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteVenueRentalConfiguration>>, TError,{venueId: string;configurationId: string}, TContext> => {

const mutationKey = ['deleteVenueRentalConfiguration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteVenueRentalConfiguration>>, {venueId: string;configurationId: string}> = (props) => {
          const {venueId,configurationId} = props ?? {};

          return  deleteVenueRentalConfiguration(venueId,configurationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteVenueRentalConfigurationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteVenueRentalConfiguration>>>

    export type DeleteVenueRentalConfigurationMutationError = ErrorType<unknown>

    /**
 * @summary Delete Rental Configuration
 */
export const useDeleteVenueRentalConfiguration = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVenueRentalConfiguration>>, TError,{venueId: string;configurationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteVenueRentalConfiguration>>,
        TError,
        {venueId: string;configurationId: string},
        TContext
      > => {
      return useMutation(getDeleteVenueRentalConfigurationMutationOptions(options), queryClient);
    }

/**
 * @summary Update Rental Configuration
 */
export const updateVenueRentalConfiguration = (
    venueId: string,
    configurationId: string,
    updateRentalConfigurationType?: BodyType<UpdateRentalConfigurationType>,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<UpdateVenueRentalConfiguration200>(
      {url: `/venues-service-v1/venues/${venueId}/rental-configurations/${configurationId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateRentalConfigurationType
    },
      options);
    }



export const getUpdateVenueRentalConfigurationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVenueRentalConfiguration>>, TError,{venueId: string;configurationId: string;data?: BodyType<UpdateRentalConfigurationType>}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateVenueRentalConfiguration>>, TError,{venueId: string;configurationId: string;data?: BodyType<UpdateRentalConfigurationType>}, TContext> => {

const mutationKey = ['updateVenueRentalConfiguration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateVenueRentalConfiguration>>, {venueId: string;configurationId: string;data?: BodyType<UpdateRentalConfigurationType>}> = (props) => {
          const {venueId,configurationId,data} = props ?? {};

          return  updateVenueRentalConfiguration(venueId,configurationId,data,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof updateVenueRentalConfiguration>>, variables: {venueId: string;configurationId: string;data?: BodyType<UpdateRentalConfigurationType>}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getFindAllVenueRentalVersionsQueryKey(variables.venueId) });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type UpdateVenueRentalConfigurationMutationResult = NonNullable<Awaited<ReturnType<typeof updateVenueRentalConfiguration>>>
    export type UpdateVenueRentalConfigurationMutationBody = BodyType<UpdateRentalConfigurationType> | undefined
    export type UpdateVenueRentalConfigurationMutationError = ErrorType<unknown>

    /**
 * @summary Update Rental Configuration
 */
export const useUpdateVenueRentalConfiguration = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVenueRentalConfiguration>>, TError,{venueId: string;configurationId: string;data?: BodyType<UpdateRentalConfigurationType>}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateVenueRentalConfiguration>>,
        TError,
        {venueId: string;configurationId: string;data?: BodyType<UpdateRentalConfigurationType>},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getUpdateVenueRentalConfigurationMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * @summary Create Rental Configuration
 */
export const createVenueRentalConfiguration = (
    venueId: string,
    createRentalConfigurationType?: BodyType<CreateRentalConfigurationType>,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<CreateVenueRentalConfiguration200>(
      {url: `/venues-service-v1/venues/${venueId}/rental-configurations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createRentalConfigurationType
    },
      options);
    }



export const getCreateVenueRentalConfigurationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVenueRentalConfiguration>>, TError,{venueId: string;data?: BodyType<CreateRentalConfigurationType>}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createVenueRentalConfiguration>>, TError,{venueId: string;data?: BodyType<CreateRentalConfigurationType>}, TContext> => {

const mutationKey = ['createVenueRentalConfiguration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createVenueRentalConfiguration>>, {venueId: string;data?: BodyType<CreateRentalConfigurationType>}> = (props) => {
          const {venueId,data} = props ?? {};

          return  createVenueRentalConfiguration(venueId,data,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof createVenueRentalConfiguration>>, variables: {venueId: string;data?: BodyType<CreateRentalConfigurationType>}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getFindAllVenueRentalVersionsQueryKey(variables.venueId) });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type CreateVenueRentalConfigurationMutationResult = NonNullable<Awaited<ReturnType<typeof createVenueRentalConfiguration>>>
    export type CreateVenueRentalConfigurationMutationBody = BodyType<CreateRentalConfigurationType> | undefined
    export type CreateVenueRentalConfigurationMutationError = ErrorType<unknown>

    /**
 * @summary Create Rental Configuration
 */
export const useCreateVenueRentalConfiguration = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVenueRentalConfiguration>>, TError,{venueId: string;data?: BodyType<CreateRentalConfigurationType>}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createVenueRentalConfiguration>>,
        TError,
        {venueId: string;data?: BodyType<CreateRentalConfigurationType>},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getCreateVenueRentalConfigurationMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * @summary Update Rental Configurations
 */
export const updateVenueRentalConfigurations = (
    venueId: string,
    updateRentalConfigurationsType?: BodyType<UpdateRentalConfigurationsType>,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<UpdateVenueRentalConfigurations200>(
      {url: `/venues-service-v1/venues/${venueId}/rental-configurations`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateRentalConfigurationsType
    },
      options);
    }



export const getUpdateVenueRentalConfigurationsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVenueRentalConfigurations>>, TError,{venueId: string;data?: BodyType<UpdateRentalConfigurationsType>}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateVenueRentalConfigurations>>, TError,{venueId: string;data?: BodyType<UpdateRentalConfigurationsType>}, TContext> => {

const mutationKey = ['updateVenueRentalConfigurations'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateVenueRentalConfigurations>>, {venueId: string;data?: BodyType<UpdateRentalConfigurationsType>}> = (props) => {
          const {venueId,data} = props ?? {};

          return  updateVenueRentalConfigurations(venueId,data,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof updateVenueRentalConfigurations>>, variables: {venueId: string;data?: BodyType<UpdateRentalConfigurationsType>}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getFindAllVenueRentalVersionsQueryKey(variables.venueId) });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type UpdateVenueRentalConfigurationsMutationResult = NonNullable<Awaited<ReturnType<typeof updateVenueRentalConfigurations>>>
    export type UpdateVenueRentalConfigurationsMutationBody = BodyType<UpdateRentalConfigurationsType> | undefined
    export type UpdateVenueRentalConfigurationsMutationError = ErrorType<unknown>

    /**
 * @summary Update Rental Configurations
 */
export const useUpdateVenueRentalConfigurations = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVenueRentalConfigurations>>, TError,{venueId: string;data?: BodyType<UpdateRentalConfigurationsType>}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateVenueRentalConfigurations>>,
        TError,
        {venueId: string;data?: BodyType<UpdateRentalConfigurationsType>},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getUpdateVenueRentalConfigurationsMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * @summary Get Rental Version Dates
 */
export const findAllVenueRentalVersions = (
    venueId: string,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<GetVenueRentalVersionDatesResponseType>(
      {url: `/venues-service-v1/venues/${venueId}/rental-configuration-version-dates`, method: 'GET'
    },
      options);
    }




export const getFindAllVenueRentalVersionsQueryKey = (venueId: string,) => {
    return [
    'venues-service-v1','venues',venueId,'rental-configuration-version-dates'
    ] as const;
    }


export const getFindAllVenueRentalVersionsQueryOptions = <TData = Awaited<ReturnType<typeof findAllVenueRentalVersions>>, TError = ErrorType<unknown>>(venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllVenueRentalVersions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllVenueRentalVersionsQueryKey(venueId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllVenueRentalVersions>>> = () => findAllVenueRentalVersions(venueId, requestOptions);





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findAllVenueRentalVersions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllVenueRentalVersionsQueryResult = NonNullable<Awaited<ReturnType<typeof findAllVenueRentalVersions>>>
export type FindAllVenueRentalVersionsQueryError = ErrorType<unknown>


export function useFindAllVenueRentalVersions<TData = Awaited<ReturnType<typeof findAllVenueRentalVersions>>, TError = ErrorType<unknown>>(
 venueId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllVenueRentalVersions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllVenueRentalVersions>>,
          TError,
          Awaited<ReturnType<typeof findAllVenueRentalVersions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllVenueRentalVersions<TData = Awaited<ReturnType<typeof findAllVenueRentalVersions>>, TError = ErrorType<unknown>>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllVenueRentalVersions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllVenueRentalVersions>>,
          TError,
          Awaited<ReturnType<typeof findAllVenueRentalVersions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllVenueRentalVersions<TData = Awaited<ReturnType<typeof findAllVenueRentalVersions>>, TError = ErrorType<unknown>>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllVenueRentalVersions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Rental Version Dates
 */

export function useFindAllVenueRentalVersions<TData = Awaited<ReturnType<typeof findAllVenueRentalVersions>>, TError = ErrorType<unknown>>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllVenueRentalVersions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllVenueRentalVersionsQueryOptions(venueId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindAllVenueRentalVersionsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findAllVenueRentalVersions>>, TError = ErrorType<unknown>>(venueId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueRentalVersions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllVenueRentalVersionsQueryKey(venueId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllVenueRentalVersions>>> = () => findAllVenueRentalVersions(venueId, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueRentalVersions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllVenueRentalVersionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findAllVenueRentalVersions>>>
export type FindAllVenueRentalVersionsSuspenseQueryError = ErrorType<unknown>


export function useFindAllVenueRentalVersionsSuspense<TData = Awaited<ReturnType<typeof findAllVenueRentalVersions>>, TError = ErrorType<unknown>>(
 venueId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueRentalVersions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllVenueRentalVersionsSuspense<TData = Awaited<ReturnType<typeof findAllVenueRentalVersions>>, TError = ErrorType<unknown>>(
 venueId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueRentalVersions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllVenueRentalVersionsSuspense<TData = Awaited<ReturnType<typeof findAllVenueRentalVersions>>, TError = ErrorType<unknown>>(
 venueId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueRentalVersions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Rental Version Dates
 */

export function useFindAllVenueRentalVersionsSuspense<TData = Awaited<ReturnType<typeof findAllVenueRentalVersions>>, TError = ErrorType<unknown>>(
 venueId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueRentalVersions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllVenueRentalVersionsSuspenseQueryOptions(venueId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Get Venue Shows
 */
export const findAllVenueShows = (
    id: string,
    params: FindAllVenueShowsParams,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<GetVenueShowsResponseType>(
      {url: `/venues-service-v1/venues/${id}/shows`, method: 'GET',
        params
    },
      options);
    }




export const getFindAllVenueShowsQueryKey = (id: string,
    params?: FindAllVenueShowsParams,) => {
    return [
    'venues-service-v1','venues',id,'shows', ...(params ? [params] : [])
    ] as const;
    }


export const getFindAllVenueShowsQueryOptions = <TData = Awaited<ReturnType<typeof findAllVenueShows>>, TError = ErrorType<unknown>>(id: string,
    params: FindAllVenueShowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllVenueShows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllVenueShowsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllVenueShows>>> = () => findAllVenueShows(id,params, requestOptions);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findAllVenueShows>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllVenueShowsQueryResult = NonNullable<Awaited<ReturnType<typeof findAllVenueShows>>>
export type FindAllVenueShowsQueryError = ErrorType<unknown>


export function useFindAllVenueShows<TData = Awaited<ReturnType<typeof findAllVenueShows>>, TError = ErrorType<unknown>>(
 id: string,
    params: FindAllVenueShowsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllVenueShows>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllVenueShows>>,
          TError,
          Awaited<ReturnType<typeof findAllVenueShows>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllVenueShows<TData = Awaited<ReturnType<typeof findAllVenueShows>>, TError = ErrorType<unknown>>(
 id: string,
    params: FindAllVenueShowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllVenueShows>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllVenueShows>>,
          TError,
          Awaited<ReturnType<typeof findAllVenueShows>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllVenueShows<TData = Awaited<ReturnType<typeof findAllVenueShows>>, TError = ErrorType<unknown>>(
 id: string,
    params: FindAllVenueShowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllVenueShows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Venue Shows
 */

export function useFindAllVenueShows<TData = Awaited<ReturnType<typeof findAllVenueShows>>, TError = ErrorType<unknown>>(
 id: string,
    params: FindAllVenueShowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllVenueShows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllVenueShowsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindAllVenueShowsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findAllVenueShows>>, TError = ErrorType<unknown>>(id: string,
    params: FindAllVenueShowsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueShows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllVenueShowsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllVenueShows>>> = () => findAllVenueShows(id,params, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueShows>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllVenueShowsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findAllVenueShows>>>
export type FindAllVenueShowsSuspenseQueryError = ErrorType<unknown>


export function useFindAllVenueShowsSuspense<TData = Awaited<ReturnType<typeof findAllVenueShows>>, TError = ErrorType<unknown>>(
 id: string,
    params: FindAllVenueShowsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueShows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllVenueShowsSuspense<TData = Awaited<ReturnType<typeof findAllVenueShows>>, TError = ErrorType<unknown>>(
 id: string,
    params: FindAllVenueShowsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueShows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllVenueShowsSuspense<TData = Awaited<ReturnType<typeof findAllVenueShows>>, TError = ErrorType<unknown>>(
 id: string,
    params: FindAllVenueShowsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueShows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Venue Shows
 */

export function useFindAllVenueShowsSuspense<TData = Awaited<ReturnType<typeof findAllVenueShows>>, TError = ErrorType<unknown>>(
 id: string,
    params: FindAllVenueShowsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueShows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllVenueShowsSuspenseQueryOptions(id,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Get Venue Holds
 */
export const findAllVenueHolds = (
    id: string,
    params: FindAllVenueHoldsParams,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<GetVenueHoldsResponseType>(
      {url: `/venues-service-v1/venues/${id}/holds`, method: 'GET',
        params
    },
      options);
    }




export const getFindAllVenueHoldsQueryKey = (id: string,
    params?: FindAllVenueHoldsParams,) => {
    return [
    'venues-service-v1','venues',id,'holds', ...(params ? [params] : [])
    ] as const;
    }


export const getFindAllVenueHoldsQueryOptions = <TData = Awaited<ReturnType<typeof findAllVenueHolds>>, TError = ErrorType<unknown>>(id: string,
    params: FindAllVenueHoldsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllVenueHolds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllVenueHoldsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllVenueHolds>>> = () => findAllVenueHolds(id,params, requestOptions);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findAllVenueHolds>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllVenueHoldsQueryResult = NonNullable<Awaited<ReturnType<typeof findAllVenueHolds>>>
export type FindAllVenueHoldsQueryError = ErrorType<unknown>


export function useFindAllVenueHolds<TData = Awaited<ReturnType<typeof findAllVenueHolds>>, TError = ErrorType<unknown>>(
 id: string,
    params: FindAllVenueHoldsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllVenueHolds>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllVenueHolds>>,
          TError,
          Awaited<ReturnType<typeof findAllVenueHolds>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllVenueHolds<TData = Awaited<ReturnType<typeof findAllVenueHolds>>, TError = ErrorType<unknown>>(
 id: string,
    params: FindAllVenueHoldsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllVenueHolds>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllVenueHolds>>,
          TError,
          Awaited<ReturnType<typeof findAllVenueHolds>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllVenueHolds<TData = Awaited<ReturnType<typeof findAllVenueHolds>>, TError = ErrorType<unknown>>(
 id: string,
    params: FindAllVenueHoldsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllVenueHolds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Venue Holds
 */

export function useFindAllVenueHolds<TData = Awaited<ReturnType<typeof findAllVenueHolds>>, TError = ErrorType<unknown>>(
 id: string,
    params: FindAllVenueHoldsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllVenueHolds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllVenueHoldsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindAllVenueHoldsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findAllVenueHolds>>, TError = ErrorType<unknown>>(id: string,
    params: FindAllVenueHoldsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueHolds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllVenueHoldsQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllVenueHolds>>> = () => findAllVenueHolds(id,params, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueHolds>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllVenueHoldsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findAllVenueHolds>>>
export type FindAllVenueHoldsSuspenseQueryError = ErrorType<unknown>


export function useFindAllVenueHoldsSuspense<TData = Awaited<ReturnType<typeof findAllVenueHolds>>, TError = ErrorType<unknown>>(
 id: string,
    params: FindAllVenueHoldsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueHolds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllVenueHoldsSuspense<TData = Awaited<ReturnType<typeof findAllVenueHolds>>, TError = ErrorType<unknown>>(
 id: string,
    params: FindAllVenueHoldsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueHolds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllVenueHoldsSuspense<TData = Awaited<ReturnType<typeof findAllVenueHolds>>, TError = ErrorType<unknown>>(
 id: string,
    params: FindAllVenueHoldsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueHolds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Venue Holds
 */

export function useFindAllVenueHoldsSuspense<TData = Awaited<ReturnType<typeof findAllVenueHolds>>, TError = ErrorType<unknown>>(
 id: string,
    params: FindAllVenueHoldsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueHolds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllVenueHoldsSuspenseQueryOptions(id,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Get Overview Version
 */
export const findVenueOverviewVersion = (
    venueId: string,
    overviewVersion: string,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<GetVenueOverviewVersionResponseType>(
      {url: `/venues-service-v1/venues/${venueId}/overviews/${overviewVersion}`, method: 'GET'
    },
      options);
    }




export const getFindVenueOverviewVersionQueryKey = (venueId: string,
    overviewVersion: string,) => {
    return [
    'venues-service-v1','venues',venueId,'overviews',overviewVersion
    ] as const;
    }


export const getFindVenueOverviewVersionQueryOptions = <TData = Awaited<ReturnType<typeof findVenueOverviewVersion>>, TError = ErrorType<unknown>>(venueId: string,
    overviewVersion: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findVenueOverviewVersion>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindVenueOverviewVersionQueryKey(venueId,overviewVersion);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findVenueOverviewVersion>>> = () => findVenueOverviewVersion(venueId,overviewVersion, requestOptions);





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined && overviewVersion !== null && overviewVersion !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findVenueOverviewVersion>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindVenueOverviewVersionQueryResult = NonNullable<Awaited<ReturnType<typeof findVenueOverviewVersion>>>
export type FindVenueOverviewVersionQueryError = ErrorType<unknown>


export function useFindVenueOverviewVersion<TData = Awaited<ReturnType<typeof findVenueOverviewVersion>>, TError = ErrorType<unknown>>(
 venueId: string,
    overviewVersion: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findVenueOverviewVersion>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findVenueOverviewVersion>>,
          TError,
          Awaited<ReturnType<typeof findVenueOverviewVersion>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindVenueOverviewVersion<TData = Awaited<ReturnType<typeof findVenueOverviewVersion>>, TError = ErrorType<unknown>>(
 venueId: string,
    overviewVersion: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findVenueOverviewVersion>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findVenueOverviewVersion>>,
          TError,
          Awaited<ReturnType<typeof findVenueOverviewVersion>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindVenueOverviewVersion<TData = Awaited<ReturnType<typeof findVenueOverviewVersion>>, TError = ErrorType<unknown>>(
 venueId: string,
    overviewVersion: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findVenueOverviewVersion>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Overview Version
 */

export function useFindVenueOverviewVersion<TData = Awaited<ReturnType<typeof findVenueOverviewVersion>>, TError = ErrorType<unknown>>(
 venueId: string,
    overviewVersion: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findVenueOverviewVersion>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindVenueOverviewVersionQueryOptions(venueId,overviewVersion,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindVenueOverviewVersionSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findVenueOverviewVersion>>, TError = ErrorType<unknown>>(venueId: string,
    overviewVersion: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findVenueOverviewVersion>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindVenueOverviewVersionQueryKey(venueId,overviewVersion);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findVenueOverviewVersion>>> = () => findVenueOverviewVersion(venueId,overviewVersion, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findVenueOverviewVersion>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindVenueOverviewVersionSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findVenueOverviewVersion>>>
export type FindVenueOverviewVersionSuspenseQueryError = ErrorType<unknown>


export function useFindVenueOverviewVersionSuspense<TData = Awaited<ReturnType<typeof findVenueOverviewVersion>>, TError = ErrorType<unknown>>(
 venueId: string,
    overviewVersion: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findVenueOverviewVersion>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindVenueOverviewVersionSuspense<TData = Awaited<ReturnType<typeof findVenueOverviewVersion>>, TError = ErrorType<unknown>>(
 venueId: string,
    overviewVersion: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findVenueOverviewVersion>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindVenueOverviewVersionSuspense<TData = Awaited<ReturnType<typeof findVenueOverviewVersion>>, TError = ErrorType<unknown>>(
 venueId: string,
    overviewVersion: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findVenueOverviewVersion>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Overview Version
 */

export function useFindVenueOverviewVersionSuspense<TData = Awaited<ReturnType<typeof findVenueOverviewVersion>>, TError = ErrorType<unknown>>(
 venueId: string,
    overviewVersion: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findVenueOverviewVersion>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindVenueOverviewVersionSuspenseQueryOptions(venueId,overviewVersion,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Update Overview Version
 */
export const updateVenueOverviewVersion = (
    venueId: string,
    overviewVersion: string,
    updateVenueOverviewVersionType?: BodyType<UpdateVenueOverviewVersionType>,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<UpdateVenueOverviewVersion200>(
      {url: `/venues-service-v1/venues/${venueId}/overviews/${overviewVersion}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateVenueOverviewVersionType
    },
      options);
    }



export const getUpdateVenueOverviewVersionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVenueOverviewVersion>>, TError,{venueId: string;overviewVersion: string;data?: BodyType<UpdateVenueOverviewVersionType>}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateVenueOverviewVersion>>, TError,{venueId: string;overviewVersion: string;data?: BodyType<UpdateVenueOverviewVersionType>}, TContext> => {

const mutationKey = ['updateVenueOverviewVersion'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateVenueOverviewVersion>>, {venueId: string;overviewVersion: string;data?: BodyType<UpdateVenueOverviewVersionType>}> = (props) => {
          const {venueId,overviewVersion,data} = props ?? {};

          return  updateVenueOverviewVersion(venueId,overviewVersion,data,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof updateVenueOverviewVersion>>, variables: {venueId: string;overviewVersion: string;data?: BodyType<UpdateVenueOverviewVersionType>}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getFindAllVenueOverviewVersionsQueryKey(variables.venueId) });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type UpdateVenueOverviewVersionMutationResult = NonNullable<Awaited<ReturnType<typeof updateVenueOverviewVersion>>>
    export type UpdateVenueOverviewVersionMutationBody = BodyType<UpdateVenueOverviewVersionType> | undefined
    export type UpdateVenueOverviewVersionMutationError = ErrorType<unknown>

    /**
 * @summary Update Overview Version
 */
export const useUpdateVenueOverviewVersion = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVenueOverviewVersion>>, TError,{venueId: string;overviewVersion: string;data?: BodyType<UpdateVenueOverviewVersionType>}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateVenueOverviewVersion>>,
        TError,
        {venueId: string;overviewVersion: string;data?: BodyType<UpdateVenueOverviewVersionType>},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getUpdateVenueOverviewVersionMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * @summary Delete Overview Version
 */
export const deleteVenueOverviewVersion = (
    venueId: string,
    overviewVersion: string,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<DeleteResponseType>(
      {url: `/venues-service-v1/venues/${venueId}/overviews/${overviewVersion}`, method: 'DELETE'
    },
      options);
    }



export const getDeleteVenueOverviewVersionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVenueOverviewVersion>>, TError,{venueId: string;overviewVersion: string}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteVenueOverviewVersion>>, TError,{venueId: string;overviewVersion: string}, TContext> => {

const mutationKey = ['deleteVenueOverviewVersion'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteVenueOverviewVersion>>, {venueId: string;overviewVersion: string}> = (props) => {
          const {venueId,overviewVersion} = props ?? {};

          return  deleteVenueOverviewVersion(venueId,overviewVersion,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof deleteVenueOverviewVersion>>, variables: {venueId: string;overviewVersion: string}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getFindAllVenueOverviewVersionsQueryKey(variables.venueId) });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type DeleteVenueOverviewVersionMutationResult = NonNullable<Awaited<ReturnType<typeof deleteVenueOverviewVersion>>>

    export type DeleteVenueOverviewVersionMutationError = ErrorType<unknown>

    /**
 * @summary Delete Overview Version
 */
export const useDeleteVenueOverviewVersion = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVenueOverviewVersion>>, TError,{venueId: string;overviewVersion: string}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteVenueOverviewVersion>>,
        TError,
        {venueId: string;overviewVersion: string},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getDeleteVenueOverviewVersionMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * @summary Get Overview Versions
 */
export const findAllVenueOverviewVersions = (
    venueId: string,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<GetVenueOverviewVersionsResponseType>(
      {url: `/venues-service-v1/venues/${venueId}/overviews`, method: 'GET'
    },
      options);
    }




export const getFindAllVenueOverviewVersionsQueryKey = (venueId: string,) => {
    return [
    'venues-service-v1','venues',venueId,'overviews'
    ] as const;
    }


export const getFindAllVenueOverviewVersionsQueryOptions = <TData = Awaited<ReturnType<typeof findAllVenueOverviewVersions>>, TError = ErrorType<unknown>>(venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllVenueOverviewVersions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllVenueOverviewVersionsQueryKey(venueId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllVenueOverviewVersions>>> = () => findAllVenueOverviewVersions(venueId, requestOptions);





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findAllVenueOverviewVersions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllVenueOverviewVersionsQueryResult = NonNullable<Awaited<ReturnType<typeof findAllVenueOverviewVersions>>>
export type FindAllVenueOverviewVersionsQueryError = ErrorType<unknown>


export function useFindAllVenueOverviewVersions<TData = Awaited<ReturnType<typeof findAllVenueOverviewVersions>>, TError = ErrorType<unknown>>(
 venueId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllVenueOverviewVersions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllVenueOverviewVersions>>,
          TError,
          Awaited<ReturnType<typeof findAllVenueOverviewVersions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllVenueOverviewVersions<TData = Awaited<ReturnType<typeof findAllVenueOverviewVersions>>, TError = ErrorType<unknown>>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllVenueOverviewVersions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllVenueOverviewVersions>>,
          TError,
          Awaited<ReturnType<typeof findAllVenueOverviewVersions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllVenueOverviewVersions<TData = Awaited<ReturnType<typeof findAllVenueOverviewVersions>>, TError = ErrorType<unknown>>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllVenueOverviewVersions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Overview Versions
 */

export function useFindAllVenueOverviewVersions<TData = Awaited<ReturnType<typeof findAllVenueOverviewVersions>>, TError = ErrorType<unknown>>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllVenueOverviewVersions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllVenueOverviewVersionsQueryOptions(venueId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindAllVenueOverviewVersionsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findAllVenueOverviewVersions>>, TError = ErrorType<unknown>>(venueId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueOverviewVersions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllVenueOverviewVersionsQueryKey(venueId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllVenueOverviewVersions>>> = () => findAllVenueOverviewVersions(venueId, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueOverviewVersions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllVenueOverviewVersionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findAllVenueOverviewVersions>>>
export type FindAllVenueOverviewVersionsSuspenseQueryError = ErrorType<unknown>


export function useFindAllVenueOverviewVersionsSuspense<TData = Awaited<ReturnType<typeof findAllVenueOverviewVersions>>, TError = ErrorType<unknown>>(
 venueId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueOverviewVersions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllVenueOverviewVersionsSuspense<TData = Awaited<ReturnType<typeof findAllVenueOverviewVersions>>, TError = ErrorType<unknown>>(
 venueId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueOverviewVersions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllVenueOverviewVersionsSuspense<TData = Awaited<ReturnType<typeof findAllVenueOverviewVersions>>, TError = ErrorType<unknown>>(
 venueId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueOverviewVersions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Overview Versions
 */

export function useFindAllVenueOverviewVersionsSuspense<TData = Awaited<ReturnType<typeof findAllVenueOverviewVersions>>, TError = ErrorType<unknown>>(
 venueId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueOverviewVersions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllVenueOverviewVersionsSuspenseQueryOptions(venueId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Create Overview Version
 */
export const createVenueOverviewVersion = (
    venueId: string,
    createVenueOverviewVersionRequestType?: BodyType<CreateVenueOverviewVersionRequestType>,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<CreateVenueOverviewVersion200>(
      {url: `/venues-service-v1/venues/${venueId}/overviews`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createVenueOverviewVersionRequestType
    },
      options);
    }



export const getCreateVenueOverviewVersionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVenueOverviewVersion>>, TError,{venueId: string;data?: BodyType<CreateVenueOverviewVersionRequestType>}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createVenueOverviewVersion>>, TError,{venueId: string;data?: BodyType<CreateVenueOverviewVersionRequestType>}, TContext> => {

const mutationKey = ['createVenueOverviewVersion'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createVenueOverviewVersion>>, {venueId: string;data?: BodyType<CreateVenueOverviewVersionRequestType>}> = (props) => {
          const {venueId,data} = props ?? {};

          return  createVenueOverviewVersion(venueId,data,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof createVenueOverviewVersion>>, variables: {venueId: string;data?: BodyType<CreateVenueOverviewVersionRequestType>}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getFindAllVenueOverviewVersionsQueryKey(variables.venueId) });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type CreateVenueOverviewVersionMutationResult = NonNullable<Awaited<ReturnType<typeof createVenueOverviewVersion>>>
    export type CreateVenueOverviewVersionMutationBody = BodyType<CreateVenueOverviewVersionRequestType> | undefined
    export type CreateVenueOverviewVersionMutationError = ErrorType<unknown>

    /**
 * @summary Create Overview Version
 */
export const useCreateVenueOverviewVersion = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVenueOverviewVersion>>, TError,{venueId: string;data?: BodyType<CreateVenueOverviewVersionRequestType>}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createVenueOverviewVersion>>,
        TError,
        {venueId: string;data?: BodyType<CreateVenueOverviewVersionRequestType>},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getCreateVenueOverviewVersionMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * @summary Get FB Contacts
 */
export const findAllVenueFBContacts = (
    venueId: string,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<GetVenueFBContactsResponseType>(
      {url: `/venues-service-v1/venues/${venueId}/fbContacts`, method: 'GET'
    },
      options);
    }




export const getFindAllVenueFBContactsQueryKey = (venueId: string,) => {
    return [
    'venues-service-v1','venues',venueId,'fbContacts'
    ] as const;
    }


export const getFindAllVenueFBContactsQueryOptions = <TData = Awaited<ReturnType<typeof findAllVenueFBContacts>>, TError = ErrorType<unknown>>(venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllVenueFBContacts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllVenueFBContactsQueryKey(venueId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllVenueFBContacts>>> = () => findAllVenueFBContacts(venueId, requestOptions);





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findAllVenueFBContacts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllVenueFBContactsQueryResult = NonNullable<Awaited<ReturnType<typeof findAllVenueFBContacts>>>
export type FindAllVenueFBContactsQueryError = ErrorType<unknown>


export function useFindAllVenueFBContacts<TData = Awaited<ReturnType<typeof findAllVenueFBContacts>>, TError = ErrorType<unknown>>(
 venueId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllVenueFBContacts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllVenueFBContacts>>,
          TError,
          Awaited<ReturnType<typeof findAllVenueFBContacts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllVenueFBContacts<TData = Awaited<ReturnType<typeof findAllVenueFBContacts>>, TError = ErrorType<unknown>>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllVenueFBContacts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllVenueFBContacts>>,
          TError,
          Awaited<ReturnType<typeof findAllVenueFBContacts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllVenueFBContacts<TData = Awaited<ReturnType<typeof findAllVenueFBContacts>>, TError = ErrorType<unknown>>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllVenueFBContacts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get FB Contacts
 */

export function useFindAllVenueFBContacts<TData = Awaited<ReturnType<typeof findAllVenueFBContacts>>, TError = ErrorType<unknown>>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllVenueFBContacts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllVenueFBContactsQueryOptions(venueId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindAllVenueFBContactsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findAllVenueFBContacts>>, TError = ErrorType<unknown>>(venueId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueFBContacts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllVenueFBContactsQueryKey(venueId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllVenueFBContacts>>> = () => findAllVenueFBContacts(venueId, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueFBContacts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllVenueFBContactsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findAllVenueFBContacts>>>
export type FindAllVenueFBContactsSuspenseQueryError = ErrorType<unknown>


export function useFindAllVenueFBContactsSuspense<TData = Awaited<ReturnType<typeof findAllVenueFBContacts>>, TError = ErrorType<unknown>>(
 venueId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueFBContacts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllVenueFBContactsSuspense<TData = Awaited<ReturnType<typeof findAllVenueFBContacts>>, TError = ErrorType<unknown>>(
 venueId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueFBContacts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllVenueFBContactsSuspense<TData = Awaited<ReturnType<typeof findAllVenueFBContacts>>, TError = ErrorType<unknown>>(
 venueId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueFBContacts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get FB Contacts
 */

export function useFindAllVenueFBContactsSuspense<TData = Awaited<ReturnType<typeof findAllVenueFBContacts>>, TError = ErrorType<unknown>>(
 venueId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueFBContacts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllVenueFBContactsSuspenseQueryOptions(venueId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Get Merch Contacts
 */
export const findAllVenueMerchContacts = (
    venueId: string,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<GetVenueMerchContactsResponseType>(
      {url: `/venues-service-v1/venues/${venueId}/merchContacts`, method: 'GET'
    },
      options);
    }




export const getFindAllVenueMerchContactsQueryKey = (venueId: string,) => {
    return [
    'venues-service-v1','venues',venueId,'merchContacts'
    ] as const;
    }


export const getFindAllVenueMerchContactsQueryOptions = <TData = Awaited<ReturnType<typeof findAllVenueMerchContacts>>, TError = ErrorType<unknown>>(venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllVenueMerchContacts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllVenueMerchContactsQueryKey(venueId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllVenueMerchContacts>>> = () => findAllVenueMerchContacts(venueId, requestOptions);





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findAllVenueMerchContacts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllVenueMerchContactsQueryResult = NonNullable<Awaited<ReturnType<typeof findAllVenueMerchContacts>>>
export type FindAllVenueMerchContactsQueryError = ErrorType<unknown>


export function useFindAllVenueMerchContacts<TData = Awaited<ReturnType<typeof findAllVenueMerchContacts>>, TError = ErrorType<unknown>>(
 venueId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllVenueMerchContacts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllVenueMerchContacts>>,
          TError,
          Awaited<ReturnType<typeof findAllVenueMerchContacts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllVenueMerchContacts<TData = Awaited<ReturnType<typeof findAllVenueMerchContacts>>, TError = ErrorType<unknown>>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllVenueMerchContacts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllVenueMerchContacts>>,
          TError,
          Awaited<ReturnType<typeof findAllVenueMerchContacts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllVenueMerchContacts<TData = Awaited<ReturnType<typeof findAllVenueMerchContacts>>, TError = ErrorType<unknown>>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllVenueMerchContacts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Merch Contacts
 */

export function useFindAllVenueMerchContacts<TData = Awaited<ReturnType<typeof findAllVenueMerchContacts>>, TError = ErrorType<unknown>>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllVenueMerchContacts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllVenueMerchContactsQueryOptions(venueId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindAllVenueMerchContactsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findAllVenueMerchContacts>>, TError = ErrorType<unknown>>(venueId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueMerchContacts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllVenueMerchContactsQueryKey(venueId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllVenueMerchContacts>>> = () => findAllVenueMerchContacts(venueId, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueMerchContacts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllVenueMerchContactsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findAllVenueMerchContacts>>>
export type FindAllVenueMerchContactsSuspenseQueryError = ErrorType<unknown>


export function useFindAllVenueMerchContactsSuspense<TData = Awaited<ReturnType<typeof findAllVenueMerchContacts>>, TError = ErrorType<unknown>>(
 venueId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueMerchContacts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllVenueMerchContactsSuspense<TData = Awaited<ReturnType<typeof findAllVenueMerchContacts>>, TError = ErrorType<unknown>>(
 venueId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueMerchContacts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllVenueMerchContactsSuspense<TData = Awaited<ReturnType<typeof findAllVenueMerchContacts>>, TError = ErrorType<unknown>>(
 venueId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueMerchContacts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Merch Contacts
 */

export function useFindAllVenueMerchContactsSuspense<TData = Awaited<ReturnType<typeof findAllVenueMerchContacts>>, TError = ErrorType<unknown>>(
 venueId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueMerchContacts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllVenueMerchContactsSuspenseQueryOptions(venueId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Get Venues List
 */
export const findAllVenues = (
    params?: FindAllVenuesParams,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<GetVenuesListResponseType>(
      {url: `/venues-service-v1/venues`, method: 'GET',
        params
    },
      options);
    }




export const getFindAllVenuesQueryKey = (params?: FindAllVenuesParams,) => {
    return [
    'venues-service-v1','venues', ...(params ? [params] : [])
    ] as const;
    }


export const getFindAllVenuesQueryOptions = <TData = Awaited<ReturnType<typeof findAllVenues>>, TError = ErrorType<unknown>>(params?: FindAllVenuesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllVenues>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllVenuesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllVenues>>> = () => findAllVenues(params, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findAllVenues>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllVenuesQueryResult = NonNullable<Awaited<ReturnType<typeof findAllVenues>>>
export type FindAllVenuesQueryError = ErrorType<unknown>


export function useFindAllVenues<TData = Awaited<ReturnType<typeof findAllVenues>>, TError = ErrorType<unknown>>(
 params: undefined |  FindAllVenuesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllVenues>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllVenues>>,
          TError,
          Awaited<ReturnType<typeof findAllVenues>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllVenues<TData = Awaited<ReturnType<typeof findAllVenues>>, TError = ErrorType<unknown>>(
 params?: FindAllVenuesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllVenues>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllVenues>>,
          TError,
          Awaited<ReturnType<typeof findAllVenues>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllVenues<TData = Awaited<ReturnType<typeof findAllVenues>>, TError = ErrorType<unknown>>(
 params?: FindAllVenuesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllVenues>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Venues List
 */

export function useFindAllVenues<TData = Awaited<ReturnType<typeof findAllVenues>>, TError = ErrorType<unknown>>(
 params?: FindAllVenuesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllVenues>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllVenuesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindAllVenuesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findAllVenues>>, TError = ErrorType<unknown>>(params?: FindAllVenuesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenues>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllVenuesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllVenues>>> = () => findAllVenues(params, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenues>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllVenuesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findAllVenues>>>
export type FindAllVenuesSuspenseQueryError = ErrorType<unknown>


export function useFindAllVenuesSuspense<TData = Awaited<ReturnType<typeof findAllVenues>>, TError = ErrorType<unknown>>(
 params: undefined |  FindAllVenuesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenues>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllVenuesSuspense<TData = Awaited<ReturnType<typeof findAllVenues>>, TError = ErrorType<unknown>>(
 params?: FindAllVenuesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenues>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllVenuesSuspense<TData = Awaited<ReturnType<typeof findAllVenues>>, TError = ErrorType<unknown>>(
 params?: FindAllVenuesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenues>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Venues List
 */

export function useFindAllVenuesSuspense<TData = Awaited<ReturnType<typeof findAllVenues>>, TError = ErrorType<unknown>>(
 params?: FindAllVenuesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenues>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllVenuesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Create Venue
 */
export const createVenue = (
    createVenueType?: BodyType<CreateVenueType>,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<CreateVenue200>(
      {url: `/venues-service-v1/venues`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createVenueType
    },
      options);
    }



export const getCreateVenueMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVenue>>, TError,{data?: BodyType<CreateVenueType>}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createVenue>>, TError,{data?: BodyType<CreateVenueType>}, TContext> => {

const mutationKey = ['createVenue'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createVenue>>, {data?: BodyType<CreateVenueType>}> = (props) => {
          const {data} = props ?? {};

          return  createVenue(data,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof createVenue>>, variables: {data?: BodyType<CreateVenueType>}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getFindAllVenuesQueryKey() });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type CreateVenueMutationResult = NonNullable<Awaited<ReturnType<typeof createVenue>>>
    export type CreateVenueMutationBody = BodyType<CreateVenueType> | undefined
    export type CreateVenueMutationError = ErrorType<unknown>

    /**
 * @summary Create Venue
 */
export const useCreateVenue = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVenue>>, TError,{data?: BodyType<CreateVenueType>}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createVenue>>,
        TError,
        {data?: BodyType<CreateVenueType>},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getCreateVenueMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * @summary Get Venue Categories
 */
export const findVenueCategories = (

 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<GetVenueCategoriesResponseType>(
      {url: `/venues-service-v1/categories`, method: 'GET'
    },
      options);
    }




export const getFindVenueCategoriesQueryKey = () => {
    return [
    'venues-service-v1','categories'
    ] as const;
    }


export const getFindVenueCategoriesQueryOptions = <TData = Awaited<ReturnType<typeof findVenueCategories>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findVenueCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindVenueCategoriesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findVenueCategories>>> = () => findVenueCategories(requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findVenueCategories>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindVenueCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof findVenueCategories>>>
export type FindVenueCategoriesQueryError = ErrorType<unknown>


export function useFindVenueCategories<TData = Awaited<ReturnType<typeof findVenueCategories>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findVenueCategories>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findVenueCategories>>,
          TError,
          Awaited<ReturnType<typeof findVenueCategories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindVenueCategories<TData = Awaited<ReturnType<typeof findVenueCategories>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findVenueCategories>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findVenueCategories>>,
          TError,
          Awaited<ReturnType<typeof findVenueCategories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindVenueCategories<TData = Awaited<ReturnType<typeof findVenueCategories>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findVenueCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Venue Categories
 */

export function useFindVenueCategories<TData = Awaited<ReturnType<typeof findVenueCategories>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findVenueCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindVenueCategoriesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindVenueCategoriesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findVenueCategories>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findVenueCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindVenueCategoriesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findVenueCategories>>> = () => findVenueCategories(requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findVenueCategories>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindVenueCategoriesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findVenueCategories>>>
export type FindVenueCategoriesSuspenseQueryError = ErrorType<unknown>


export function useFindVenueCategoriesSuspense<TData = Awaited<ReturnType<typeof findVenueCategories>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findVenueCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindVenueCategoriesSuspense<TData = Awaited<ReturnType<typeof findVenueCategories>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findVenueCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindVenueCategoriesSuspense<TData = Awaited<ReturnType<typeof findVenueCategories>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findVenueCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Venue Categories
 */

export function useFindVenueCategoriesSuspense<TData = Awaited<ReturnType<typeof findVenueCategories>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findVenueCategories>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindVenueCategoriesSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Get Venue Files
 */
export const findAllVenueFiles = (
    venueId: string,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<GetVenueFilesResponseType>(
      {url: `/venues-service-v1/venues/${venueId}/files`, method: 'GET'
    },
      options);
    }




export const getFindAllVenueFilesQueryKey = (venueId: string,) => {
    return [
    'venues-service-v1','venues',venueId,'files'
    ] as const;
    }


export const getFindAllVenueFilesQueryOptions = <TData = Awaited<ReturnType<typeof findAllVenueFiles>>, TError = ErrorType<unknown>>(venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllVenueFiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllVenueFilesQueryKey(venueId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllVenueFiles>>> = () => findAllVenueFiles(venueId, requestOptions);





   return  { queryKey, queryFn, enabled: venueId !== null && venueId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findAllVenueFiles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllVenueFilesQueryResult = NonNullable<Awaited<ReturnType<typeof findAllVenueFiles>>>
export type FindAllVenueFilesQueryError = ErrorType<unknown>


export function useFindAllVenueFiles<TData = Awaited<ReturnType<typeof findAllVenueFiles>>, TError = ErrorType<unknown>>(
 venueId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllVenueFiles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllVenueFiles>>,
          TError,
          Awaited<ReturnType<typeof findAllVenueFiles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllVenueFiles<TData = Awaited<ReturnType<typeof findAllVenueFiles>>, TError = ErrorType<unknown>>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllVenueFiles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllVenueFiles>>,
          TError,
          Awaited<ReturnType<typeof findAllVenueFiles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllVenueFiles<TData = Awaited<ReturnType<typeof findAllVenueFiles>>, TError = ErrorType<unknown>>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllVenueFiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Venue Files
 */

export function useFindAllVenueFiles<TData = Awaited<ReturnType<typeof findAllVenueFiles>>, TError = ErrorType<unknown>>(
 venueId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllVenueFiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllVenueFilesQueryOptions(venueId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindAllVenueFilesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findAllVenueFiles>>, TError = ErrorType<unknown>>(venueId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueFiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllVenueFilesQueryKey(venueId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllVenueFiles>>> = () => findAllVenueFiles(venueId, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueFiles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllVenueFilesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findAllVenueFiles>>>
export type FindAllVenueFilesSuspenseQueryError = ErrorType<unknown>


export function useFindAllVenueFilesSuspense<TData = Awaited<ReturnType<typeof findAllVenueFiles>>, TError = ErrorType<unknown>>(
 venueId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueFiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllVenueFilesSuspense<TData = Awaited<ReturnType<typeof findAllVenueFiles>>, TError = ErrorType<unknown>>(
 venueId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueFiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllVenueFilesSuspense<TData = Awaited<ReturnType<typeof findAllVenueFiles>>, TError = ErrorType<unknown>>(
 venueId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueFiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Venue Files
 */

export function useFindAllVenueFilesSuspense<TData = Awaited<ReturnType<typeof findAllVenueFiles>>, TError = ErrorType<unknown>>(
 venueId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllVenueFiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllVenueFilesSuspenseQueryOptions(venueId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Get Artist List
 */
export const findAllArtists = (
    params?: FindAllArtistsParams,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<GetArtistListResponseType>(
      {url: `/artist-service-v1/artists`, method: 'GET',
        params
    },
      options);
    }




export const getFindAllArtistsQueryKey = (params?: FindAllArtistsParams,) => {
    return [
    'artist-service-v1','artists', ...(params ? [params] : [])
    ] as const;
    }


export const getFindAllArtistsQueryOptions = <TData = Awaited<ReturnType<typeof findAllArtists>>, TError = ErrorType<unknown>>(params?: FindAllArtistsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllArtists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllArtistsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllArtists>>> = () => findAllArtists(params, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findAllArtists>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllArtistsQueryResult = NonNullable<Awaited<ReturnType<typeof findAllArtists>>>
export type FindAllArtistsQueryError = ErrorType<unknown>


export function useFindAllArtists<TData = Awaited<ReturnType<typeof findAllArtists>>, TError = ErrorType<unknown>>(
 params: undefined |  FindAllArtistsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllArtists>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllArtists>>,
          TError,
          Awaited<ReturnType<typeof findAllArtists>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllArtists<TData = Awaited<ReturnType<typeof findAllArtists>>, TError = ErrorType<unknown>>(
 params?: FindAllArtistsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllArtists>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllArtists>>,
          TError,
          Awaited<ReturnType<typeof findAllArtists>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllArtists<TData = Awaited<ReturnType<typeof findAllArtists>>, TError = ErrorType<unknown>>(
 params?: FindAllArtistsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllArtists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Artist List
 */

export function useFindAllArtists<TData = Awaited<ReturnType<typeof findAllArtists>>, TError = ErrorType<unknown>>(
 params?: FindAllArtistsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllArtists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllArtistsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindAllArtistsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findAllArtists>>, TError = ErrorType<unknown>>(params?: FindAllArtistsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllArtists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllArtistsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllArtists>>> = () => findAllArtists(params, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllArtists>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllArtistsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findAllArtists>>>
export type FindAllArtistsSuspenseQueryError = ErrorType<unknown>


export function useFindAllArtistsSuspense<TData = Awaited<ReturnType<typeof findAllArtists>>, TError = ErrorType<unknown>>(
 params: undefined |  FindAllArtistsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllArtists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllArtistsSuspense<TData = Awaited<ReturnType<typeof findAllArtists>>, TError = ErrorType<unknown>>(
 params?: FindAllArtistsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllArtists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllArtistsSuspense<TData = Awaited<ReturnType<typeof findAllArtists>>, TError = ErrorType<unknown>>(
 params?: FindAllArtistsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllArtists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Artist List
 */

export function useFindAllArtistsSuspense<TData = Awaited<ReturnType<typeof findAllArtists>>, TError = ErrorType<unknown>>(
 params?: FindAllArtistsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllArtists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllArtistsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Create Artist
 */
export const createArtist = (
    createArtistType?: BodyType<CreateArtistType>,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<CreateArtist200>(
      {url: `/artist-service-v1/artists`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createArtistType
    },
      options);
    }



export const getCreateArtistMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createArtist>>, TError,{data?: BodyType<CreateArtistType>}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createArtist>>, TError,{data?: BodyType<CreateArtistType>}, TContext> => {

const mutationKey = ['createArtist'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createArtist>>, {data?: BodyType<CreateArtistType>}> = (props) => {
          const {data} = props ?? {};

          return  createArtist(data,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof createArtist>>, variables: {data?: BodyType<CreateArtistType>}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getFindAllArtistsQueryKey() });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type CreateArtistMutationResult = NonNullable<Awaited<ReturnType<typeof createArtist>>>
    export type CreateArtistMutationBody = BodyType<CreateArtistType> | undefined
    export type CreateArtistMutationError = ErrorType<unknown>

    /**
 * @summary Create Artist
 */
export const useCreateArtist = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createArtist>>, TError,{data?: BodyType<CreateArtistType>}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createArtist>>,
        TError,
        {data?: BodyType<CreateArtistType>},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getCreateArtistMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * @summary Get Artist
 */
export const findArtist = (
    artistId: string,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<GetArtistResponseType>(
      {url: `/artist-service-v1/artists/${artistId}`, method: 'GET'
    },
      options);
    }




export const getFindArtistQueryKey = (artistId: string,) => {
    return [
    'artist-service-v1','artists',artistId
    ] as const;
    }


export const getFindArtistQueryOptions = <TData = Awaited<ReturnType<typeof findArtist>>, TError = ErrorType<unknown>>(artistId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findArtist>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindArtistQueryKey(artistId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findArtist>>> = () => findArtist(artistId, requestOptions);





   return  { queryKey, queryFn, enabled: artistId !== null && artistId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findArtist>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindArtistQueryResult = NonNullable<Awaited<ReturnType<typeof findArtist>>>
export type FindArtistQueryError = ErrorType<unknown>


export function useFindArtist<TData = Awaited<ReturnType<typeof findArtist>>, TError = ErrorType<unknown>>(
 artistId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findArtist>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findArtist>>,
          TError,
          Awaited<ReturnType<typeof findArtist>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindArtist<TData = Awaited<ReturnType<typeof findArtist>>, TError = ErrorType<unknown>>(
 artistId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findArtist>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findArtist>>,
          TError,
          Awaited<ReturnType<typeof findArtist>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindArtist<TData = Awaited<ReturnType<typeof findArtist>>, TError = ErrorType<unknown>>(
 artistId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findArtist>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Artist
 */

export function useFindArtist<TData = Awaited<ReturnType<typeof findArtist>>, TError = ErrorType<unknown>>(
 artistId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findArtist>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindArtistQueryOptions(artistId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindArtistSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findArtist>>, TError = ErrorType<unknown>>(artistId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findArtist>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindArtistQueryKey(artistId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findArtist>>> = () => findArtist(artistId, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findArtist>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindArtistSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findArtist>>>
export type FindArtistSuspenseQueryError = ErrorType<unknown>


export function useFindArtistSuspense<TData = Awaited<ReturnType<typeof findArtist>>, TError = ErrorType<unknown>>(
 artistId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findArtist>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindArtistSuspense<TData = Awaited<ReturnType<typeof findArtist>>, TError = ErrorType<unknown>>(
 artistId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findArtist>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindArtistSuspense<TData = Awaited<ReturnType<typeof findArtist>>, TError = ErrorType<unknown>>(
 artistId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findArtist>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Artist
 */

export function useFindArtistSuspense<TData = Awaited<ReturnType<typeof findArtist>>, TError = ErrorType<unknown>>(
 artistId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findArtist>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindArtistSuspenseQueryOptions(artistId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Delete Artist
 */
export const deleteArtist = (
    artistId: string,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<DeleteResponseType>(
      {url: `/artist-service-v1/artists/${artistId}`, method: 'DELETE'
    },
      options);
    }



export const getDeleteArtistMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteArtist>>, TError,{artistId: string}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteArtist>>, TError,{artistId: string}, TContext> => {

const mutationKey = ['deleteArtist'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteArtist>>, {artistId: string}> = (props) => {
          const {artistId} = props ?? {};

          return  deleteArtist(artistId,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof deleteArtist>>, variables: {artistId: string}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getFindAllArtistsQueryKey() });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type DeleteArtistMutationResult = NonNullable<Awaited<ReturnType<typeof deleteArtist>>>

    export type DeleteArtistMutationError = ErrorType<unknown>

    /**
 * @summary Delete Artist
 */
export const useDeleteArtist = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteArtist>>, TError,{artistId: string}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteArtist>>,
        TError,
        {artistId: string},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getDeleteArtistMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * @summary Update Artist
 */
export const updateArtist = (
    artistId: string,
    updateArtistType?: BodyType<UpdateArtistType>,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<UpdateArtist200>(
      {url: `/artist-service-v1/artists/${artistId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateArtistType
    },
      options);
    }



export const getUpdateArtistMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateArtist>>, TError,{artistId: string;data?: BodyType<UpdateArtistType>}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateArtist>>, TError,{artistId: string;data?: BodyType<UpdateArtistType>}, TContext> => {

const mutationKey = ['updateArtist'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateArtist>>, {artistId: string;data?: BodyType<UpdateArtistType>}> = (props) => {
          const {artistId,data} = props ?? {};

          return  updateArtist(artistId,data,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof updateArtist>>, variables: {artistId: string;data?: BodyType<UpdateArtistType>}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getFindAllArtistsQueryKey() });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type UpdateArtistMutationResult = NonNullable<Awaited<ReturnType<typeof updateArtist>>>
    export type UpdateArtistMutationBody = BodyType<UpdateArtistType> | undefined
    export type UpdateArtistMutationError = ErrorType<unknown>

    /**
 * @summary Update Artist
 */
export const useUpdateArtist = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateArtist>>, TError,{artistId: string;data?: BodyType<UpdateArtistType>}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateArtist>>,
        TError,
        {artistId: string;data?: BodyType<UpdateArtistType>},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getUpdateArtistMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * @summary Get Artist Genres
 */
export const findArtistGenres = (

 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<GetArtistGenresResponseType>(
      {url: `/artist-service-v1/genres`, method: 'GET'
    },
      options);
    }




export const getFindArtistGenresQueryKey = () => {
    return [
    'artist-service-v1','genres'
    ] as const;
    }


export const getFindArtistGenresQueryOptions = <TData = Awaited<ReturnType<typeof findArtistGenres>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findArtistGenres>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindArtistGenresQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findArtistGenres>>> = () => findArtistGenres(requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findArtistGenres>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindArtistGenresQueryResult = NonNullable<Awaited<ReturnType<typeof findArtistGenres>>>
export type FindArtistGenresQueryError = ErrorType<unknown>


export function useFindArtistGenres<TData = Awaited<ReturnType<typeof findArtistGenres>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findArtistGenres>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findArtistGenres>>,
          TError,
          Awaited<ReturnType<typeof findArtistGenres>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindArtistGenres<TData = Awaited<ReturnType<typeof findArtistGenres>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findArtistGenres>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findArtistGenres>>,
          TError,
          Awaited<ReturnType<typeof findArtistGenres>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindArtistGenres<TData = Awaited<ReturnType<typeof findArtistGenres>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findArtistGenres>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Artist Genres
 */

export function useFindArtistGenres<TData = Awaited<ReturnType<typeof findArtistGenres>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findArtistGenres>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindArtistGenresQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindArtistGenresSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findArtistGenres>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findArtistGenres>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindArtistGenresQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findArtistGenres>>> = () => findArtistGenres(requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findArtistGenres>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindArtistGenresSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findArtistGenres>>>
export type FindArtistGenresSuspenseQueryError = ErrorType<unknown>


export function useFindArtistGenresSuspense<TData = Awaited<ReturnType<typeof findArtistGenres>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findArtistGenres>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindArtistGenresSuspense<TData = Awaited<ReturnType<typeof findArtistGenres>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findArtistGenres>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindArtistGenresSuspense<TData = Awaited<ReturnType<typeof findArtistGenres>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findArtistGenres>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Artist Genres
 */

export function useFindArtistGenresSuspense<TData = Awaited<ReturnType<typeof findArtistGenres>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findArtistGenres>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindArtistGenresSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Get Organization Units
 */
export const findAllOrganizationUnits = (

 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<GetOrganizationUnitsResponseType>(
      {url: `/artist-service-v1/organization-units`, method: 'GET'
    },
      options);
    }




export const getFindAllOrganizationUnitsQueryKey = () => {
    return [
    'artist-service-v1','organization-units'
    ] as const;
    }


export const getFindAllOrganizationUnitsQueryOptions = <TData = Awaited<ReturnType<typeof findAllOrganizationUnits>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllOrganizationUnits>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllOrganizationUnitsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllOrganizationUnits>>> = () => findAllOrganizationUnits(requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findAllOrganizationUnits>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllOrganizationUnitsQueryResult = NonNullable<Awaited<ReturnType<typeof findAllOrganizationUnits>>>
export type FindAllOrganizationUnitsQueryError = ErrorType<unknown>


export function useFindAllOrganizationUnits<TData = Awaited<ReturnType<typeof findAllOrganizationUnits>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllOrganizationUnits>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllOrganizationUnits>>,
          TError,
          Awaited<ReturnType<typeof findAllOrganizationUnits>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllOrganizationUnits<TData = Awaited<ReturnType<typeof findAllOrganizationUnits>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllOrganizationUnits>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllOrganizationUnits>>,
          TError,
          Awaited<ReturnType<typeof findAllOrganizationUnits>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllOrganizationUnits<TData = Awaited<ReturnType<typeof findAllOrganizationUnits>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllOrganizationUnits>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Organization Units
 */

export function useFindAllOrganizationUnits<TData = Awaited<ReturnType<typeof findAllOrganizationUnits>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllOrganizationUnits>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllOrganizationUnitsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindAllOrganizationUnitsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findAllOrganizationUnits>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllOrganizationUnits>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllOrganizationUnitsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllOrganizationUnits>>> = () => findAllOrganizationUnits(requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllOrganizationUnits>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllOrganizationUnitsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findAllOrganizationUnits>>>
export type FindAllOrganizationUnitsSuspenseQueryError = ErrorType<unknown>


export function useFindAllOrganizationUnitsSuspense<TData = Awaited<ReturnType<typeof findAllOrganizationUnits>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllOrganizationUnits>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllOrganizationUnitsSuspense<TData = Awaited<ReturnType<typeof findAllOrganizationUnits>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllOrganizationUnits>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllOrganizationUnitsSuspense<TData = Awaited<ReturnType<typeof findAllOrganizationUnits>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllOrganizationUnits>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Organization Units
 */

export function useFindAllOrganizationUnitsSuspense<TData = Awaited<ReturnType<typeof findAllOrganizationUnits>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllOrganizationUnits>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllOrganizationUnitsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Get Contracting Persons
 */
export const findAllContractingPersons = (

 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<GetContractingPersonsResponseType>(
      {url: `/artist-service-v1/contracting-persons`, method: 'GET'
    },
      options);
    }




export const getFindAllContractingPersonsQueryKey = () => {
    return [
    'artist-service-v1','contracting-persons'
    ] as const;
    }


export const getFindAllContractingPersonsQueryOptions = <TData = Awaited<ReturnType<typeof findAllContractingPersons>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllContractingPersons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllContractingPersonsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllContractingPersons>>> = () => findAllContractingPersons(requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findAllContractingPersons>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllContractingPersonsQueryResult = NonNullable<Awaited<ReturnType<typeof findAllContractingPersons>>>
export type FindAllContractingPersonsQueryError = ErrorType<unknown>


export function useFindAllContractingPersons<TData = Awaited<ReturnType<typeof findAllContractingPersons>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllContractingPersons>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllContractingPersons>>,
          TError,
          Awaited<ReturnType<typeof findAllContractingPersons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllContractingPersons<TData = Awaited<ReturnType<typeof findAllContractingPersons>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllContractingPersons>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllContractingPersons>>,
          TError,
          Awaited<ReturnType<typeof findAllContractingPersons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllContractingPersons<TData = Awaited<ReturnType<typeof findAllContractingPersons>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllContractingPersons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Contracting Persons
 */

export function useFindAllContractingPersons<TData = Awaited<ReturnType<typeof findAllContractingPersons>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllContractingPersons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllContractingPersonsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindAllContractingPersonsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findAllContractingPersons>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllContractingPersons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllContractingPersonsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllContractingPersons>>> = () => findAllContractingPersons(requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllContractingPersons>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllContractingPersonsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findAllContractingPersons>>>
export type FindAllContractingPersonsSuspenseQueryError = ErrorType<unknown>


export function useFindAllContractingPersonsSuspense<TData = Awaited<ReturnType<typeof findAllContractingPersons>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllContractingPersons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllContractingPersonsSuspense<TData = Awaited<ReturnType<typeof findAllContractingPersons>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllContractingPersons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllContractingPersonsSuspense<TData = Awaited<ReturnType<typeof findAllContractingPersons>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllContractingPersons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Contracting Persons
 */

export function useFindAllContractingPersonsSuspense<TData = Awaited<ReturnType<typeof findAllContractingPersons>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllContractingPersons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllContractingPersonsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Get Contracting Companies
 */
export const findAllContractingCompanies = (

 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<GetContractingCompaniesResponseType>(
      {url: `/artist-service-v1/contracting-companies`, method: 'GET'
    },
      options);
    }




export const getFindAllContractingCompaniesQueryKey = () => {
    return [
    'artist-service-v1','contracting-companies'
    ] as const;
    }


export const getFindAllContractingCompaniesQueryOptions = <TData = Awaited<ReturnType<typeof findAllContractingCompanies>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllContractingCompanies>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllContractingCompaniesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllContractingCompanies>>> = () => findAllContractingCompanies(requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findAllContractingCompanies>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllContractingCompaniesQueryResult = NonNullable<Awaited<ReturnType<typeof findAllContractingCompanies>>>
export type FindAllContractingCompaniesQueryError = ErrorType<unknown>


export function useFindAllContractingCompanies<TData = Awaited<ReturnType<typeof findAllContractingCompanies>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllContractingCompanies>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllContractingCompanies>>,
          TError,
          Awaited<ReturnType<typeof findAllContractingCompanies>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllContractingCompanies<TData = Awaited<ReturnType<typeof findAllContractingCompanies>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllContractingCompanies>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllContractingCompanies>>,
          TError,
          Awaited<ReturnType<typeof findAllContractingCompanies>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllContractingCompanies<TData = Awaited<ReturnType<typeof findAllContractingCompanies>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllContractingCompanies>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Contracting Companies
 */

export function useFindAllContractingCompanies<TData = Awaited<ReturnType<typeof findAllContractingCompanies>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllContractingCompanies>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllContractingCompaniesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindAllContractingCompaniesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findAllContractingCompanies>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllContractingCompanies>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllContractingCompaniesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllContractingCompanies>>> = () => findAllContractingCompanies(requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllContractingCompanies>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllContractingCompaniesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findAllContractingCompanies>>>
export type FindAllContractingCompaniesSuspenseQueryError = ErrorType<unknown>


export function useFindAllContractingCompaniesSuspense<TData = Awaited<ReturnType<typeof findAllContractingCompanies>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllContractingCompanies>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllContractingCompaniesSuspense<TData = Awaited<ReturnType<typeof findAllContractingCompanies>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllContractingCompanies>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllContractingCompaniesSuspense<TData = Awaited<ReturnType<typeof findAllContractingCompanies>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllContractingCompanies>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Contracting Companies
 */

export function useFindAllContractingCompaniesSuspense<TData = Awaited<ReturnType<typeof findAllContractingCompanies>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllContractingCompanies>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllContractingCompaniesSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Create Artist Bank Account
 */
export const createArtistBankAccount = (
    artistId: string,
    createBankAccountType?: BodyType<CreateBankAccountType>,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<CreateArtistBankAccount200>(
      {url: `/artist-service-v1/artists/${artistId}/bank-accounts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createBankAccountType
    },
      options);
    }



export const getCreateArtistBankAccountMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createArtistBankAccount>>, TError,{artistId: string;data?: BodyType<CreateBankAccountType>}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createArtistBankAccount>>, TError,{artistId: string;data?: BodyType<CreateBankAccountType>}, TContext> => {

const mutationKey = ['createArtistBankAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createArtistBankAccount>>, {artistId: string;data?: BodyType<CreateBankAccountType>}> = (props) => {
          const {artistId,data} = props ?? {};

          return  createArtistBankAccount(artistId,data,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof createArtistBankAccount>>, variables: {artistId: string;data?: BodyType<CreateBankAccountType>}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getFindArtistQueryKey(variables.artistId) });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type CreateArtistBankAccountMutationResult = NonNullable<Awaited<ReturnType<typeof createArtistBankAccount>>>
    export type CreateArtistBankAccountMutationBody = BodyType<CreateBankAccountType> | undefined
    export type CreateArtistBankAccountMutationError = ErrorType<unknown>

    /**
 * @summary Create Artist Bank Account
 */
export const useCreateArtistBankAccount = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createArtistBankAccount>>, TError,{artistId: string;data?: BodyType<CreateBankAccountType>}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createArtistBankAccount>>,
        TError,
        {artistId: string;data?: BodyType<CreateBankAccountType>},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getCreateArtistBankAccountMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * @summary Delete File
 */
export const deleteFile = (
    fileId: string,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<DeleteResponseType>(
      {url: `/documents-service-v1/files/${fileId}`, method: 'DELETE'
    },
      options);
    }



export const getDeleteFileMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFile>>, TError,{fileId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteFile>>, TError,{fileId: string}, TContext> => {

const mutationKey = ['deleteFile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteFile>>, {fileId: string}> = (props) => {
          const {fileId} = props ?? {};

          return  deleteFile(fileId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteFileMutationResult = NonNullable<Awaited<ReturnType<typeof deleteFile>>>

    export type DeleteFileMutationError = ErrorType<unknown>

    /**
 * @summary Delete File
 */
export const useDeleteFile = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFile>>, TError,{fileId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteFile>>,
        TError,
        {fileId: string},
        TContext
      > => {
      return useMutation(getDeleteFileMutationOptions(options), queryClient);
    }

/**
 * @summary Rename File
 */
export const renameFile = (
    fileId: string,
    renameFileRequestType?: BodyType<RenameFileRequestType>,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<string>(
      {url: `/documents-service-v1/files/${fileId}/rename`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: renameFileRequestType
    },
      options);
    }



export const getRenameFileMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof renameFile>>, TError,{fileId: string;data?: BodyType<RenameFileRequestType>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof renameFile>>, TError,{fileId: string;data?: BodyType<RenameFileRequestType>}, TContext> => {

const mutationKey = ['renameFile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof renameFile>>, {fileId: string;data?: BodyType<RenameFileRequestType>}> = (props) => {
          const {fileId,data} = props ?? {};

          return  renameFile(fileId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RenameFileMutationResult = NonNullable<Awaited<ReturnType<typeof renameFile>>>
    export type RenameFileMutationBody = BodyType<RenameFileRequestType> | undefined
    export type RenameFileMutationError = ErrorType<unknown>

    /**
 * @summary Rename File
 */
export const useRenameFile = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof renameFile>>, TError,{fileId: string;data?: BodyType<RenameFileRequestType>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof renameFile>>,
        TError,
        {fileId: string;data?: BodyType<RenameFileRequestType>},
        TContext
      > => {
      return useMutation(getRenameFileMutationOptions(options), queryClient);
    }

/**
 * @summary Move File
 */
export const moveFile = (
    fileId: string,
    moveFileRequestType?: BodyType<MoveFileRequestType>,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<string>(
      {url: `/documents-service-v1/files/${fileId}/move`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: moveFileRequestType
    },
      options);
    }



export const getMoveFileMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moveFile>>, TError,{fileId: string;data?: BodyType<MoveFileRequestType>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof moveFile>>, TError,{fileId: string;data?: BodyType<MoveFileRequestType>}, TContext> => {

const mutationKey = ['moveFile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moveFile>>, {fileId: string;data?: BodyType<MoveFileRequestType>}> = (props) => {
          const {fileId,data} = props ?? {};

          return  moveFile(fileId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MoveFileMutationResult = NonNullable<Awaited<ReturnType<typeof moveFile>>>
    export type MoveFileMutationBody = BodyType<MoveFileRequestType> | undefined
    export type MoveFileMutationError = ErrorType<unknown>

    /**
 * @summary Move File
 */
export const useMoveFile = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moveFile>>, TError,{fileId: string;data?: BodyType<MoveFileRequestType>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof moveFile>>,
        TError,
        {fileId: string;data?: BodyType<MoveFileRequestType>},
        TContext
      > => {
      return useMutation(getMoveFileMutationOptions(options), queryClient);
    }

/**
 * @summary Create Folder
 */
export const createFolder = (
    createFolderRequestType?: BodyType<CreateFolderRequestType>,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<CreateFolder200>(
      {url: `/documents-service-v1/folders`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createFolderRequestType
    },
      options);
    }



export const getCreateFolderMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFolder>>, TError,{data?: BodyType<CreateFolderRequestType>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createFolder>>, TError,{data?: BodyType<CreateFolderRequestType>}, TContext> => {

const mutationKey = ['createFolder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFolder>>, {data?: BodyType<CreateFolderRequestType>}> = (props) => {
          const {data} = props ?? {};

          return  createFolder(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateFolderMutationResult = NonNullable<Awaited<ReturnType<typeof createFolder>>>
    export type CreateFolderMutationBody = BodyType<CreateFolderRequestType> | undefined
    export type CreateFolderMutationError = ErrorType<unknown>

    /**
 * @summary Create Folder
 */
export const useCreateFolder = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFolder>>, TError,{data?: BodyType<CreateFolderRequestType>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createFolder>>,
        TError,
        {data?: BodyType<CreateFolderRequestType>},
        TContext
      > => {
      return useMutation(getCreateFolderMutationOptions(options), queryClient);
    }

/**
 * @summary Initialize Upload
 */
export const initializeUpload = (
    initializeUploadRequestType?: BodyType<InitializeUploadRequestType>,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<InitializeUploadResponseType>(
      {url: `/documents-service-v1/initialize-upload`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: initializeUploadRequestType
    },
      options);
    }



export const getInitializeUploadMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof initializeUpload>>, TError,{data?: BodyType<InitializeUploadRequestType>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof initializeUpload>>, TError,{data?: BodyType<InitializeUploadRequestType>}, TContext> => {

const mutationKey = ['initializeUpload'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof initializeUpload>>, {data?: BodyType<InitializeUploadRequestType>}> = (props) => {
          const {data} = props ?? {};

          return  initializeUpload(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type InitializeUploadMutationResult = NonNullable<Awaited<ReturnType<typeof initializeUpload>>>
    export type InitializeUploadMutationBody = BodyType<InitializeUploadRequestType> | undefined
    export type InitializeUploadMutationError = ErrorType<unknown>

    /**
 * @summary Initialize Upload
 */
export const useInitializeUpload = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof initializeUpload>>, TError,{data?: BodyType<InitializeUploadRequestType>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof initializeUpload>>,
        TError,
        {data?: BodyType<InitializeUploadRequestType>},
        TContext
      > => {
      return useMutation(getInitializeUploadMutationOptions(options), queryClient);
    }

/**
 * @summary Upload File
 */
export const uploadFile = (
    uploadFileRequestType?: BodyType<UploadFileRequestType>,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<UploadFile200>(
      {url: `/documents-service-v1/upload-file`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: uploadFileRequestType
    },
      options);
    }



export const getUploadFileMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadFile>>, TError,{data?: BodyType<UploadFileRequestType>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadFile>>, TError,{data?: BodyType<UploadFileRequestType>}, TContext> => {

const mutationKey = ['uploadFile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadFile>>, {data?: BodyType<UploadFileRequestType>}> = (props) => {
          const {data} = props ?? {};

          return  uploadFile(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadFileMutationResult = NonNullable<Awaited<ReturnType<typeof uploadFile>>>
    export type UploadFileMutationBody = BodyType<UploadFileRequestType> | undefined
    export type UploadFileMutationError = ErrorType<unknown>

    /**
 * @summary Upload File
 */
export const useUploadFile = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadFile>>, TError,{data?: BodyType<UploadFileRequestType>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadFile>>,
        TError,
        {data?: BodyType<UploadFileRequestType>},
        TContext
      > => {
      return useMutation(getUploadFileMutationOptions(options), queryClient);
    }

/**
 * @summary Get Legal Files
 */
export const findAllLegalFiles = (

 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<GetVenueFilesResponseType>(
      {url: `/legal-service-v1/files`, method: 'GET'
    },
      options);
    }




export const getFindAllLegalFilesQueryKey = () => {
    return [
    'legal-service-v1','files'
    ] as const;
    }


export const getFindAllLegalFilesQueryOptions = <TData = Awaited<ReturnType<typeof findAllLegalFiles>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllLegalFiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllLegalFilesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllLegalFiles>>> = () => findAllLegalFiles(requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findAllLegalFiles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllLegalFilesQueryResult = NonNullable<Awaited<ReturnType<typeof findAllLegalFiles>>>
export type FindAllLegalFilesQueryError = ErrorType<unknown>


export function useFindAllLegalFiles<TData = Awaited<ReturnType<typeof findAllLegalFiles>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllLegalFiles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllLegalFiles>>,
          TError,
          Awaited<ReturnType<typeof findAllLegalFiles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllLegalFiles<TData = Awaited<ReturnType<typeof findAllLegalFiles>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllLegalFiles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllLegalFiles>>,
          TError,
          Awaited<ReturnType<typeof findAllLegalFiles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllLegalFiles<TData = Awaited<ReturnType<typeof findAllLegalFiles>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllLegalFiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Legal Files
 */

export function useFindAllLegalFiles<TData = Awaited<ReturnType<typeof findAllLegalFiles>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllLegalFiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllLegalFilesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindAllLegalFilesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findAllLegalFiles>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllLegalFiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllLegalFilesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllLegalFiles>>> = () => findAllLegalFiles(requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllLegalFiles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllLegalFilesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findAllLegalFiles>>>
export type FindAllLegalFilesSuspenseQueryError = ErrorType<unknown>


export function useFindAllLegalFilesSuspense<TData = Awaited<ReturnType<typeof findAllLegalFiles>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllLegalFiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllLegalFilesSuspense<TData = Awaited<ReturnType<typeof findAllLegalFiles>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllLegalFiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllLegalFilesSuspense<TData = Awaited<ReturnType<typeof findAllLegalFiles>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllLegalFiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Legal Files
 */

export function useFindAllLegalFilesSuspense<TData = Awaited<ReturnType<typeof findAllLegalFiles>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllLegalFiles>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllLegalFilesSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Get Company List
 */
export const findAllCompanies = (
    params?: FindAllCompaniesParams,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<GetCompanyListResponseType>(
      {url: `/company-service-v1/companies`, method: 'GET',
        params
    },
      options);
    }




export const getFindAllCompaniesQueryKey = (params?: FindAllCompaniesParams,) => {
    return [
    'company-service-v1','companies', ...(params ? [params] : [])
    ] as const;
    }


export const getFindAllCompaniesQueryOptions = <TData = Awaited<ReturnType<typeof findAllCompanies>>, TError = ErrorType<unknown>>(params?: FindAllCompaniesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllCompanies>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllCompaniesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllCompanies>>> = () => findAllCompanies(params, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findAllCompanies>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllCompaniesQueryResult = NonNullable<Awaited<ReturnType<typeof findAllCompanies>>>
export type FindAllCompaniesQueryError = ErrorType<unknown>


export function useFindAllCompanies<TData = Awaited<ReturnType<typeof findAllCompanies>>, TError = ErrorType<unknown>>(
 params: undefined |  FindAllCompaniesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllCompanies>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllCompanies>>,
          TError,
          Awaited<ReturnType<typeof findAllCompanies>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllCompanies<TData = Awaited<ReturnType<typeof findAllCompanies>>, TError = ErrorType<unknown>>(
 params?: FindAllCompaniesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllCompanies>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllCompanies>>,
          TError,
          Awaited<ReturnType<typeof findAllCompanies>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllCompanies<TData = Awaited<ReturnType<typeof findAllCompanies>>, TError = ErrorType<unknown>>(
 params?: FindAllCompaniesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllCompanies>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Company List
 */

export function useFindAllCompanies<TData = Awaited<ReturnType<typeof findAllCompanies>>, TError = ErrorType<unknown>>(
 params?: FindAllCompaniesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllCompanies>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllCompaniesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindAllCompaniesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findAllCompanies>>, TError = ErrorType<unknown>>(params?: FindAllCompaniesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllCompanies>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllCompaniesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllCompanies>>> = () => findAllCompanies(params, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllCompanies>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllCompaniesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findAllCompanies>>>
export type FindAllCompaniesSuspenseQueryError = ErrorType<unknown>


export function useFindAllCompaniesSuspense<TData = Awaited<ReturnType<typeof findAllCompanies>>, TError = ErrorType<unknown>>(
 params: undefined |  FindAllCompaniesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllCompanies>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllCompaniesSuspense<TData = Awaited<ReturnType<typeof findAllCompanies>>, TError = ErrorType<unknown>>(
 params?: FindAllCompaniesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllCompanies>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllCompaniesSuspense<TData = Awaited<ReturnType<typeof findAllCompanies>>, TError = ErrorType<unknown>>(
 params?: FindAllCompaniesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllCompanies>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Company List
 */

export function useFindAllCompaniesSuspense<TData = Awaited<ReturnType<typeof findAllCompanies>>, TError = ErrorType<unknown>>(
 params?: FindAllCompaniesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllCompanies>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllCompaniesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Create Company
 */
export const createCompany = (
    createCompanyType: BodyType<CreateCompanyType>,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<CreateCompanyResponseType>(
      {url: `/company-service-v1/companies`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createCompanyType
    },
      options);
    }



export const getCreateCompanyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCompany>>, TError,{data: BodyType<CreateCompanyType>}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createCompany>>, TError,{data: BodyType<CreateCompanyType>}, TContext> => {

const mutationKey = ['createCompany'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCompany>>, {data: BodyType<CreateCompanyType>}> = (props) => {
          const {data} = props ?? {};

          return  createCompany(data,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof createCompany>>, variables: {data: BodyType<CreateCompanyType>}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getFindAllCompaniesQueryKey() });
    queryClient.invalidateQueries({ queryKey: getFindCompanySitesMinifiedQueryKey() });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type CreateCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof createCompany>>>
    export type CreateCompanyMutationBody = BodyType<CreateCompanyType>
    export type CreateCompanyMutationError = ErrorType<unknown>

    /**
 * @summary Create Company
 */
export const useCreateCompany = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCompany>>, TError,{data: BodyType<CreateCompanyType>}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createCompany>>,
        TError,
        {data: BodyType<CreateCompanyType>},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getCreateCompanyMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * @summary Get Company Sites Minified
 */
export const findCompanySitesMinified = (

 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<GetCompanySitesMinifiedResponseType>(
      {url: `/company-service-v1/company-sites`, method: 'GET'
    },
      options);
    }




export const getFindCompanySitesMinifiedQueryKey = () => {
    return [
    'company-service-v1','company-sites'
    ] as const;
    }


export const getFindCompanySitesMinifiedQueryOptions = <TData = Awaited<ReturnType<typeof findCompanySitesMinified>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanySitesMinified>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindCompanySitesMinifiedQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findCompanySitesMinified>>> = () => findCompanySitesMinified(requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findCompanySitesMinified>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindCompanySitesMinifiedQueryResult = NonNullable<Awaited<ReturnType<typeof findCompanySitesMinified>>>
export type FindCompanySitesMinifiedQueryError = ErrorType<unknown>


export function useFindCompanySitesMinified<TData = Awaited<ReturnType<typeof findCompanySitesMinified>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanySitesMinified>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findCompanySitesMinified>>,
          TError,
          Awaited<ReturnType<typeof findCompanySitesMinified>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindCompanySitesMinified<TData = Awaited<ReturnType<typeof findCompanySitesMinified>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanySitesMinified>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findCompanySitesMinified>>,
          TError,
          Awaited<ReturnType<typeof findCompanySitesMinified>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindCompanySitesMinified<TData = Awaited<ReturnType<typeof findCompanySitesMinified>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanySitesMinified>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Company Sites Minified
 */

export function useFindCompanySitesMinified<TData = Awaited<ReturnType<typeof findCompanySitesMinified>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanySitesMinified>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindCompanySitesMinifiedQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindCompanySitesMinifiedSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findCompanySitesMinified>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanySitesMinified>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindCompanySitesMinifiedQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findCompanySitesMinified>>> = () => findCompanySitesMinified(requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanySitesMinified>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindCompanySitesMinifiedSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findCompanySitesMinified>>>
export type FindCompanySitesMinifiedSuspenseQueryError = ErrorType<unknown>


export function useFindCompanySitesMinifiedSuspense<TData = Awaited<ReturnType<typeof findCompanySitesMinified>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanySitesMinified>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindCompanySitesMinifiedSuspense<TData = Awaited<ReturnType<typeof findCompanySitesMinified>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanySitesMinified>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindCompanySitesMinifiedSuspense<TData = Awaited<ReturnType<typeof findCompanySitesMinified>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanySitesMinified>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Company Sites Minified
 */

export function useFindCompanySitesMinifiedSuspense<TData = Awaited<ReturnType<typeof findCompanySitesMinified>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanySitesMinified>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindCompanySitesMinifiedSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Get Company
 */
export const findCompany = (
    companyId: string,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<GetCompanyResponseType>(
      {url: `/company-service-v1/companies/${companyId}`, method: 'GET'
    },
      options);
    }




export const getFindCompanyQueryKey = (companyId: string,) => {
    return [
    'company-service-v1','companies',companyId
    ] as const;
    }


export const getFindCompanyQueryOptions = <TData = Awaited<ReturnType<typeof findCompany>>, TError = ErrorType<unknown>>(companyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompany>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindCompanyQueryKey(companyId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findCompany>>> = () => findCompany(companyId, requestOptions);





   return  { queryKey, queryFn, enabled: companyId !== null && companyId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findCompany>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindCompanyQueryResult = NonNullable<Awaited<ReturnType<typeof findCompany>>>
export type FindCompanyQueryError = ErrorType<unknown>


export function useFindCompany<TData = Awaited<ReturnType<typeof findCompany>>, TError = ErrorType<unknown>>(
 companyId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompany>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findCompany>>,
          TError,
          Awaited<ReturnType<typeof findCompany>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindCompany<TData = Awaited<ReturnType<typeof findCompany>>, TError = ErrorType<unknown>>(
 companyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompany>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findCompany>>,
          TError,
          Awaited<ReturnType<typeof findCompany>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindCompany<TData = Awaited<ReturnType<typeof findCompany>>, TError = ErrorType<unknown>>(
 companyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompany>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Company
 */

export function useFindCompany<TData = Awaited<ReturnType<typeof findCompany>>, TError = ErrorType<unknown>>(
 companyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompany>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindCompanyQueryOptions(companyId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindCompanySuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findCompany>>, TError = ErrorType<unknown>>(companyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompany>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindCompanyQueryKey(companyId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findCompany>>> = () => findCompany(companyId, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompany>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindCompanySuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findCompany>>>
export type FindCompanySuspenseQueryError = ErrorType<unknown>


export function useFindCompanySuspense<TData = Awaited<ReturnType<typeof findCompany>>, TError = ErrorType<unknown>>(
 companyId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompany>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindCompanySuspense<TData = Awaited<ReturnType<typeof findCompany>>, TError = ErrorType<unknown>>(
 companyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompany>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindCompanySuspense<TData = Awaited<ReturnType<typeof findCompany>>, TError = ErrorType<unknown>>(
 companyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompany>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Company
 */

export function useFindCompanySuspense<TData = Awaited<ReturnType<typeof findCompany>>, TError = ErrorType<unknown>>(
 companyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompany>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindCompanySuspenseQueryOptions(companyId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Delete Company
 */
export const deleteCompany = (
    companyId: string,
    params?: DeleteCompanyParams,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<DeleteResponseType>(
      {url: `/company-service-v1/companies/${companyId}`, method: 'DELETE',
        params
    },
      options);
    }



export const getDeleteCompanyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCompany>>, TError,{companyId: string;params?: DeleteCompanyParams}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCompany>>, TError,{companyId: string;params?: DeleteCompanyParams}, TContext> => {

const mutationKey = ['deleteCompany'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCompany>>, {companyId: string;params?: DeleteCompanyParams}> = (props) => {
          const {companyId,params} = props ?? {};

          return  deleteCompany(companyId,params,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof deleteCompany>>, variables: {companyId: string;params?: DeleteCompanyParams}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getFindAllCompaniesQueryKey() });
    queryClient.invalidateQueries({ queryKey: getFindCompanySitesMinifiedQueryKey() });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type DeleteCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCompany>>>

    export type DeleteCompanyMutationError = ErrorType<unknown>

    /**
 * @summary Delete Company
 */
export const useDeleteCompany = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCompany>>, TError,{companyId: string;params?: DeleteCompanyParams}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCompany>>,
        TError,
        {companyId: string;params?: DeleteCompanyParams},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getDeleteCompanyMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * @summary Update Company
 */
export const updateCompany = (
    companyId: string,
    updateCompanyType: BodyType<UpdateCompanyType>,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<UpdateCompanyResponseType>(
      {url: `/company-service-v1/companies/${companyId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateCompanyType
    },
      options);
    }



export const getUpdateCompanyMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCompany>>, TError,{companyId: string;data: BodyType<UpdateCompanyType>}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCompany>>, TError,{companyId: string;data: BodyType<UpdateCompanyType>}, TContext> => {

const mutationKey = ['updateCompany'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCompany>>, {companyId: string;data: BodyType<UpdateCompanyType>}> = (props) => {
          const {companyId,data} = props ?? {};

          return  updateCompany(companyId,data,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof updateCompany>>, variables: {companyId: string;data: BodyType<UpdateCompanyType>}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getFindAllCompaniesQueryKey() });
    queryClient.invalidateQueries({ queryKey: getFindCompanySitesMinifiedQueryKey() });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type UpdateCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof updateCompany>>>
    export type UpdateCompanyMutationBody = BodyType<UpdateCompanyType>
    export type UpdateCompanyMutationError = ErrorType<unknown>

    /**
 * @summary Update Company
 */
export const useUpdateCompany = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCompany>>, TError,{companyId: string;data: BodyType<UpdateCompanyType>}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateCompany>>,
        TError,
        {companyId: string;data: BodyType<UpdateCompanyType>},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getUpdateCompanyMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * @summary Get Company Email Addresses
 */
export const findCompanyEmailAddresses = (
    companyId: string,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<GetCompanyEmailAddressesResponseType>(
      {url: `/company-service-v1/companies/${companyId}/email-addresses`, method: 'GET'
    },
      options);
    }




export const getFindCompanyEmailAddressesQueryKey = (companyId: string,) => {
    return [
    'company-service-v1','companies',companyId,'email-addresses'
    ] as const;
    }


export const getFindCompanyEmailAddressesQueryOptions = <TData = Awaited<ReturnType<typeof findCompanyEmailAddresses>>, TError = ErrorType<unknown>>(companyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanyEmailAddresses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindCompanyEmailAddressesQueryKey(companyId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findCompanyEmailAddresses>>> = () => findCompanyEmailAddresses(companyId, requestOptions);





   return  { queryKey, queryFn, enabled: companyId !== null && companyId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findCompanyEmailAddresses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindCompanyEmailAddressesQueryResult = NonNullable<Awaited<ReturnType<typeof findCompanyEmailAddresses>>>
export type FindCompanyEmailAddressesQueryError = ErrorType<unknown>


export function useFindCompanyEmailAddresses<TData = Awaited<ReturnType<typeof findCompanyEmailAddresses>>, TError = ErrorType<unknown>>(
 companyId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanyEmailAddresses>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findCompanyEmailAddresses>>,
          TError,
          Awaited<ReturnType<typeof findCompanyEmailAddresses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindCompanyEmailAddresses<TData = Awaited<ReturnType<typeof findCompanyEmailAddresses>>, TError = ErrorType<unknown>>(
 companyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanyEmailAddresses>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findCompanyEmailAddresses>>,
          TError,
          Awaited<ReturnType<typeof findCompanyEmailAddresses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindCompanyEmailAddresses<TData = Awaited<ReturnType<typeof findCompanyEmailAddresses>>, TError = ErrorType<unknown>>(
 companyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanyEmailAddresses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Company Email Addresses
 */

export function useFindCompanyEmailAddresses<TData = Awaited<ReturnType<typeof findCompanyEmailAddresses>>, TError = ErrorType<unknown>>(
 companyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanyEmailAddresses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindCompanyEmailAddressesQueryOptions(companyId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindCompanyEmailAddressesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findCompanyEmailAddresses>>, TError = ErrorType<unknown>>(companyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanyEmailAddresses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindCompanyEmailAddressesQueryKey(companyId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findCompanyEmailAddresses>>> = () => findCompanyEmailAddresses(companyId, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanyEmailAddresses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindCompanyEmailAddressesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findCompanyEmailAddresses>>>
export type FindCompanyEmailAddressesSuspenseQueryError = ErrorType<unknown>


export function useFindCompanyEmailAddressesSuspense<TData = Awaited<ReturnType<typeof findCompanyEmailAddresses>>, TError = ErrorType<unknown>>(
 companyId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanyEmailAddresses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindCompanyEmailAddressesSuspense<TData = Awaited<ReturnType<typeof findCompanyEmailAddresses>>, TError = ErrorType<unknown>>(
 companyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanyEmailAddresses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindCompanyEmailAddressesSuspense<TData = Awaited<ReturnType<typeof findCompanyEmailAddresses>>, TError = ErrorType<unknown>>(
 companyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanyEmailAddresses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Company Email Addresses
 */

export function useFindCompanyEmailAddressesSuspense<TData = Awaited<ReturnType<typeof findCompanyEmailAddresses>>, TError = ErrorType<unknown>>(
 companyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanyEmailAddresses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindCompanyEmailAddressesSuspenseQueryOptions(companyId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Get Company Sites
 */
export const findCompanySites = (
    companyId: string,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<GetCompanySitesResponseType>(
      {url: `/company-service-v1/companies/${companyId}/sites`, method: 'GET'
    },
      options);
    }




export const getFindCompanySitesQueryKey = (companyId: string,) => {
    return [
    'company-service-v1','companies',companyId,'sites'
    ] as const;
    }


export const getFindCompanySitesQueryOptions = <TData = Awaited<ReturnType<typeof findCompanySites>>, TError = ErrorType<unknown>>(companyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanySites>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindCompanySitesQueryKey(companyId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findCompanySites>>> = () => findCompanySites(companyId, requestOptions);





   return  { queryKey, queryFn, enabled: companyId !== null && companyId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findCompanySites>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindCompanySitesQueryResult = NonNullable<Awaited<ReturnType<typeof findCompanySites>>>
export type FindCompanySitesQueryError = ErrorType<unknown>


export function useFindCompanySites<TData = Awaited<ReturnType<typeof findCompanySites>>, TError = ErrorType<unknown>>(
 companyId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanySites>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findCompanySites>>,
          TError,
          Awaited<ReturnType<typeof findCompanySites>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindCompanySites<TData = Awaited<ReturnType<typeof findCompanySites>>, TError = ErrorType<unknown>>(
 companyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanySites>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findCompanySites>>,
          TError,
          Awaited<ReturnType<typeof findCompanySites>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindCompanySites<TData = Awaited<ReturnType<typeof findCompanySites>>, TError = ErrorType<unknown>>(
 companyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanySites>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Company Sites
 */

export function useFindCompanySites<TData = Awaited<ReturnType<typeof findCompanySites>>, TError = ErrorType<unknown>>(
 companyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanySites>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindCompanySitesQueryOptions(companyId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindCompanySitesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findCompanySites>>, TError = ErrorType<unknown>>(companyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanySites>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindCompanySitesQueryKey(companyId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findCompanySites>>> = () => findCompanySites(companyId, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanySites>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindCompanySitesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findCompanySites>>>
export type FindCompanySitesSuspenseQueryError = ErrorType<unknown>


export function useFindCompanySitesSuspense<TData = Awaited<ReturnType<typeof findCompanySites>>, TError = ErrorType<unknown>>(
 companyId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanySites>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindCompanySitesSuspense<TData = Awaited<ReturnType<typeof findCompanySites>>, TError = ErrorType<unknown>>(
 companyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanySites>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindCompanySitesSuspense<TData = Awaited<ReturnType<typeof findCompanySites>>, TError = ErrorType<unknown>>(
 companyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanySites>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Company Sites
 */

export function useFindCompanySitesSuspense<TData = Awaited<ReturnType<typeof findCompanySites>>, TError = ErrorType<unknown>>(
 companyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanySites>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindCompanySitesSuspenseQueryOptions(companyId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Create Company Site
 */
export const createCompanySite = (
    companyId: string,
    createCompanySiteType: BodyType<CreateCompanySiteType>,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<CreateCompanySiteResponseType>(
      {url: `/company-service-v1/companies/${companyId}/sites`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createCompanySiteType
    },
      options);
    }



export const getCreateCompanySiteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCompanySite>>, TError,{companyId: string;data: BodyType<CreateCompanySiteType>}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createCompanySite>>, TError,{companyId: string;data: BodyType<CreateCompanySiteType>}, TContext> => {

const mutationKey = ['createCompanySite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCompanySite>>, {companyId: string;data: BodyType<CreateCompanySiteType>}> = (props) => {
          const {companyId,data} = props ?? {};

          return  createCompanySite(companyId,data,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof createCompanySite>>, variables: {companyId: string;data: BodyType<CreateCompanySiteType>}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getFindCompanySitesMinifiedQueryKey() });
    queryClient.invalidateQueries({ queryKey: getFindCompanySitesQueryKey(variables.companyId) });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type CreateCompanySiteMutationResult = NonNullable<Awaited<ReturnType<typeof createCompanySite>>>
    export type CreateCompanySiteMutationBody = BodyType<CreateCompanySiteType>
    export type CreateCompanySiteMutationError = ErrorType<unknown>

    /**
 * @summary Create Company Site
 */
export const useCreateCompanySite = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCompanySite>>, TError,{companyId: string;data: BodyType<CreateCompanySiteType>}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createCompanySite>>,
        TError,
        {companyId: string;data: BodyType<CreateCompanySiteType>},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getCreateCompanySiteMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * @summary Delete Company Site
 */
export const deleteCompanySite = (
    companyId: string,
    siteId: string,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<DeleteResponseType>(
      {url: `/company-service-v1/companies/${companyId}/sites/${siteId}`, method: 'DELETE'
    },
      options);
    }



export const getDeleteCompanySiteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCompanySite>>, TError,{companyId: string;siteId: string}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCompanySite>>, TError,{companyId: string;siteId: string}, TContext> => {

const mutationKey = ['deleteCompanySite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCompanySite>>, {companyId: string;siteId: string}> = (props) => {
          const {companyId,siteId} = props ?? {};

          return  deleteCompanySite(companyId,siteId,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof deleteCompanySite>>, variables: {companyId: string;siteId: string}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getFindAllCompaniesQueryKey() });
    queryClient.invalidateQueries({ queryKey: getFindCompanySitesMinifiedQueryKey() });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type DeleteCompanySiteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCompanySite>>>

    export type DeleteCompanySiteMutationError = ErrorType<unknown>

    /**
 * @summary Delete Company Site
 */
export const useDeleteCompanySite = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCompanySite>>, TError,{companyId: string;siteId: string}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCompanySite>>,
        TError,
        {companyId: string;siteId: string},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getDeleteCompanySiteMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * @summary Update Company Site
 */
export const updateCompanySite = (
    companyId: string,
    siteId: string,
    updateCompanySiteType: BodyType<UpdateCompanySiteType>,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<UpdateCompanySiteResponseType>(
      {url: `/company-service-v1/companies/${companyId}/sites/${siteId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateCompanySiteType
    },
      options);
    }



export const getUpdateCompanySiteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCompanySite>>, TError,{companyId: string;siteId: string;data: BodyType<UpdateCompanySiteType>}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCompanySite>>, TError,{companyId: string;siteId: string;data: BodyType<UpdateCompanySiteType>}, TContext> => {

const mutationKey = ['updateCompanySite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCompanySite>>, {companyId: string;siteId: string;data: BodyType<UpdateCompanySiteType>}> = (props) => {
          const {companyId,siteId,data} = props ?? {};

          return  updateCompanySite(companyId,siteId,data,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof updateCompanySite>>, variables: {companyId: string;siteId: string;data: BodyType<UpdateCompanySiteType>}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getFindAllCompaniesQueryKey() });
    queryClient.invalidateQueries({ queryKey: getFindCompanySitesMinifiedQueryKey() });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type UpdateCompanySiteMutationResult = NonNullable<Awaited<ReturnType<typeof updateCompanySite>>>
    export type UpdateCompanySiteMutationBody = BodyType<UpdateCompanySiteType>
    export type UpdateCompanySiteMutationError = ErrorType<unknown>

    /**
 * @summary Update Company Site
 */
export const useUpdateCompanySite = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCompanySite>>, TError,{companyId: string;siteId: string;data: BodyType<UpdateCompanySiteType>}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateCompanySite>>,
        TError,
        {companyId: string;siteId: string;data: BodyType<UpdateCompanySiteType>},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getUpdateCompanySiteMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * @summary Get Company Employees
 */
export const findCompanyEmployees = (
    companyId: string,
    siteId: string,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<GetCompanyEmployeesResponseType>(
      {url: `/company-service-v1/companies/${companyId}/sites/${siteId}/employees`, method: 'GET'
    },
      options);
    }




export const getFindCompanyEmployeesQueryKey = (companyId: string,
    siteId: string,) => {
    return [
    'company-service-v1','companies',companyId,'sites',siteId,'employees'
    ] as const;
    }


export const getFindCompanyEmployeesQueryOptions = <TData = Awaited<ReturnType<typeof findCompanyEmployees>>, TError = ErrorType<unknown>>(companyId: string,
    siteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanyEmployees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindCompanyEmployeesQueryKey(companyId,siteId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findCompanyEmployees>>> = () => findCompanyEmployees(companyId,siteId, requestOptions);





   return  { queryKey, queryFn, enabled: companyId !== null && companyId !== undefined && siteId !== null && siteId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findCompanyEmployees>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindCompanyEmployeesQueryResult = NonNullable<Awaited<ReturnType<typeof findCompanyEmployees>>>
export type FindCompanyEmployeesQueryError = ErrorType<unknown>


export function useFindCompanyEmployees<TData = Awaited<ReturnType<typeof findCompanyEmployees>>, TError = ErrorType<unknown>>(
 companyId: string,
    siteId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanyEmployees>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findCompanyEmployees>>,
          TError,
          Awaited<ReturnType<typeof findCompanyEmployees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindCompanyEmployees<TData = Awaited<ReturnType<typeof findCompanyEmployees>>, TError = ErrorType<unknown>>(
 companyId: string,
    siteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanyEmployees>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findCompanyEmployees>>,
          TError,
          Awaited<ReturnType<typeof findCompanyEmployees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindCompanyEmployees<TData = Awaited<ReturnType<typeof findCompanyEmployees>>, TError = ErrorType<unknown>>(
 companyId: string,
    siteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanyEmployees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Company Employees
 */

export function useFindCompanyEmployees<TData = Awaited<ReturnType<typeof findCompanyEmployees>>, TError = ErrorType<unknown>>(
 companyId: string,
    siteId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanyEmployees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindCompanyEmployeesQueryOptions(companyId,siteId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindCompanyEmployeesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findCompanyEmployees>>, TError = ErrorType<unknown>>(companyId: string,
    siteId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanyEmployees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindCompanyEmployeesQueryKey(companyId,siteId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findCompanyEmployees>>> = () => findCompanyEmployees(companyId,siteId, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanyEmployees>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindCompanyEmployeesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findCompanyEmployees>>>
export type FindCompanyEmployeesSuspenseQueryError = ErrorType<unknown>


export function useFindCompanyEmployeesSuspense<TData = Awaited<ReturnType<typeof findCompanyEmployees>>, TError = ErrorType<unknown>>(
 companyId: string,
    siteId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanyEmployees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindCompanyEmployeesSuspense<TData = Awaited<ReturnType<typeof findCompanyEmployees>>, TError = ErrorType<unknown>>(
 companyId: string,
    siteId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanyEmployees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindCompanyEmployeesSuspense<TData = Awaited<ReturnType<typeof findCompanyEmployees>>, TError = ErrorType<unknown>>(
 companyId: string,
    siteId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanyEmployees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Company Employees
 */

export function useFindCompanyEmployeesSuspense<TData = Awaited<ReturnType<typeof findCompanyEmployees>>, TError = ErrorType<unknown>>(
 companyId: string,
    siteId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanyEmployees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindCompanyEmployeesSuspenseQueryOptions(companyId,siteId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Get Company Tags
 */
export const findCompanyTags = (

 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<GetCompanyTagsResponseType>(
      {url: `/company-service-v1/company-tags`, method: 'GET'
    },
      options);
    }




export const getFindCompanyTagsQueryKey = () => {
    return [
    'company-service-v1','company-tags'
    ] as const;
    }


export const getFindCompanyTagsQueryOptions = <TData = Awaited<ReturnType<typeof findCompanyTags>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanyTags>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindCompanyTagsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findCompanyTags>>> = () => findCompanyTags(requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findCompanyTags>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindCompanyTagsQueryResult = NonNullable<Awaited<ReturnType<typeof findCompanyTags>>>
export type FindCompanyTagsQueryError = ErrorType<unknown>


export function useFindCompanyTags<TData = Awaited<ReturnType<typeof findCompanyTags>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanyTags>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findCompanyTags>>,
          TError,
          Awaited<ReturnType<typeof findCompanyTags>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindCompanyTags<TData = Awaited<ReturnType<typeof findCompanyTags>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanyTags>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findCompanyTags>>,
          TError,
          Awaited<ReturnType<typeof findCompanyTags>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindCompanyTags<TData = Awaited<ReturnType<typeof findCompanyTags>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanyTags>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Company Tags
 */

export function useFindCompanyTags<TData = Awaited<ReturnType<typeof findCompanyTags>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanyTags>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindCompanyTagsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindCompanyTagsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findCompanyTags>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanyTags>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindCompanyTagsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findCompanyTags>>> = () => findCompanyTags(requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanyTags>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindCompanyTagsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findCompanyTags>>>
export type FindCompanyTagsSuspenseQueryError = ErrorType<unknown>


export function useFindCompanyTagsSuspense<TData = Awaited<ReturnType<typeof findCompanyTags>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanyTags>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindCompanyTagsSuspense<TData = Awaited<ReturnType<typeof findCompanyTags>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanyTags>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindCompanyTagsSuspense<TData = Awaited<ReturnType<typeof findCompanyTags>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanyTags>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Company Tags
 */

export function useFindCompanyTagsSuspense<TData = Awaited<ReturnType<typeof findCompanyTags>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanyTags>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindCompanyTagsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Get Company Artists
 */
export const findCompanyArtists = (
    companyId: string,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<GetCompanyArtistsResponseType>(
      {url: `/company-service-v1/companies/${companyId}/artists`, method: 'GET'
    },
      options);
    }




export const getFindCompanyArtistsQueryKey = (companyId: string,) => {
    return [
    'company-service-v1','companies',companyId,'artists'
    ] as const;
    }


export const getFindCompanyArtistsQueryOptions = <TData = Awaited<ReturnType<typeof findCompanyArtists>>, TError = ErrorType<unknown>>(companyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanyArtists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindCompanyArtistsQueryKey(companyId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findCompanyArtists>>> = () => findCompanyArtists(companyId, requestOptions);





   return  { queryKey, queryFn, enabled: companyId !== null && companyId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findCompanyArtists>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindCompanyArtistsQueryResult = NonNullable<Awaited<ReturnType<typeof findCompanyArtists>>>
export type FindCompanyArtistsQueryError = ErrorType<unknown>


export function useFindCompanyArtists<TData = Awaited<ReturnType<typeof findCompanyArtists>>, TError = ErrorType<unknown>>(
 companyId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanyArtists>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findCompanyArtists>>,
          TError,
          Awaited<ReturnType<typeof findCompanyArtists>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindCompanyArtists<TData = Awaited<ReturnType<typeof findCompanyArtists>>, TError = ErrorType<unknown>>(
 companyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanyArtists>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findCompanyArtists>>,
          TError,
          Awaited<ReturnType<typeof findCompanyArtists>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindCompanyArtists<TData = Awaited<ReturnType<typeof findCompanyArtists>>, TError = ErrorType<unknown>>(
 companyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanyArtists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Company Artists
 */

export function useFindCompanyArtists<TData = Awaited<ReturnType<typeof findCompanyArtists>>, TError = ErrorType<unknown>>(
 companyId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanyArtists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindCompanyArtistsQueryOptions(companyId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindCompanyArtistsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findCompanyArtists>>, TError = ErrorType<unknown>>(companyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanyArtists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindCompanyArtistsQueryKey(companyId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findCompanyArtists>>> = () => findCompanyArtists(companyId, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanyArtists>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindCompanyArtistsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findCompanyArtists>>>
export type FindCompanyArtistsSuspenseQueryError = ErrorType<unknown>


export function useFindCompanyArtistsSuspense<TData = Awaited<ReturnType<typeof findCompanyArtists>>, TError = ErrorType<unknown>>(
 companyId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanyArtists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindCompanyArtistsSuspense<TData = Awaited<ReturnType<typeof findCompanyArtists>>, TError = ErrorType<unknown>>(
 companyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanyArtists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindCompanyArtistsSuspense<TData = Awaited<ReturnType<typeof findCompanyArtists>>, TError = ErrorType<unknown>>(
 companyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanyArtists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Company Artists
 */

export function useFindCompanyArtistsSuspense<TData = Awaited<ReturnType<typeof findCompanyArtists>>, TError = ErrorType<unknown>>(
 companyId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanyArtists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindCompanyArtistsSuspenseQueryOptions(companyId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Get Company Shows
 */
export const findCompanyShows = (
    companyId: string,
    params?: FindCompanyShowsParams,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<GetCompanyShowsResponseType>(
      {url: `/company-service-v1/companies/${companyId}/shows`, method: 'GET',
        params
    },
      options);
    }




export const getFindCompanyShowsQueryKey = (companyId: string,
    params?: FindCompanyShowsParams,) => {
    return [
    'company-service-v1','companies',companyId,'shows', ...(params ? [params] : [])
    ] as const;
    }


export const getFindCompanyShowsQueryOptions = <TData = Awaited<ReturnType<typeof findCompanyShows>>, TError = ErrorType<unknown>>(companyId: string,
    params?: FindCompanyShowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanyShows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindCompanyShowsQueryKey(companyId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findCompanyShows>>> = () => findCompanyShows(companyId,params, requestOptions);





   return  { queryKey, queryFn, enabled: companyId !== null && companyId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findCompanyShows>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindCompanyShowsQueryResult = NonNullable<Awaited<ReturnType<typeof findCompanyShows>>>
export type FindCompanyShowsQueryError = ErrorType<unknown>


export function useFindCompanyShows<TData = Awaited<ReturnType<typeof findCompanyShows>>, TError = ErrorType<unknown>>(
 companyId: string,
    params: undefined |  FindCompanyShowsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanyShows>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findCompanyShows>>,
          TError,
          Awaited<ReturnType<typeof findCompanyShows>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindCompanyShows<TData = Awaited<ReturnType<typeof findCompanyShows>>, TError = ErrorType<unknown>>(
 companyId: string,
    params?: FindCompanyShowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanyShows>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findCompanyShows>>,
          TError,
          Awaited<ReturnType<typeof findCompanyShows>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindCompanyShows<TData = Awaited<ReturnType<typeof findCompanyShows>>, TError = ErrorType<unknown>>(
 companyId: string,
    params?: FindCompanyShowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanyShows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Company Shows
 */

export function useFindCompanyShows<TData = Awaited<ReturnType<typeof findCompanyShows>>, TError = ErrorType<unknown>>(
 companyId: string,
    params?: FindCompanyShowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanyShows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindCompanyShowsQueryOptions(companyId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindCompanyShowsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findCompanyShows>>, TError = ErrorType<unknown>>(companyId: string,
    params?: FindCompanyShowsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanyShows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindCompanyShowsQueryKey(companyId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findCompanyShows>>> = () => findCompanyShows(companyId,params, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanyShows>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindCompanyShowsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findCompanyShows>>>
export type FindCompanyShowsSuspenseQueryError = ErrorType<unknown>


export function useFindCompanyShowsSuspense<TData = Awaited<ReturnType<typeof findCompanyShows>>, TError = ErrorType<unknown>>(
 companyId: string,
    params: undefined |  FindCompanyShowsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanyShows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindCompanyShowsSuspense<TData = Awaited<ReturnType<typeof findCompanyShows>>, TError = ErrorType<unknown>>(
 companyId: string,
    params?: FindCompanyShowsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanyShows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindCompanyShowsSuspense<TData = Awaited<ReturnType<typeof findCompanyShows>>, TError = ErrorType<unknown>>(
 companyId: string,
    params?: FindCompanyShowsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanyShows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Company Shows
 */

export function useFindCompanyShowsSuspense<TData = Awaited<ReturnType<typeof findCompanyShows>>, TError = ErrorType<unknown>>(
 companyId: string,
    params?: FindCompanyShowsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanyShows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindCompanyShowsSuspenseQueryOptions(companyId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Get Company Holds
 */
export const findCompanyHolds = (
    companyId: string,
    params: FindCompanyHoldsParams,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<GetCompanyHoldsResponseType>(
      {url: `/company-service-v1/companies/${companyId}/holds`, method: 'GET',
        params
    },
      options);
    }




export const getFindCompanyHoldsQueryKey = (companyId: string,
    params?: FindCompanyHoldsParams,) => {
    return [
    'company-service-v1','companies',companyId,'holds', ...(params ? [params] : [])
    ] as const;
    }


export const getFindCompanyHoldsQueryOptions = <TData = Awaited<ReturnType<typeof findCompanyHolds>>, TError = ErrorType<unknown>>(companyId: string,
    params: FindCompanyHoldsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanyHolds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindCompanyHoldsQueryKey(companyId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findCompanyHolds>>> = () => findCompanyHolds(companyId,params, requestOptions);





   return  { queryKey, queryFn, enabled: companyId !== null && companyId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findCompanyHolds>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindCompanyHoldsQueryResult = NonNullable<Awaited<ReturnType<typeof findCompanyHolds>>>
export type FindCompanyHoldsQueryError = ErrorType<unknown>


export function useFindCompanyHolds<TData = Awaited<ReturnType<typeof findCompanyHolds>>, TError = ErrorType<unknown>>(
 companyId: string,
    params: FindCompanyHoldsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanyHolds>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findCompanyHolds>>,
          TError,
          Awaited<ReturnType<typeof findCompanyHolds>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindCompanyHolds<TData = Awaited<ReturnType<typeof findCompanyHolds>>, TError = ErrorType<unknown>>(
 companyId: string,
    params: FindCompanyHoldsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanyHolds>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findCompanyHolds>>,
          TError,
          Awaited<ReturnType<typeof findCompanyHolds>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindCompanyHolds<TData = Awaited<ReturnType<typeof findCompanyHolds>>, TError = ErrorType<unknown>>(
 companyId: string,
    params: FindCompanyHoldsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanyHolds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Company Holds
 */

export function useFindCompanyHolds<TData = Awaited<ReturnType<typeof findCompanyHolds>>, TError = ErrorType<unknown>>(
 companyId: string,
    params: FindCompanyHoldsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findCompanyHolds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindCompanyHoldsQueryOptions(companyId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindCompanyHoldsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findCompanyHolds>>, TError = ErrorType<unknown>>(companyId: string,
    params: FindCompanyHoldsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanyHolds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindCompanyHoldsQueryKey(companyId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findCompanyHolds>>> = () => findCompanyHolds(companyId,params, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanyHolds>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindCompanyHoldsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findCompanyHolds>>>
export type FindCompanyHoldsSuspenseQueryError = ErrorType<unknown>


export function useFindCompanyHoldsSuspense<TData = Awaited<ReturnType<typeof findCompanyHolds>>, TError = ErrorType<unknown>>(
 companyId: string,
    params: FindCompanyHoldsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanyHolds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindCompanyHoldsSuspense<TData = Awaited<ReturnType<typeof findCompanyHolds>>, TError = ErrorType<unknown>>(
 companyId: string,
    params: FindCompanyHoldsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanyHolds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindCompanyHoldsSuspense<TData = Awaited<ReturnType<typeof findCompanyHolds>>, TError = ErrorType<unknown>>(
 companyId: string,
    params: FindCompanyHoldsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanyHolds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Company Holds
 */

export function useFindCompanyHoldsSuspense<TData = Awaited<ReturnType<typeof findCompanyHolds>>, TError = ErrorType<unknown>>(
 companyId: string,
    params: FindCompanyHoldsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findCompanyHolds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindCompanyHoldsSuspenseQueryOptions(companyId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Create Company Bank Account
 */
export const createCompanyBankAccount = (
    companyId: string,
    createBankAccountType?: BodyType<CreateBankAccountType>,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<CreateCompanyBankAccount200>(
      {url: `/company-service-v1/companies/${companyId}/bank-accounts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createBankAccountType
    },
      options);
    }



export const getCreateCompanyBankAccountMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCompanyBankAccount>>, TError,{companyId: string;data?: BodyType<CreateBankAccountType>}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createCompanyBankAccount>>, TError,{companyId: string;data?: BodyType<CreateBankAccountType>}, TContext> => {

const mutationKey = ['createCompanyBankAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCompanyBankAccount>>, {companyId: string;data?: BodyType<CreateBankAccountType>}> = (props) => {
          const {companyId,data} = props ?? {};

          return  createCompanyBankAccount(companyId,data,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof createCompanyBankAccount>>, variables: {companyId: string;data?: BodyType<CreateBankAccountType>}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getFindCompanyQueryKey(variables.companyId) });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type CreateCompanyBankAccountMutationResult = NonNullable<Awaited<ReturnType<typeof createCompanyBankAccount>>>
    export type CreateCompanyBankAccountMutationBody = BodyType<CreateBankAccountType> | undefined
    export type CreateCompanyBankAccountMutationError = ErrorType<unknown>

    /**
 * @summary Create Company Bank Account
 */
export const useCreateCompanyBankAccount = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCompanyBankAccount>>, TError,{companyId: string;data?: BodyType<CreateBankAccountType>}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createCompanyBankAccount>>,
        TError,
        {companyId: string;data?: BodyType<CreateBankAccountType>},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getCreateCompanyBankAccountMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * @summary Update Bank Account
 */
export const updateBankAccount = (
    bankAccountId: string,
    updateBankAccountType?: BodyType<UpdateBankAccountType>,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<UpdateBankAccount200>(
      {url: `/common-service-v1/bank-accounts/${bankAccountId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateBankAccountType
    },
      options);
    }



export const getUpdateBankAccountMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBankAccount>>, TError,{bankAccountId: string;data?: BodyType<UpdateBankAccountType>}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateBankAccount>>, TError,{bankAccountId: string;data?: BodyType<UpdateBankAccountType>}, TContext> => {

const mutationKey = ['updateBankAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateBankAccount>>, {bankAccountId: string;data?: BodyType<UpdateBankAccountType>}> = (props) => {
          const {bankAccountId,data} = props ?? {};

          return  updateBankAccount(bankAccountId,data,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof updateBankAccount>>, variables: {bankAccountId: string;data?: BodyType<UpdateBankAccountType>}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getFindAllCompaniesQueryKey() });
    queryClient.invalidateQueries({ queryKey: getFindAllArtistsQueryKey() });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type UpdateBankAccountMutationResult = NonNullable<Awaited<ReturnType<typeof updateBankAccount>>>
    export type UpdateBankAccountMutationBody = BodyType<UpdateBankAccountType> | undefined
    export type UpdateBankAccountMutationError = ErrorType<unknown>

    /**
 * @summary Update Bank Account
 */
export const useUpdateBankAccount = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBankAccount>>, TError,{bankAccountId: string;data?: BodyType<UpdateBankAccountType>}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateBankAccount>>,
        TError,
        {bankAccountId: string;data?: BodyType<UpdateBankAccountType>},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getUpdateBankAccountMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * @summary Delete Artist Bank Account
 */
export const deleteBankAccount = (
    bankAccountId: string,
    deleteBankAccountRequestType?: BodyType<DeleteBankAccountRequestType>,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<DeleteResponseType>(
      {url: `/common-service-v1/bank-accounts/${bankAccountId}`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: deleteBankAccountRequestType
    },
      options);
    }



export const getDeleteBankAccountMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBankAccount>>, TError,{bankAccountId: string;data?: BodyType<DeleteBankAccountRequestType>}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteBankAccount>>, TError,{bankAccountId: string;data?: BodyType<DeleteBankAccountRequestType>}, TContext> => {

const mutationKey = ['deleteBankAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteBankAccount>>, {bankAccountId: string;data?: BodyType<DeleteBankAccountRequestType>}> = (props) => {
          const {bankAccountId,data} = props ?? {};

          return  deleteBankAccount(bankAccountId,data,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof deleteBankAccount>>, variables: {bankAccountId: string;data?: BodyType<DeleteBankAccountRequestType>}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getFindAllCompaniesQueryKey() });
    queryClient.invalidateQueries({ queryKey: getFindAllArtistsQueryKey() });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type DeleteBankAccountMutationResult = NonNullable<Awaited<ReturnType<typeof deleteBankAccount>>>
    export type DeleteBankAccountMutationBody = BodyType<DeleteBankAccountRequestType> | undefined
    export type DeleteBankAccountMutationError = ErrorType<unknown>

    /**
 * @summary Delete Artist Bank Account
 */
export const useDeleteBankAccount = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBankAccount>>, TError,{bankAccountId: string;data?: BodyType<DeleteBankAccountRequestType>}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteBankAccount>>,
        TError,
        {bankAccountId: string;data?: BodyType<DeleteBankAccountRequestType>},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getDeleteBankAccountMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * @summary Approve Artist Bank Account
 */
export const approveBankAccount = (
    bankAccountId: string,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<ApproveBankAccount200>(
      {url: `/common-service-v1/bank-accounts/${bankAccountId}/approve`, method: 'POST'
    },
      options);
    }



export const getApproveBankAccountMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveBankAccount>>, TError,{bankAccountId: string}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof approveBankAccount>>, TError,{bankAccountId: string}, TContext> => {

const mutationKey = ['approveBankAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveBankAccount>>, {bankAccountId: string}> = (props) => {
          const {bankAccountId} = props ?? {};

          return  approveBankAccount(bankAccountId,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof approveBankAccount>>, variables: {bankAccountId: string}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getFindAllCompaniesQueryKey() });
    queryClient.invalidateQueries({ queryKey: getFindAllArtistsQueryKey() });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type ApproveBankAccountMutationResult = NonNullable<Awaited<ReturnType<typeof approveBankAccount>>>

    export type ApproveBankAccountMutationError = ErrorType<unknown>

    /**
 * @summary Approve Artist Bank Account
 */
export const useApproveBankAccount = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveBankAccount>>, TError,{bankAccountId: string}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approveBankAccount>>,
        TError,
        {bankAccountId: string},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getApproveBankAccountMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * @summary Get Events
 */
export const findAllEvents = (
    params?: FindAllEventsParams,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<FindAllEventsResponseType>(
      {url: `/dashboard-service-v1/events`, method: 'GET',
        params
    },
      options);
    }




export const getFindAllEventsQueryKey = (params?: FindAllEventsParams,) => {
    return [
    'dashboard-service-v1','events', ...(params ? [params] : [])
    ] as const;
    }


export const getFindAllEventsQueryOptions = <TData = Awaited<ReturnType<typeof findAllEvents>>, TError = ErrorType<unknown>>(params?: FindAllEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllEvents>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllEventsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllEvents>>> = () => findAllEvents(params, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findAllEvents>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllEventsQueryResult = NonNullable<Awaited<ReturnType<typeof findAllEvents>>>
export type FindAllEventsQueryError = ErrorType<unknown>


export function useFindAllEvents<TData = Awaited<ReturnType<typeof findAllEvents>>, TError = ErrorType<unknown>>(
 params: undefined |  FindAllEventsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllEvents>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllEvents>>,
          TError,
          Awaited<ReturnType<typeof findAllEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllEvents<TData = Awaited<ReturnType<typeof findAllEvents>>, TError = ErrorType<unknown>>(
 params?: FindAllEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllEvents>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllEvents>>,
          TError,
          Awaited<ReturnType<typeof findAllEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllEvents<TData = Awaited<ReturnType<typeof findAllEvents>>, TError = ErrorType<unknown>>(
 params?: FindAllEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllEvents>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Events
 */

export function useFindAllEvents<TData = Awaited<ReturnType<typeof findAllEvents>>, TError = ErrorType<unknown>>(
 params?: FindAllEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllEvents>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllEventsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindAllEventsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findAllEvents>>, TError = ErrorType<unknown>>(params?: FindAllEventsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllEvents>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllEventsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllEvents>>> = () => findAllEvents(params, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllEvents>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllEventsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findAllEvents>>>
export type FindAllEventsSuspenseQueryError = ErrorType<unknown>


export function useFindAllEventsSuspense<TData = Awaited<ReturnType<typeof findAllEvents>>, TError = ErrorType<unknown>>(
 params: undefined |  FindAllEventsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllEvents>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllEventsSuspense<TData = Awaited<ReturnType<typeof findAllEvents>>, TError = ErrorType<unknown>>(
 params?: FindAllEventsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllEvents>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllEventsSuspense<TData = Awaited<ReturnType<typeof findAllEvents>>, TError = ErrorType<unknown>>(
 params?: FindAllEventsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllEvents>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Events
 */

export function useFindAllEventsSuspense<TData = Awaited<ReturnType<typeof findAllEvents>>, TError = ErrorType<unknown>>(
 params?: FindAllEventsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllEvents>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllEventsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Get AST Favorites
 */
export const findAllASTFavorites = (
    params: FindAllASTFavoritesParams,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<FindAllASTFavoritesResponseType>(
      {url: `/ast-service-v1/favorites`, method: 'GET',
        params
    },
      options);
    }




export const getFindAllASTFavoritesQueryKey = (params?: FindAllASTFavoritesParams,) => {
    return [
    'ast-service-v1','favorites', ...(params ? [params] : [])
    ] as const;
    }


export const getFindAllASTFavoritesQueryOptions = <TData = Awaited<ReturnType<typeof findAllASTFavorites>>, TError = ErrorType<unknown>>(params: FindAllASTFavoritesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllASTFavorites>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllASTFavoritesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllASTFavorites>>> = () => findAllASTFavorites(params, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findAllASTFavorites>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllASTFavoritesQueryResult = NonNullable<Awaited<ReturnType<typeof findAllASTFavorites>>>
export type FindAllASTFavoritesQueryError = ErrorType<unknown>


export function useFindAllASTFavorites<TData = Awaited<ReturnType<typeof findAllASTFavorites>>, TError = ErrorType<unknown>>(
 params: FindAllASTFavoritesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllASTFavorites>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllASTFavorites>>,
          TError,
          Awaited<ReturnType<typeof findAllASTFavorites>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllASTFavorites<TData = Awaited<ReturnType<typeof findAllASTFavorites>>, TError = ErrorType<unknown>>(
 params: FindAllASTFavoritesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllASTFavorites>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllASTFavorites>>,
          TError,
          Awaited<ReturnType<typeof findAllASTFavorites>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllASTFavorites<TData = Awaited<ReturnType<typeof findAllASTFavorites>>, TError = ErrorType<unknown>>(
 params: FindAllASTFavoritesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllASTFavorites>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get AST Favorites
 */

export function useFindAllASTFavorites<TData = Awaited<ReturnType<typeof findAllASTFavorites>>, TError = ErrorType<unknown>>(
 params: FindAllASTFavoritesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllASTFavorites>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllASTFavoritesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindAllASTFavoritesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findAllASTFavorites>>, TError = ErrorType<unknown>>(params: FindAllASTFavoritesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllASTFavorites>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllASTFavoritesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllASTFavorites>>> = () => findAllASTFavorites(params, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllASTFavorites>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllASTFavoritesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findAllASTFavorites>>>
export type FindAllASTFavoritesSuspenseQueryError = ErrorType<unknown>


export function useFindAllASTFavoritesSuspense<TData = Awaited<ReturnType<typeof findAllASTFavorites>>, TError = ErrorType<unknown>>(
 params: FindAllASTFavoritesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllASTFavorites>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllASTFavoritesSuspense<TData = Awaited<ReturnType<typeof findAllASTFavorites>>, TError = ErrorType<unknown>>(
 params: FindAllASTFavoritesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllASTFavorites>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllASTFavoritesSuspense<TData = Awaited<ReturnType<typeof findAllASTFavorites>>, TError = ErrorType<unknown>>(
 params: FindAllASTFavoritesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllASTFavorites>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get AST Favorites
 */

export function useFindAllASTFavoritesSuspense<TData = Awaited<ReturnType<typeof findAllASTFavorites>>, TError = ErrorType<unknown>>(
 params: FindAllASTFavoritesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllASTFavorites>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllASTFavoritesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Create AST Favorite
 */
export const createASTFavorite = (
    createASTFavoriteRequestType: BodyType<CreateASTFavoriteRequestType>,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<CreateASTFavorite200>(
      {url: `/ast-service-v1/favorites`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createASTFavoriteRequestType
    },
      options);
    }



export const getCreateASTFavoriteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createASTFavorite>>, TError,{data: BodyType<CreateASTFavoriteRequestType>}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createASTFavorite>>, TError,{data: BodyType<CreateASTFavoriteRequestType>}, TContext> => {

const mutationKey = ['createASTFavorite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createASTFavorite>>, {data: BodyType<CreateASTFavoriteRequestType>}> = (props) => {
          const {data} = props ?? {};

          return  createASTFavorite(data,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof createASTFavorite>>, variables: {data: BodyType<CreateASTFavoriteRequestType>}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getFindAllASTFavoritesQueryKey() });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type CreateASTFavoriteMutationResult = NonNullable<Awaited<ReturnType<typeof createASTFavorite>>>
    export type CreateASTFavoriteMutationBody = BodyType<CreateASTFavoriteRequestType>
    export type CreateASTFavoriteMutationError = ErrorType<unknown>

    /**
 * @summary Create AST Favorite
 */
export const useCreateASTFavorite = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createASTFavorite>>, TError,{data: BodyType<CreateASTFavoriteRequestType>}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createASTFavorite>>,
        TError,
        {data: BodyType<CreateASTFavoriteRequestType>},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getCreateASTFavoriteMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * @summary Delete AST Favorite
 */
export const deleteASTFavorite = (
    astFavoriteId: string,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<DeleteASTFavorite200>(
      {url: `/ast-service-v1/favorites/${astFavoriteId}`, method: 'DELETE'
    },
      options);
    }



export const getDeleteASTFavoriteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteASTFavorite>>, TError,{astFavoriteId: string}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteASTFavorite>>, TError,{astFavoriteId: string}, TContext> => {

const mutationKey = ['deleteASTFavorite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteASTFavorite>>, {astFavoriteId: string}> = (props) => {
          const {astFavoriteId} = props ?? {};

          return  deleteASTFavorite(astFavoriteId,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof deleteASTFavorite>>, variables: {astFavoriteId: string}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getFindAllASTFavoritesQueryKey() });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type DeleteASTFavoriteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteASTFavorite>>>

    export type DeleteASTFavoriteMutationError = ErrorType<unknown>

    /**
 * @summary Delete AST Favorite
 */
export const useDeleteASTFavorite = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteASTFavorite>>, TError,{astFavoriteId: string}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteASTFavorite>>,
        TError,
        {astFavoriteId: string},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getDeleteASTFavoriteMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * @summary Get AST Entities
 */
export const findAllTicketSalesASTEntities = (
    params: FindAllTicketSalesASTEntitiesParams,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<FindAllASTEntitiesResponseType>(
      {url: `/ast-service-v1/entities`, method: 'GET',
        params
    },
      options);
    }




export const getFindAllTicketSalesASTEntitiesQueryKey = (params?: FindAllTicketSalesASTEntitiesParams,) => {
    return [
    'ast-service-v1','entities', ...(params ? [params] : [])
    ] as const;
    }


export const getFindAllTicketSalesASTEntitiesQueryOptions = <TData = Awaited<ReturnType<typeof findAllTicketSalesASTEntities>>, TError = ErrorType<unknown>>(params: FindAllTicketSalesASTEntitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllTicketSalesASTEntities>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllTicketSalesASTEntitiesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllTicketSalesASTEntities>>> = () => findAllTicketSalesASTEntities(params, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findAllTicketSalesASTEntities>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllTicketSalesASTEntitiesQueryResult = NonNullable<Awaited<ReturnType<typeof findAllTicketSalesASTEntities>>>
export type FindAllTicketSalesASTEntitiesQueryError = ErrorType<unknown>


export function useFindAllTicketSalesASTEntities<TData = Awaited<ReturnType<typeof findAllTicketSalesASTEntities>>, TError = ErrorType<unknown>>(
 params: FindAllTicketSalesASTEntitiesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllTicketSalesASTEntities>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllTicketSalesASTEntities>>,
          TError,
          Awaited<ReturnType<typeof findAllTicketSalesASTEntities>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllTicketSalesASTEntities<TData = Awaited<ReturnType<typeof findAllTicketSalesASTEntities>>, TError = ErrorType<unknown>>(
 params: FindAllTicketSalesASTEntitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllTicketSalesASTEntities>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllTicketSalesASTEntities>>,
          TError,
          Awaited<ReturnType<typeof findAllTicketSalesASTEntities>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllTicketSalesASTEntities<TData = Awaited<ReturnType<typeof findAllTicketSalesASTEntities>>, TError = ErrorType<unknown>>(
 params: FindAllTicketSalesASTEntitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllTicketSalesASTEntities>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get AST Entities
 */

export function useFindAllTicketSalesASTEntities<TData = Awaited<ReturnType<typeof findAllTicketSalesASTEntities>>, TError = ErrorType<unknown>>(
 params: FindAllTicketSalesASTEntitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllTicketSalesASTEntities>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllTicketSalesASTEntitiesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindAllTicketSalesASTEntitiesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findAllTicketSalesASTEntities>>, TError = ErrorType<unknown>>(params: FindAllTicketSalesASTEntitiesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllTicketSalesASTEntities>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllTicketSalesASTEntitiesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllTicketSalesASTEntities>>> = () => findAllTicketSalesASTEntities(params, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllTicketSalesASTEntities>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllTicketSalesASTEntitiesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findAllTicketSalesASTEntities>>>
export type FindAllTicketSalesASTEntitiesSuspenseQueryError = ErrorType<unknown>


export function useFindAllTicketSalesASTEntitiesSuspense<TData = Awaited<ReturnType<typeof findAllTicketSalesASTEntities>>, TError = ErrorType<unknown>>(
 params: FindAllTicketSalesASTEntitiesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllTicketSalesASTEntities>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllTicketSalesASTEntitiesSuspense<TData = Awaited<ReturnType<typeof findAllTicketSalesASTEntities>>, TError = ErrorType<unknown>>(
 params: FindAllTicketSalesASTEntitiesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllTicketSalesASTEntities>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllTicketSalesASTEntitiesSuspense<TData = Awaited<ReturnType<typeof findAllTicketSalesASTEntities>>, TError = ErrorType<unknown>>(
 params: FindAllTicketSalesASTEntitiesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllTicketSalesASTEntities>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get AST Entities
 */

export function useFindAllTicketSalesASTEntitiesSuspense<TData = Awaited<ReturnType<typeof findAllTicketSalesASTEntities>>, TError = ErrorType<unknown>>(
 params: FindAllTicketSalesASTEntitiesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllTicketSalesASTEntities>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllTicketSalesASTEntitiesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Get AST Entity Values
 */
export const findAllTicketSalesASTEntityValues = (
    entityId: string,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<FindAllASTEntityValuesResponseType>(
      {url: `/ast-service-v1/ast-entities/${entityId}`, method: 'GET'
    },
      options);
    }




export const getFindAllTicketSalesASTEntityValuesQueryKey = (entityId: string,) => {
    return [
    'ast-service-v1','ast-entities',entityId
    ] as const;
    }


export const getFindAllTicketSalesASTEntityValuesQueryOptions = <TData = Awaited<ReturnType<typeof findAllTicketSalesASTEntityValues>>, TError = ErrorType<unknown>>(entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllTicketSalesASTEntityValues>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllTicketSalesASTEntityValuesQueryKey(entityId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllTicketSalesASTEntityValues>>> = () => findAllTicketSalesASTEntityValues(entityId, requestOptions);





   return  { queryKey, queryFn, enabled: entityId !== null && entityId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findAllTicketSalesASTEntityValues>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllTicketSalesASTEntityValuesQueryResult = NonNullable<Awaited<ReturnType<typeof findAllTicketSalesASTEntityValues>>>
export type FindAllTicketSalesASTEntityValuesQueryError = ErrorType<unknown>


export function useFindAllTicketSalesASTEntityValues<TData = Awaited<ReturnType<typeof findAllTicketSalesASTEntityValues>>, TError = ErrorType<unknown>>(
 entityId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllTicketSalesASTEntityValues>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllTicketSalesASTEntityValues>>,
          TError,
          Awaited<ReturnType<typeof findAllTicketSalesASTEntityValues>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllTicketSalesASTEntityValues<TData = Awaited<ReturnType<typeof findAllTicketSalesASTEntityValues>>, TError = ErrorType<unknown>>(
 entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllTicketSalesASTEntityValues>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllTicketSalesASTEntityValues>>,
          TError,
          Awaited<ReturnType<typeof findAllTicketSalesASTEntityValues>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllTicketSalesASTEntityValues<TData = Awaited<ReturnType<typeof findAllTicketSalesASTEntityValues>>, TError = ErrorType<unknown>>(
 entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllTicketSalesASTEntityValues>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get AST Entity Values
 */

export function useFindAllTicketSalesASTEntityValues<TData = Awaited<ReturnType<typeof findAllTicketSalesASTEntityValues>>, TError = ErrorType<unknown>>(
 entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllTicketSalesASTEntityValues>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllTicketSalesASTEntityValuesQueryOptions(entityId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindAllTicketSalesASTEntityValuesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findAllTicketSalesASTEntityValues>>, TError = ErrorType<unknown>>(entityId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllTicketSalesASTEntityValues>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllTicketSalesASTEntityValuesQueryKey(entityId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllTicketSalesASTEntityValues>>> = () => findAllTicketSalesASTEntityValues(entityId, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllTicketSalesASTEntityValues>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllTicketSalesASTEntityValuesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findAllTicketSalesASTEntityValues>>>
export type FindAllTicketSalesASTEntityValuesSuspenseQueryError = ErrorType<unknown>


export function useFindAllTicketSalesASTEntityValuesSuspense<TData = Awaited<ReturnType<typeof findAllTicketSalesASTEntityValues>>, TError = ErrorType<unknown>>(
 entityId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllTicketSalesASTEntityValues>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllTicketSalesASTEntityValuesSuspense<TData = Awaited<ReturnType<typeof findAllTicketSalesASTEntityValues>>, TError = ErrorType<unknown>>(
 entityId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllTicketSalesASTEntityValues>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllTicketSalesASTEntityValuesSuspense<TData = Awaited<ReturnType<typeof findAllTicketSalesASTEntityValues>>, TError = ErrorType<unknown>>(
 entityId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllTicketSalesASTEntityValues>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get AST Entity Values
 */

export function useFindAllTicketSalesASTEntityValuesSuspense<TData = Awaited<ReturnType<typeof findAllTicketSalesASTEntityValues>>, TError = ErrorType<unknown>>(
 entityId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllTicketSalesASTEntityValues>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllTicketSalesASTEntityValuesSuspenseQueryOptions(entityId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Create saved AST
 */
export const createSavedAST = (
    createSavedASTRequestType: BodyType<CreateSavedASTRequestType>,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<CreateSavedASTResponseType>(
      {url: `/ast-service-v1/saved-asts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createSavedASTRequestType
    },
      options);
    }



export const getCreateSavedASTMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSavedAST>>, TError,{data: BodyType<CreateSavedASTRequestType>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createSavedAST>>, TError,{data: BodyType<CreateSavedASTRequestType>}, TContext> => {

const mutationKey = ['createSavedAST'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSavedAST>>, {data: BodyType<CreateSavedASTRequestType>}> = (props) => {
          const {data} = props ?? {};

          return  createSavedAST(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSavedASTMutationResult = NonNullable<Awaited<ReturnType<typeof createSavedAST>>>
    export type CreateSavedASTMutationBody = BodyType<CreateSavedASTRequestType>
    export type CreateSavedASTMutationError = ErrorType<unknown>

    /**
 * @summary Create saved AST
 */
export const useCreateSavedAST = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSavedAST>>, TError,{data: BodyType<CreateSavedASTRequestType>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createSavedAST>>,
        TError,
        {data: BodyType<CreateSavedASTRequestType>},
        TContext
      > => {
      return useMutation(getCreateSavedASTMutationOptions(options), queryClient);
    }

/**
 * @summary Get Saved AST
 */
export const findSavedAST = (
    id: string,
    params: FindSavedASTParams,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<FindSavedASTResponseType>(
      {url: `/ast-service-v1/saved-asts/${id}`, method: 'GET',
        params
    },
      options);
    }




export const getFindSavedASTQueryKey = (id: string,
    params?: FindSavedASTParams,) => {
    return [
    'ast-service-v1','saved-asts',id, ...(params ? [params] : [])
    ] as const;
    }


export const getFindSavedASTQueryOptions = <TData = Awaited<ReturnType<typeof findSavedAST>>, TError = ErrorType<unknown>>(id: string,
    params: FindSavedASTParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findSavedAST>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindSavedASTQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findSavedAST>>> = () => findSavedAST(id,params, requestOptions);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findSavedAST>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindSavedASTQueryResult = NonNullable<Awaited<ReturnType<typeof findSavedAST>>>
export type FindSavedASTQueryError = ErrorType<unknown>


export function useFindSavedAST<TData = Awaited<ReturnType<typeof findSavedAST>>, TError = ErrorType<unknown>>(
 id: string,
    params: FindSavedASTParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findSavedAST>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findSavedAST>>,
          TError,
          Awaited<ReturnType<typeof findSavedAST>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindSavedAST<TData = Awaited<ReturnType<typeof findSavedAST>>, TError = ErrorType<unknown>>(
 id: string,
    params: FindSavedASTParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findSavedAST>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findSavedAST>>,
          TError,
          Awaited<ReturnType<typeof findSavedAST>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindSavedAST<TData = Awaited<ReturnType<typeof findSavedAST>>, TError = ErrorType<unknown>>(
 id: string,
    params: FindSavedASTParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findSavedAST>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Saved AST
 */

export function useFindSavedAST<TData = Awaited<ReturnType<typeof findSavedAST>>, TError = ErrorType<unknown>>(
 id: string,
    params: FindSavedASTParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findSavedAST>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindSavedASTQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindSavedASTSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findSavedAST>>, TError = ErrorType<unknown>>(id: string,
    params: FindSavedASTParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSavedAST>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindSavedASTQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findSavedAST>>> = () => findSavedAST(id,params, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSavedAST>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindSavedASTSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findSavedAST>>>
export type FindSavedASTSuspenseQueryError = ErrorType<unknown>


export function useFindSavedASTSuspense<TData = Awaited<ReturnType<typeof findSavedAST>>, TError = ErrorType<unknown>>(
 id: string,
    params: FindSavedASTParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSavedAST>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindSavedASTSuspense<TData = Awaited<ReturnType<typeof findSavedAST>>, TError = ErrorType<unknown>>(
 id: string,
    params: FindSavedASTParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSavedAST>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindSavedASTSuspense<TData = Awaited<ReturnType<typeof findSavedAST>>, TError = ErrorType<unknown>>(
 id: string,
    params: FindSavedASTParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSavedAST>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Saved AST
 */

export function useFindSavedASTSuspense<TData = Awaited<ReturnType<typeof findSavedAST>>, TError = ErrorType<unknown>>(
 id: string,
    params: FindSavedASTParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSavedAST>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindSavedASTSuspenseQueryOptions(id,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Get Ticket Sales
 */
export const findAllTicketSales = (
    findAllTicketSalesRequestType: BodyType<FindAllTicketSalesRequestType>,
    params?: FindAllTicketSalesParams,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<FindAllTicketSalesResponseType>(
      {url: `/ticket-sales-service-v1/ticket-sales`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: findAllTicketSalesRequestType,
        params
    },
      options);
    }




export const getFindAllTicketSalesQueryKey = (findAllTicketSalesRequestType?: BodyType<FindAllTicketSalesRequestType>,
    params?: FindAllTicketSalesParams,) => {
    return [
    'POST', 'ticket-sales-service-v1','ticket-sales', ...(params ? [params] : []), findAllTicketSalesRequestType
    ] as const;
    }


export const getFindAllTicketSalesQueryOptions = <TData = Awaited<ReturnType<typeof findAllTicketSales>>, TError = ErrorType<unknown>>(findAllTicketSalesRequestType: BodyType<FindAllTicketSalesRequestType>,
    params?: FindAllTicketSalesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllTicketSales>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllTicketSalesQueryKey(findAllTicketSalesRequestType,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllTicketSales>>> = () => findAllTicketSales(findAllTicketSalesRequestType,params, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findAllTicketSales>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllTicketSalesQueryResult = NonNullable<Awaited<ReturnType<typeof findAllTicketSales>>>
export type FindAllTicketSalesQueryError = ErrorType<unknown>


export function useFindAllTicketSales<TData = Awaited<ReturnType<typeof findAllTicketSales>>, TError = ErrorType<unknown>>(
 findAllTicketSalesRequestType: BodyType<FindAllTicketSalesRequestType>,
    params: undefined |  FindAllTicketSalesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllTicketSales>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllTicketSales>>,
          TError,
          Awaited<ReturnType<typeof findAllTicketSales>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllTicketSales<TData = Awaited<ReturnType<typeof findAllTicketSales>>, TError = ErrorType<unknown>>(
 findAllTicketSalesRequestType: BodyType<FindAllTicketSalesRequestType>,
    params?: FindAllTicketSalesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllTicketSales>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllTicketSales>>,
          TError,
          Awaited<ReturnType<typeof findAllTicketSales>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllTicketSales<TData = Awaited<ReturnType<typeof findAllTicketSales>>, TError = ErrorType<unknown>>(
 findAllTicketSalesRequestType: BodyType<FindAllTicketSalesRequestType>,
    params?: FindAllTicketSalesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllTicketSales>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Ticket Sales
 */

export function useFindAllTicketSales<TData = Awaited<ReturnType<typeof findAllTicketSales>>, TError = ErrorType<unknown>>(
 findAllTicketSalesRequestType: BodyType<FindAllTicketSalesRequestType>,
    params?: FindAllTicketSalesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllTicketSales>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllTicketSalesQueryOptions(findAllTicketSalesRequestType,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindAllTicketSalesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findAllTicketSales>>, TError = ErrorType<unknown>>(findAllTicketSalesRequestType: BodyType<FindAllTicketSalesRequestType>,
    params?: FindAllTicketSalesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllTicketSales>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllTicketSalesQueryKey(findAllTicketSalesRequestType,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllTicketSales>>> = () => findAllTicketSales(findAllTicketSalesRequestType,params, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllTicketSales>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllTicketSalesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findAllTicketSales>>>
export type FindAllTicketSalesSuspenseQueryError = ErrorType<unknown>


export function useFindAllTicketSalesSuspense<TData = Awaited<ReturnType<typeof findAllTicketSales>>, TError = ErrorType<unknown>>(
 findAllTicketSalesRequestType: BodyType<FindAllTicketSalesRequestType>,
    params: undefined |  FindAllTicketSalesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllTicketSales>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllTicketSalesSuspense<TData = Awaited<ReturnType<typeof findAllTicketSales>>, TError = ErrorType<unknown>>(
 findAllTicketSalesRequestType: BodyType<FindAllTicketSalesRequestType>,
    params?: FindAllTicketSalesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllTicketSales>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllTicketSalesSuspense<TData = Awaited<ReturnType<typeof findAllTicketSales>>, TError = ErrorType<unknown>>(
 findAllTicketSalesRequestType: BodyType<FindAllTicketSalesRequestType>,
    params?: FindAllTicketSalesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllTicketSales>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Ticket Sales
 */

export function useFindAllTicketSalesSuspense<TData = Awaited<ReturnType<typeof findAllTicketSales>>, TError = ErrorType<unknown>>(
 findAllTicketSalesRequestType: BodyType<FindAllTicketSalesRequestType>,
    params?: FindAllTicketSalesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllTicketSales>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllTicketSalesSuspenseQueryOptions(findAllTicketSalesRequestType,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Update Ticket Sales Copy
 */
export const updateTicketSales = (
    id: string,
    updateTicketSalesRequestType: BodyType<UpdateTicketSalesRequestType>,
    params?: UpdateTicketSalesParams,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<UpdateTicketSales200>(
      {url: `/ticket-sales-service-v1/ticket-sales/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateTicketSalesRequestType,
        params
    },
      options);
    }



export const getUpdateTicketSalesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTicketSales>>, TError,{id: string;data: BodyType<UpdateTicketSalesRequestType>;params?: UpdateTicketSalesParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTicketSales>>, TError,{id: string;data: BodyType<UpdateTicketSalesRequestType>;params?: UpdateTicketSalesParams}, TContext> => {

const mutationKey = ['updateTicketSales'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTicketSales>>, {id: string;data: BodyType<UpdateTicketSalesRequestType>;params?: UpdateTicketSalesParams}> = (props) => {
          const {id,data,params} = props ?? {};

          return  updateTicketSales(id,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTicketSalesMutationResult = NonNullable<Awaited<ReturnType<typeof updateTicketSales>>>
    export type UpdateTicketSalesMutationBody = BodyType<UpdateTicketSalesRequestType>
    export type UpdateTicketSalesMutationError = ErrorType<unknown>

    /**
 * @summary Update Ticket Sales Copy
 */
export const useUpdateTicketSales = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTicketSales>>, TError,{id: string;data: BodyType<UpdateTicketSalesRequestType>;params?: UpdateTicketSalesParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateTicketSales>>,
        TError,
        {id: string;data: BodyType<UpdateTicketSalesRequestType>;params?: UpdateTicketSalesParams},
        TContext
      > => {
      return useMutation(getUpdateTicketSalesMutationOptions(options), queryClient);
    }

/**
 * @summary Get Task List Items
 */
export const findAllTaskListItems = (

 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<FindAllTaskListItemsResponseType>(
      {url: `/task-service-v1/tasks-list-items`, method: 'GET'
    },
      options);
    }




export const getFindAllTaskListItemsQueryKey = () => {
    return [
    'task-service-v1','tasks-list-items'
    ] as const;
    }


export const getFindAllTaskListItemsQueryOptions = <TData = Awaited<ReturnType<typeof findAllTaskListItems>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllTaskListItems>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllTaskListItemsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllTaskListItems>>> = () => findAllTaskListItems(requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findAllTaskListItems>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllTaskListItemsQueryResult = NonNullable<Awaited<ReturnType<typeof findAllTaskListItems>>>
export type FindAllTaskListItemsQueryError = ErrorType<unknown>


export function useFindAllTaskListItems<TData = Awaited<ReturnType<typeof findAllTaskListItems>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllTaskListItems>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllTaskListItems>>,
          TError,
          Awaited<ReturnType<typeof findAllTaskListItems>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllTaskListItems<TData = Awaited<ReturnType<typeof findAllTaskListItems>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllTaskListItems>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllTaskListItems>>,
          TError,
          Awaited<ReturnType<typeof findAllTaskListItems>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllTaskListItems<TData = Awaited<ReturnType<typeof findAllTaskListItems>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllTaskListItems>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Task List Items
 */

export function useFindAllTaskListItems<TData = Awaited<ReturnType<typeof findAllTaskListItems>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllTaskListItems>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllTaskListItemsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindAllTaskListItemsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findAllTaskListItems>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllTaskListItems>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllTaskListItemsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllTaskListItems>>> = () => findAllTaskListItems(requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllTaskListItems>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllTaskListItemsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findAllTaskListItems>>>
export type FindAllTaskListItemsSuspenseQueryError = ErrorType<unknown>


export function useFindAllTaskListItemsSuspense<TData = Awaited<ReturnType<typeof findAllTaskListItems>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllTaskListItems>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllTaskListItemsSuspense<TData = Awaited<ReturnType<typeof findAllTaskListItems>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllTaskListItems>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllTaskListItemsSuspense<TData = Awaited<ReturnType<typeof findAllTaskListItems>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllTaskListItems>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Task List Items
 */

export function useFindAllTaskListItemsSuspense<TData = Awaited<ReturnType<typeof findAllTaskListItems>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllTaskListItems>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllTaskListItemsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Update Task
 */
export const updateTask = (
    taskId: string,
    updateTaskType?: BodyType<UpdateTaskType>,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<UpdateTaskResponseType>(
      {url: `/task-service-v1/tasks/${taskId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateTaskType
    },
      options);
    }



export const getUpdateTaskMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTask>>, TError,{taskId: string;data?: BodyType<UpdateTaskType>}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTask>>, TError,{taskId: string;data?: BodyType<UpdateTaskType>}, TContext> => {

const mutationKey = ['updateTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTask>>, {taskId: string;data?: BodyType<UpdateTaskType>}> = (props) => {
          const {taskId,data} = props ?? {};

          return  updateTask(taskId,data,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof updateTask>>, variables: {taskId: string;data?: BodyType<UpdateTaskType>}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getFindAllTasksQueryKey() });
    queryClient.invalidateQueries({ queryKey: getFindAllTaskListItemsQueryKey() });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type UpdateTaskMutationResult = NonNullable<Awaited<ReturnType<typeof updateTask>>>
    export type UpdateTaskMutationBody = BodyType<UpdateTaskType> | undefined
    export type UpdateTaskMutationError = ErrorType<unknown>

    /**
 * @summary Update Task
 */
export const useUpdateTask = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTask>>, TError,{taskId: string;data?: BodyType<UpdateTaskType>}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateTask>>,
        TError,
        {taskId: string;data?: BodyType<UpdateTaskType>},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getUpdateTaskMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * @summary Claim Task
 */
export const claimTask = (
    taskId: string,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<ClaimTaskResponseType>(
      {url: `/task-service-v1/tasks/${taskId}/claim`, method: 'POST'
    },
      options);
    }



export const getClaimTaskMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof claimTask>>, TError,{taskId: string}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof claimTask>>, TError,{taskId: string}, TContext> => {

const mutationKey = ['claimTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof claimTask>>, {taskId: string}> = (props) => {
          const {taskId} = props ?? {};

          return  claimTask(taskId,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof claimTask>>, variables: {taskId: string}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getFindAllTasksQueryKey() });
    queryClient.invalidateQueries({ queryKey: getFindAllTaskListItemsQueryKey() });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type ClaimTaskMutationResult = NonNullable<Awaited<ReturnType<typeof claimTask>>>

    export type ClaimTaskMutationError = ErrorType<unknown>

    /**
 * @summary Claim Task
 */
export const useClaimTask = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof claimTask>>, TError,{taskId: string}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof claimTask>>,
        TError,
        {taskId: string},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getClaimTaskMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * @summary Create Task
 */
export const createTask = (
    createTaskType: BodyType<CreateTaskType>,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<CreateTaskResponseType>(
      {url: `/task-service-v1/tasks`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createTaskType
    },
      options);
    }



export const getCreateTaskMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTask>>, TError,{data: BodyType<CreateTaskType>}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createTask>>, TError,{data: BodyType<CreateTaskType>}, TContext> => {

const mutationKey = ['createTask'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTask>>, {data: BodyType<CreateTaskType>}> = (props) => {
          const {data} = props ?? {};

          return  createTask(data,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof createTask>>, variables: {data: BodyType<CreateTaskType>}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getFindAllTasksQueryKey() });
    queryClient.invalidateQueries({ queryKey: getFindAllTaskListItemsQueryKey() });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type CreateTaskMutationResult = NonNullable<Awaited<ReturnType<typeof createTask>>>
    export type CreateTaskMutationBody = BodyType<CreateTaskType>
    export type CreateTaskMutationError = ErrorType<unknown>

    /**
 * @summary Create Task
 */
export const useCreateTask = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTask>>, TError,{data: BodyType<CreateTaskType>}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createTask>>,
        TError,
        {data: BodyType<CreateTaskType>},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getCreateTaskMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * @summary Get Tasks
 */
export const findAllTasks = (
    params?: FindAllTasksParams,
 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<FindAllTasksResponseType>(
      {url: `/task-service-v1/tasks`, method: 'GET',
        params
    },
      options);
    }




export const getFindAllTasksQueryKey = (params?: FindAllTasksParams,) => {
    return [
    'task-service-v1','tasks', ...(params ? [params] : [])
    ] as const;
    }


export const getFindAllTasksQueryOptions = <TData = Awaited<ReturnType<typeof findAllTasks>>, TError = ErrorType<unknown>>(params?: FindAllTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllTasks>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllTasksQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllTasks>>> = () => findAllTasks(params, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findAllTasks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllTasksQueryResult = NonNullable<Awaited<ReturnType<typeof findAllTasks>>>
export type FindAllTasksQueryError = ErrorType<unknown>


export function useFindAllTasks<TData = Awaited<ReturnType<typeof findAllTasks>>, TError = ErrorType<unknown>>(
 params: undefined |  FindAllTasksParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllTasks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllTasks>>,
          TError,
          Awaited<ReturnType<typeof findAllTasks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllTasks<TData = Awaited<ReturnType<typeof findAllTasks>>, TError = ErrorType<unknown>>(
 params?: FindAllTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllTasks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findAllTasks>>,
          TError,
          Awaited<ReturnType<typeof findAllTasks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllTasks<TData = Awaited<ReturnType<typeof findAllTasks>>, TError = ErrorType<unknown>>(
 params?: FindAllTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllTasks>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Tasks
 */

export function useFindAllTasks<TData = Awaited<ReturnType<typeof findAllTasks>>, TError = ErrorType<unknown>>(
 params?: FindAllTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findAllTasks>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllTasksQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindAllTasksSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findAllTasks>>, TError = ErrorType<unknown>>(params?: FindAllTasksParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllTasks>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindAllTasksQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findAllTasks>>> = () => findAllTasks(params, requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllTasks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindAllTasksSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findAllTasks>>>
export type FindAllTasksSuspenseQueryError = ErrorType<unknown>


export function useFindAllTasksSuspense<TData = Awaited<ReturnType<typeof findAllTasks>>, TError = ErrorType<unknown>>(
 params: undefined |  FindAllTasksParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllTasks>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllTasksSuspense<TData = Awaited<ReturnType<typeof findAllTasks>>, TError = ErrorType<unknown>>(
 params?: FindAllTasksParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllTasks>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindAllTasksSuspense<TData = Awaited<ReturnType<typeof findAllTasks>>, TError = ErrorType<unknown>>(
 params?: FindAllTasksParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllTasks>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Tasks
 */

export function useFindAllTasksSuspense<TData = Awaited<ReturnType<typeof findAllTasks>>, TError = ErrorType<unknown>>(
 params?: FindAllTasksParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findAllTasks>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindAllTasksSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Get Task Assignable Persons
 */
export const findTaskAssignablePersons = (

 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<GetUsersResponseType>(
      {url: `/task-service-v1/assignable-persons`, method: 'GET'
    },
      options);
    }




export const getFindTaskAssignablePersonsQueryKey = () => {
    return [
    'task-service-v1','assignable-persons'
    ] as const;
    }


export const getFindTaskAssignablePersonsQueryOptions = <TData = Awaited<ReturnType<typeof findTaskAssignablePersons>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findTaskAssignablePersons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindTaskAssignablePersonsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findTaskAssignablePersons>>> = () => findTaskAssignablePersons(requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findTaskAssignablePersons>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindTaskAssignablePersonsQueryResult = NonNullable<Awaited<ReturnType<typeof findTaskAssignablePersons>>>
export type FindTaskAssignablePersonsQueryError = ErrorType<unknown>


export function useFindTaskAssignablePersons<TData = Awaited<ReturnType<typeof findTaskAssignablePersons>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findTaskAssignablePersons>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findTaskAssignablePersons>>,
          TError,
          Awaited<ReturnType<typeof findTaskAssignablePersons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindTaskAssignablePersons<TData = Awaited<ReturnType<typeof findTaskAssignablePersons>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findTaskAssignablePersons>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findTaskAssignablePersons>>,
          TError,
          Awaited<ReturnType<typeof findTaskAssignablePersons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindTaskAssignablePersons<TData = Awaited<ReturnType<typeof findTaskAssignablePersons>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findTaskAssignablePersons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Task Assignable Persons
 */

export function useFindTaskAssignablePersons<TData = Awaited<ReturnType<typeof findTaskAssignablePersons>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findTaskAssignablePersons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindTaskAssignablePersonsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindTaskAssignablePersonsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findTaskAssignablePersons>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findTaskAssignablePersons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindTaskAssignablePersonsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findTaskAssignablePersons>>> = () => findTaskAssignablePersons(requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findTaskAssignablePersons>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindTaskAssignablePersonsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findTaskAssignablePersons>>>
export type FindTaskAssignablePersonsSuspenseQueryError = ErrorType<unknown>


export function useFindTaskAssignablePersonsSuspense<TData = Awaited<ReturnType<typeof findTaskAssignablePersons>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findTaskAssignablePersons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindTaskAssignablePersonsSuspense<TData = Awaited<ReturnType<typeof findTaskAssignablePersons>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findTaskAssignablePersons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindTaskAssignablePersonsSuspense<TData = Awaited<ReturnType<typeof findTaskAssignablePersons>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findTaskAssignablePersons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Task Assignable Persons
 */

export function useFindTaskAssignablePersonsSuspense<TData = Awaited<ReturnType<typeof findTaskAssignablePersons>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findTaskAssignablePersons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindTaskAssignablePersonsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







/**
 * @summary Get Task Assignable Teams
 */
export const findTaskAssignableTeams = (

 options?: SecondParameter<typeof customInstance>,) => {


      return customInstance<GetTeamsResponseType>(
      {url: `/task-service-v1/assignable-teams`, method: 'GET'
    },
      options);
    }




export const getFindTaskAssignableTeamsQueryKey = () => {
    return [
    'task-service-v1','assignable-teams'
    ] as const;
    }


export const getFindTaskAssignableTeamsQueryOptions = <TData = Awaited<ReturnType<typeof findTaskAssignableTeams>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findTaskAssignableTeams>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindTaskAssignableTeamsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findTaskAssignableTeams>>> = () => findTaskAssignableTeams(requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findTaskAssignableTeams>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindTaskAssignableTeamsQueryResult = NonNullable<Awaited<ReturnType<typeof findTaskAssignableTeams>>>
export type FindTaskAssignableTeamsQueryError = ErrorType<unknown>


export function useFindTaskAssignableTeams<TData = Awaited<ReturnType<typeof findTaskAssignableTeams>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findTaskAssignableTeams>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findTaskAssignableTeams>>,
          TError,
          Awaited<ReturnType<typeof findTaskAssignableTeams>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindTaskAssignableTeams<TData = Awaited<ReturnType<typeof findTaskAssignableTeams>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findTaskAssignableTeams>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findTaskAssignableTeams>>,
          TError,
          Awaited<ReturnType<typeof findTaskAssignableTeams>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindTaskAssignableTeams<TData = Awaited<ReturnType<typeof findTaskAssignableTeams>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findTaskAssignableTeams>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Task Assignable Teams
 */

export function useFindTaskAssignableTeams<TData = Awaited<ReturnType<typeof findTaskAssignableTeams>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findTaskAssignableTeams>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindTaskAssignableTeamsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getFindTaskAssignableTeamsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof findTaskAssignableTeams>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findTaskAssignableTeams>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindTaskAssignableTeamsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof findTaskAssignableTeams>>> = () => findTaskAssignableTeams(requestOptions);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof findTaskAssignableTeams>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindTaskAssignableTeamsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof findTaskAssignableTeams>>>
export type FindTaskAssignableTeamsSuspenseQueryError = ErrorType<unknown>


export function useFindTaskAssignableTeamsSuspense<TData = Awaited<ReturnType<typeof findTaskAssignableTeams>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findTaskAssignableTeams>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindTaskAssignableTeamsSuspense<TData = Awaited<ReturnType<typeof findTaskAssignableTeams>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findTaskAssignableTeams>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindTaskAssignableTeamsSuspense<TData = Awaited<ReturnType<typeof findTaskAssignableTeams>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findTaskAssignableTeams>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Task Assignable Teams
 */

export function useFindTaskAssignableTeamsSuspense<TData = Awaited<ReturnType<typeof findTaskAssignableTeams>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof findTaskAssignableTeams>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindTaskAssignableTeamsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}







